(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[862],{

/***/ 6983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.J = void 0;
const recoil_1 = __webpack_require__(53476);
/**
 * Recoil module to persist state to storage
 *
 * @param config Optional configuration object
 * @param config.key Used as key in local storage, defaults to `recoil-persist`
 * @param config.storage Local storage to use, defaults to `localStorage`
 */
const recoilPersist = (config = {}) => {
    if (typeof window === 'undefined') {
        return {
            persistAtom: () => { },
        };
    }
    const { key = 'recoil-persist', storage = localStorage } = config;
    const persistAtom = ({ onSet, node, trigger, setSelf }) => {
        if (trigger === 'get') {
            const state = getState();
            if (typeof state.then === 'function') {
                state.then((s) => {
                    if (s.hasOwnProperty(node.key)) {
                        setSelf(s[node.key]);
                    }
                });
            }
            if (state.hasOwnProperty(node.key)) {
                setSelf(state[node.key]);
            }
        }
        onSet(async (newValue) => {
            const state = getState();
            if (typeof state.then === 'function') {
                state.then((s) => updateState(newValue, s, node.key));
            }
            else {
                updateState(newValue, state, node.key);
            }
        });
    };
    const updateState = (newValue, state, key) => {
        if (newValue !== null &&
            newValue !== undefined &&
            newValue instanceof recoil_1.DefaultValue &&
            state.hasOwnProperty(key)) {
            delete state[key];
        }
        else {
            state[key] = newValue;
        }
        setState(state);
    };
    const getState = () => {
        const toParse = storage.getItem(key);
        if (toParse === null || toParse === undefined) {
            return {};
        }
        if (typeof toParse === 'string') {
            return parseState(toParse);
        }
        if (typeof toParse.then === 'function') {
            return toParse.then(parseState);
        }
        return {};
    };
    const parseState = (state) => {
        if (state === undefined) {
            return {};
        }
        try {
            return JSON.parse(state);
        }
        catch (e) {
            console.error(e);
            return {};
        }
    };
    const setState = (state) => {
        try {
            if (typeof storage.mergeItem === 'function') {
                storage.mergeItem(key, JSON.stringify(state));
            }
            else {
                storage.setItem(key, JSON.stringify(state));
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    return { persistAtom };
};
exports.J = recoilPersist;


/***/ }),

/***/ 65450:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telemedicine/request",
      function () {
        return __webpack_require__(8109);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mD": function() { return /* reexport */ hooks_useRefetchUser; },
  "aF": function() { return /* reexport */ hooks_useUser; }
});

// UNUSED EXPORTS: convertGender, convertPlatform, convertProvider, parseUserRealTime

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/recoil/atoms/common/user.ts
var user = __webpack_require__(3818);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/entities/user/parser/genderConverter.ts

var convertGender = function(gender) {
    switch(gender){
        case gql_schema/* GenderType.Female */.dnx.Female:
            return "female";
        case gql_schema/* GenderType.Male */.dnx.Male:
            return "male";
        default:
            return "none";
    }
};


;// CONCATENATED MODULE: ./src/entities/user/parser/platformConverter.ts

var convertPlatform = function(platform) {
    switch(platform){
        case gql_schema/* PlatformType.Android */.zhv.Android:
            return "Android";
        case gql_schema/* PlatformType.Ios */.zhv.Ios:
            return "iOS";
        case gql_schema/* PlatformType.Web */.zhv.Web:
            return "Web";
        default:
            return "Unknown";
    }
};


;// CONCATENATED MODULE: ./src/entities/user/parser/providerConverter.ts

var convertProvider = function(provider) {
    switch(provider){
        case gql_schema/* ProviderType.Kakao */.lP_.Kakao:
            return "kakao";
        case gql_schema/* ProviderType.Naver */.lP_.Naver:
            return "naver";
        case gql_schema/* ProviderType.Apple */.lP_.Apple:
            return "apple";
        default:
            return "doctornow";
    }
};


// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/entities/user/parser/userParser.ts




var parseUserRealTime = function(data) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var userInfo = data.user;
    var _email, ref8, ref9, ref10, ref11;
    return {
        id: Number(userInfo.userId),
        userId: userInfo.userId,
        email: (_email = userInfo.email) !== null && _email !== void 0 ? _email : undefined,
        name: ((ref = userInfo.detail) === null || ref === void 0 ? void 0 : ref.name) || "",
        phone: ((ref1 = userInfo.detail) === null || ref1 === void 0 ? void 0 : ref1.phone) || "",
        provider: convertProvider((ref8 = (ref2 = userInfo.account.oAuthInfo) === null || ref2 === void 0 ? void 0 : ref2.providerType) !== null && ref8 !== void 0 ? ref8 : undefined),
        deviceId: userInfo.deviceId || "",
        birth: ((ref3 = userInfo.detail) === null || ref3 === void 0 ? void 0 : ref3.birthDate) || "",
        gender: convertGender((ref9 = (ref4 = userInfo.detail) === null || ref4 === void 0 ? void 0 : ref4.gender) !== null && ref9 !== void 0 ? ref9 : undefined),
        isMarketing: userInfo.marketingReceiptAccepted,
        isNotify: userInfo.notificationAllowed,
        pushToken: userInfo.pushToken || "",
        isDoseNotify: (ref10 = (ref5 = userInfo.detail) === null || ref5 === void 0 ? void 0 : ref5.doseNotificationAllowed) !== null && ref10 !== void 0 ? ref10 : false,
        isCertified: userInfo.isVerified,
        isNeedVerificationForDiagnosis: (ref11 = (ref6 = userInfo.detail) === null || ref6 === void 0 ? void 0 : ref6.isNeedVerificationForDiagnosis) !== null && ref11 !== void 0 ? ref11 : false,
        createdAt: dayjs_min_default()(userInfo.createdAt).toISOString(),
        platform: convertPlatform(userInfo.platform),
        username: ((ref7 = userInfo.detail) === null || ref7 === void 0 ? void 0 : ref7.name) || "",
        isContentNotify: userInfo.contentNotificationAllowed,
        isNightlyMarketing: userInfo.nightlyMarketingReceiptAccepted
    };
};


;// CONCATENATED MODULE: ./src/entities/user/parser/index.ts






// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/user/hooks/user.gql.impl.tsx


var UserDocument = "\n    query User {\n  user {\n    accountId\n    deviceId\n    email\n    invitationCode\n    isVerified\n    marketingReceiptAccepted\n    notificationAllowed\n    nightlyMarketingReceiptAccepted\n    contentNotificationAllowed\n    platform\n    pushToken\n    userId\n    createdAt\n    detail {\n      birthDate\n      doseNotificationAllowed\n      gender\n      isForeigner\n      isNeedVerificationForDiagnosis\n      name\n      phone\n      telemedicineEligibleGroupType\n    }\n    account {\n      id\n      loginType\n      role\n      status\n      oAuthInfo {\n        accountId\n        id\n        providerType\n      }\n    }\n  }\n}\n    ";
var useUserQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)(variables === undefined ? [
        "User"
    ] : [
        "User",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(UserDocument, "User", variables), options);
};
useUserQuery.getKey = function(variables) {
    return variables === undefined ? [
        "User"
    ] : [
        "User",
        variables
    ];
};
useUserQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(UserDocument, "User", variables, options);
};

;// CONCATENATED MODULE: ./src/entities/user/hooks/useRefetchUser.ts







var useRefetchUser = function() {
    var setUser = (0,es.useSetRecoilState)(user/* userState */.KL);
    var refetch = useUserQuery({}, {
        select: parseUserRealTime,
        enabled: false,
        useErrorBoundary: false,
        retry: 0
    }).refetch;
    var refetchUser = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        refetch()
                    ];
                case 1:
                    result = _state.sent();
                    if (result.data) {
                        setUser(result.data);
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    }), [
        refetch,
        setUser
    ]);
    return {
        refetchUser: refetchUser
    };
};
/* harmony default export */ var hooks_useRefetchUser = (useRefetchUser);

;// CONCATENATED MODULE: ./src/entities/user/hooks/useUser.ts


var useUser = function(param) {
    var enabled = param.enabled, onSuccess = param.onSuccess, onError = param.onError;
    var data = useUserQuery({}, {
        select: parseUserRealTime,
        useErrorBoundary: false,
        retry: 0,
        enabled: enabled,
        onSuccess: onSuccess,
        onError: onError
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ var hooks_useUser = (useUser);

;// CONCATENATED MODULE: ./src/entities/user/hooks/index.ts




;// CONCATENATED MODULE: ./src/entities/user/index.ts





/***/ }),

/***/ 31310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4415);


var useAuth = function() {
    var token = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilValue)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__/* .tokenState */ .J1);
    return {
        token: token
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 38245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oy": function() { return /* binding */ useSearchKoreaAddressV2Query; },
/* harmony export */   "Yx": function() { return /* binding */ useDoctorReviewMetricQuery; },
/* harmony export */   "dr": function() { return /* binding */ useGetHospitalByIdQuery; },
/* harmony export */   "hh": function() { return /* binding */ useGetAddressByLocationQuery; },
/* harmony export */   "nR": function() { return /* binding */ useGetTotalReviewCountWithAverageRatingByPublicIdQuery; },
/* harmony export */   "xK": function() { return /* binding */ useGetUserAddressesQuery; }
/* harmony export */ });
/* unused harmony exports GetHospitalByIdDocument, DoctorReviewMetricDocument, GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery, GetTotalReviewCountWithAverageRatingByPublicIdDocument, GetAddressByLocationDocument, GetUserAddressesDocument, SearchKoreaAddressV2Document, HospitalExternalPostDocument, useHospitalExternalPostQuery */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var GetHospitalByIdDocument = "\n    query GetHospitalById($publicId: String!) {\n  getHospitalByPublicId(publicId: $publicId) {\n    id\n    name\n    isBookable\n    isTodayBookable\n    partnershipTemplate\n    profileImages {\n      url\n      isRepresentative\n    }\n    badges\n    naverPlaceDetail {\n      hashtags\n      treatmentMenus {\n        treatmentName\n        price\n      }\n    }\n    temporaryHolidaysNotice\n    temporaryHolidays\n    todayDuty {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n      operatingStatus\n    }\n    duties {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n    }\n    departmentsV2 {\n      departmentId\n      departmentName\n    }\n    departmentGroups {\n      averageRating\n      departmentGroupId\n      departmentGroupName\n      departmentGroupIconUrl\n      tags\n    }\n    nonBenefitDiagnosisPrices {\n      middleCategoryName\n      minPrice\n      maxPrice\n    }\n    longitude\n    latitude\n    jibunAddress\n    roadAddress\n    detailAddress\n    directionGuidance\n    parkingInformation\n    isFreeParking\n    tel\n    viewCount\n    introduction\n    regionByDepth {\n      siDoName\n      siGunGuName\n      eupMyeonDongName\n    }\n    treatments {\n      id\n      name\n    }\n    hospitalAdBanners {\n      displayDiscount\n      displayPrice\n      id\n      thumbnailImageUrl\n      title\n      url\n      hospitalId\n    }\n    hospitalSurgeries {\n      surgeryCount\n      surgeryName\n      badges\n      id\n    }\n    doctors {\n      id\n      publicId\n      hospitalId\n      isAbsent\n      name\n      displayName\n      medicineType\n      gender\n      profileImagePath\n      contractType\n      departmentGroups {\n        departmentGroupId\n        departmentGroupName\n        departmentGroupIconUrl\n        averageRating\n      }\n      professionalDepartmentsV2 {\n        departmentId\n        departmentName\n        departmentCode\n      }\n      careers {\n        careerType\n        content\n        id\n      }\n      reviewMetric {\n        averageRating\n        totalCount\n        groupByDiagnosisType {\n          count\n          diagnosisType\n          diagnosisTypeId\n          name\n        }\n        groupByRating {\n          count\n          rating\n        }\n      }\n      partnershipStatus\n    }\n    topRatedDoctorReviews(size: 3) {\n      content\n      createdAt\n      id\n      isPrivate\n      likeCount\n      maskedHolderName\n      rating\n      targetCategoryName\n      title\n      isBlocked\n      isLiked\n      comments {\n        content\n        createdAt\n        id\n        isBlocked\n        reviewCommentHolder {\n          id\n          name\n          profileImageUrl\n        }\n      }\n      reviewContext {\n        reviewReceiver {\n          id\n          name\n        }\n      }\n      tags {\n        id\n        reviewId\n        tag {\n          tagId\n          text\n        }\n        tagId\n      }\n    }\n  }\n}\n    ";
var useGetHospitalByIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetHospitalById",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables), options);
};
useGetHospitalByIdQuery.getKey = function(variables) {
    return [
        "GetHospitalById",
        variables
    ];
};
useGetHospitalByIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables, options);
};
var DoctorReviewMetricDocument = "\n    query DoctorReviewMetric($doctorReviewSearchRequest: DoctorReviewSearchRequestV2Input!) {\n  doctorReviewMetric(doctorReviewSearchRequest: $doctorReviewSearchRequest) {\n    totalCount\n    averageRating\n    groupByRating {\n      count\n      rating\n    }\n    groupByDiagnosisType {\n      diagnosisType\n      diagnosisTypeId\n      name\n      count\n    }\n  }\n}\n    ";
var useDoctorReviewMetricQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "DoctorReviewMetric",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables), options);
};
useDoctorReviewMetricQuery.getKey = function(variables) {
    return [
        "DoctorReviewMetric",
        variables
    ];
};
useDoctorReviewMetricQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables, options);
};
var GetFaceToFaceDiagnosisBookingFormByPublicIdDocument = "\n    query GetFaceToFaceDiagnosisBookingFormByPublicId($publicId: String!) {\n  getFaceToFaceDiagnosisBookingFormByPublicId(publicId: $publicId) {\n    hospital {\n      name\n    }\n    doctor {\n      name\n      medicineType\n    }\n    booking {\n      status\n    }\n    diagnosis {\n      status\n    }\n    bookingId\n    targetDate\n    targetDateDisplayText\n    detailSymptom\n    name\n    registrationNumber\n    address\n    detailAddress\n  }\n}\n    ";
var useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables), options);
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.getKey = function(variables) {
    return [
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ];
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables, options);
};
var GetTotalReviewCountWithAverageRatingByPublicIdDocument = "\n    query GetTotalReviewCountWithAverageRatingByPublicId($publicId: String!) {\n  getTotalReviewCountWithAverageRatingByPublicId(publicId: $publicId) {\n    averageRating\n    totalCount\n  }\n}\n    ";
var useGetTotalReviewCountWithAverageRatingByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables), options);
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.getKey = function(variables) {
    return [
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ];
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables, options);
};
var GetAddressByLocationDocument = "\n    query GetAddressByLocation($longitude: Float!, $latitude: Float!) {\n  getAddressByLocation(longitude: $longitude, latitude: $latitude) {\n    detailAddress\n    jibunAddress\n    roadAddress\n    sido\n    zipCode\n    sigungu\n    dongLi\n  }\n}\n    ";
var useGetAddressByLocationQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetAddressByLocation",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables), options);
};
useGetAddressByLocationQuery.getKey = function(variables) {
    return [
        "GetAddressByLocation",
        variables
    ];
};
useGetAddressByLocationQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables, options);
};
var GetUserAddressesDocument = "\n    query GetUserAddresses {\n  getUserAddresses {\n    userAddressId\n    userId\n    alias\n    roadAddress\n    oldAddress\n    detailAddress\n    addressType\n    location {\n      latitude\n      longitude\n    }\n    zipCode\n    deliveryComment\n    frontDoorPassword\n    isDefault\n  }\n}\n    ";
var useGetUserAddressesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables), options);
};
useGetUserAddressesQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ];
};
useGetUserAddressesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables, options);
};
var SearchKoreaAddressV2Document = "\n    query SearchKoreaAddressV2($request: KoreaAddressSearchRequestV2Input!) {\n  searchKoreaAddressV2(request: $request) {\n    centroidLatitude\n    centroidLongitude\n    displayName\n    regionCode\n    regionName\n  }\n}\n    ";
var useSearchKoreaAddressV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchKoreaAddressV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables), options);
};
useSearchKoreaAddressV2Query.getKey = function(variables) {
    return [
        "SearchKoreaAddressV2",
        variables
    ];
};
useSearchKoreaAddressV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables, options);
};
var HospitalExternalPostDocument = "\n    query HospitalExternalPost($hospitalPublicId: ID!, $size: Int!, $pivotId: Int) {\n  hospitalExternalPost(\n    hospitalPublicId: $hospitalPublicId\n    size: $size\n    pivotId: $pivotId\n  ) {\n    totalCount\n    items {\n      id\n      title\n      content\n      postedAt\n      url\n    }\n  }\n}\n    ";
var useHospitalExternalPostQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "HospitalExternalPost",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables), options);
};
useHospitalExternalPostQuery.getKey = function(variables) {
    return [
        "HospitalExternalPost",
        variables
    ];
};
useHospitalExternalPostQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables, options);
};


/***/ }),

/***/ 57710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ telemedicine_useGetDiagnosisCategories; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/telemedicine/telemedicine.gql.impl.tsx
var telemedicine_gql_impl = __webpack_require__(76122);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ./src/constants/category.ts
var category = __webpack_require__(26214);
// EXTERNAL MODULE: ./src/entities/medical-category/index.ts + 4 modules
var medical_category = __webpack_require__(7551);
;// CONCATENATED MODULE: ./src/models/diagnosis/category.ts




var DepartmentCategoryModel = /*#__PURE__*/ function() {
    "use strict";
    function DepartmentCategoryModel(id, name, description, icon) {
        (0,_class_call_check/* default */.Z)(this, DepartmentCategoryModel);
        this.id = id;
        this.name = name;
        this.description = description;
        this.icon = icon;
    }
    var _proto = DepartmentCategoryModel.prototype;
    _proto.getSeoTitle = function getSeoTitle() {
        switch(this.id){
            case category/* TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS */.Iq.DEPARTMENT.PEDIATRICS:
                return "소아과(소아청소년과) 비대면진료 예약\xb7약 처방 받기 - 닥터나우";
            default:
                return "".concat(this.name, " 비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우");
        }
    };
    _proto.getSeoDescription = function getSeoDescription() {
        switch(this.id){
            case category/* TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS */.Iq.DEPARTMENT.PEDIATRICS:
                return "아이 아플 때, 닥터나우에서 소아과 선생님께 비대면진료와 약 처방까지 빠르게 받아보세요. 아기 해열제까지 모두 비대면 처방 가능해요.";
            default:
                return "".concat(this.name, "에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면진료로 약 처방까지 받아보세요.");
        }
    };
    _proto.getKeywords = function getKeywords() {
        switch(this.id){
            case category/* TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS */.Iq.DEPARTMENT.PEDIATRICS:
                return "소아과, 소아청소년과, 비대면진료, 일요일소아과, 비대면진료어플, 닥터나우";
            default:
                return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
        }
    };
    return DepartmentCategoryModel;
}();
var PopularDepartmentCategoryModel = function PopularDepartmentCategoryModel(id, name) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, PopularDepartmentCategoryModel);
    this.id = id;
    this.name = name;
};
var PopularTreatmentCategoryModel = function PopularTreatmentCategoryModel(id, name) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, PopularTreatmentCategoryModel);
    this.id = id;
    this.name = name;
};
var TreatmentCategoryModel = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentCategoryModel(id, name, icon, _treatments) {
        (0,_class_call_check/* default */.Z)(this, TreatmentCategoryModel);
        this.id = id;
        this.name = name;
        this.icon = icon;
        this._treatments = _treatments;
    }
    var _proto = TreatmentCategoryModel.prototype;
    _proto.getSeoTitle = function getSeoTitle(treatmentId) {
        switch(treatmentId){
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD */.Iq.TREATMENT.COLD:
                return "감기\xb7독감 비대면진료 예약하고 약 처방받기 - 닥터나우";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS */.Iq.TREATMENT.ARTIFICIAL_TEARS:
                return "인공눈물, 비대면진료 예약하고 처방받기 - 닥터나우";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS */.Iq.TREATMENT.HAIRLOSS:
                return "탈모 비대면진료 예약하고 탈모약 처방받기 - 닥터나우";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE */.Iq.TREATMENT.ACNE:
                return "여드름 비대면진료 예약하고 여드름약 처방받기 - 닥터나우";
            default:
                return "".concat(this.name, " 비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우");
        }
    };
    _proto.getSeoDescription = function getSeoDescription(treatmentId) {
        switch(treatmentId){
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD */.Iq.TREATMENT.COLD:
                return "코감기, 인후통, 몸살 증상이 있으신가요? 병원 갈 필요 없이, 닥터나우에서 의사에게 감기\xb7독감 비대면 진료 후 약 처방받아 보세요.";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS */.Iq.TREATMENT.ARTIFICIAL_TEARS:
                return "라식/라섹 후 인공눈물 필요하세요? 닥터나우를 이용하면 안과 갈 필요 없이 비대면진료로 빠르게 인공눈물을 처방받을 수 있어요.";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS */.Iq.TREATMENT.HAIRLOSS:
                return "탈모약 처방 저렴한 곳 찾는다면? 병원 갈 필요 없이, 닥터나우에서 최저가 탈모약 처방을 비대면으로 안전하게 받아 보세요.";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE */.Iq.TREATMENT.ACNE:
                return "여드름으로 고생하고 있다면? 피부과 방문 없이 닥터나우에서 항생제 및 외용제를 비대면 진료로 간편하게 처방받아 보세요.";
            default:
                return "".concat(this.name, "에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면진료로 약 처방까지 받아보세요.");
        }
    };
    _proto.getKeywords = function getKeywords(treatmentId) {
        switch(treatmentId){
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD */.Iq.TREATMENT.COLD:
                return "감기, 독감, 코감기, 몸살, 감기비대면진료, 감기약처방, 비대면처방, 비대면진료어플, 닥터나우";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS */.Iq.TREATMENT.ARTIFICIAL_TEARS:
                return "인공눈물, 안구건조증, 비대면진료, 인공눈물대량처방, 인공눈물처방최대, 인공눈물비대면진료";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS */.Iq.TREATMENT.HAIRLOSS:
                return "탈모약, 피나스테리드, 두타스테리드, 탈모비대면처방, 탈모비대면진료, 비대면진료어플, 닥터나우";
            case category/* TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE */.Iq.TREATMENT.ACNE:
                return "여드름약, 여드름처방, 여드름비대면진료, 이소티논, 크레오신티, 비대면진료어플, 닥터나우";
            default:
                return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
        }
    };
    (0,_create_class/* default */.Z)(TreatmentCategoryModel, [
        {
            key: "treatments",
            get: function get() {
                var _this = this;
                return this._treatments.map(function(treatment) {
                    return {
                        id: treatment.id,
                        name: treatment.name,
                        getSeoTitle: function() {
                            return _this.getSeoTitle(treatment.id);
                        },
                        getSeoDescription: function() {
                            return _this.getSeoDescription(treatment.id);
                        },
                        getKeywords: function() {
                            return _this.getKeywords(treatment.id);
                        }
                    };
                });
            }
        }
    ]);
    return TreatmentCategoryModel;
}();
var DiagnosisCategoryInfoModel = /*#__PURE__*/ function() {
    "use strict";
    function DiagnosisCategoryInfoModel(popularDepartmentCategories, popularTreatmentCategories, departmentCategories, treatmentCategories) {
        (0,_class_call_check/* default */.Z)(this, DiagnosisCategoryInfoModel);
        this.popularDepartmentCategories = popularDepartmentCategories;
        this.popularTreatmentCategories = popularTreatmentCategories;
        this.departmentCategories = departmentCategories;
        this.treatmentCategories = treatmentCategories;
    }
    var _proto = DiagnosisCategoryInfoModel.prototype;
    _proto.findDepartmentCategoryByCategoryId = function findDepartmentCategoryByCategoryId(categoryId) {
        return this.departmentCategories.find(function(category) {
            return category.id === categoryId;
        }) || null;
    };
    _proto.findTreatmentCategoryByTreatmentId = function findTreatmentCategoryByTreatmentId(treatmentId) {
        return this.treatmentCategories.find(function(category) {
            return category.treatments.some(function(treatment) {
                return treatment.id === treatmentId;
            });
        }) || null;
    };
    _proto.findTreatmentByTreatmentId = function findTreatmentByTreatmentId(treatmentId) {
        var foundCategory = this.findTreatmentCategoryByTreatmentId(treatmentId);
        if (!foundCategory) {
            return null;
        }
        return foundCategory.treatments.find(function(treatment) {
            return treatment.id === treatmentId;
        }) || null;
    };
    _proto.getDepartmentCategories = function getDepartmentCategories() {
        return this.departmentCategories;
    };
    _proto.getCategoryNameByIdAndType = function getCategoryNameByIdAndType(categoryId, categoryType) {
        if (!categoryId || !categoryType) {
            return "증상/과목";
        }
        if (categoryType === medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT) {
            var ref;
            var ref1;
            return (ref1 = (ref = this.findDepartmentCategoryByCategoryId(categoryId)) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : "";
        } else if (categoryType === medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT) {
            var ref2;
            var ref3;
            return (ref3 = (ref2 = this.findTreatmentByTreatmentId(categoryId)) === null || ref2 === void 0 ? void 0 : ref2.name) !== null && ref3 !== void 0 ? ref3 : "";
        }
        return "증상/과목";
    };
    return DiagnosisCategoryInfoModel;
}();

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts





var parseDiagnosisCategories = function(data) {
    var categoriesInfo = data.getDiagnosisCategoriesV2;
    return new DiagnosisCategoryInfoModel(categoriesInfo.popularDepartmentCategories.map(function(departmentCategory) {
        return new PopularDepartmentCategoryModel(departmentCategory.id, departmentCategory.name);
    }), categoriesInfo.popularTreatmentCategories.map(function(treatmentCategory) {
        return new PopularTreatmentCategoryModel(treatmentCategory.id, treatmentCategory.name);
    }), categoriesInfo.departmentCategories.map(function(departmentCategory) {
        var _description;
        return new DepartmentCategoryModel(departmentCategory.id, departmentCategory.name, (_description = departmentCategory.description) !== null && _description !== void 0 ? _description : "", departmentCategory.iconUrl);
    }), categoriesInfo.treatmentCategories.map(function(treatmentCategory) {
        return new TreatmentCategoryModel(treatmentCategory.id, treatmentCategory.name, treatmentCategory.iconUrl, treatmentCategory.items.map(function(treatment) {
            return {
                id: treatment.id,
                name: treatment.name
            };
        }));
    }));
};
var useGetDiagnosisCategories = function() {
    var ref = (0,telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query */.lE)({
        contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
    }, {
        select: parseDiagnosisCategories
    }), tmp = ref.data, categoriesInfo = tmp === void 0 ? new DiagnosisCategoryInfoModel([], [], [], []) : tmp;
    return {
        categoriesInfo: categoriesInfo
    };
};
/* harmony default export */ var telemedicine_useGetDiagnosisCategories = (useGetDiagnosisCategories);
useGetDiagnosisCategories.getKey = function() {
    return telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.getKey */.lE.getKey({
        contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
    });
};
useGetDiagnosisCategories.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(useGetDiagnosisCategories.getKey(), telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.fetcher */.lE.fetcher({
                            contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient) {
        return _ref.apply(this, arguments);
    };
}();
useGetDiagnosisCategories.fetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery(useGetDiagnosisCategories.getKey(), telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.fetcher */.lE.fetcher({
                            contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
                        }))
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        {
                            categoriesInfo: parseDiagnosisCategories(data)
                        }
                    ];
            }
        });
    });
    return function(queryClient) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 84958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ Review; },
/* harmony export */   "Fj": function() { return /* binding */ EReviewType; },
/* harmony export */   "IE": function() { return /* binding */ ReviewComment; },
/* harmony export */   "R": function() { return /* binding */ ReviewDiagnosisDoctor; },
/* harmony export */   "Vj": function() { return /* binding */ ReviewTag; },
/* harmony export */   "XV": function() { return /* binding */ ReviewTagExposure; },
/* harmony export */   "fr": function() { return /* binding */ ReviewTargetType; }
/* harmony export */ });
/* unused harmony exports MedicineType, ReviewDiagnosis */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27805);


var ReviewTargetType;
(function(ReviewTargetType) {
    ReviewTargetType["DOCTOR"] = "DOCTOR";
    ReviewTargetType["PHARMACY"] = "PHARMACY";
})(ReviewTargetType || (ReviewTargetType = {}));
var EReviewType;
(function(EReviewType) {
    EReviewType["NORMAL"] = "NORMAL";
    EReviewType["BEST"] = "BEST";
})(EReviewType || (EReviewType = {}));
var MedicineType;
(function(MedicineType) {
    MedicineType["Counselor"] = "COUNSELOR";
    MedicineType["Dentist"] = "DENTIST";
    MedicineType["Doctor"] = "DOCTOR";
    MedicineType["OrientalDoctor"] = "ORIENTAL_DOCTOR";
})(MedicineType || (MedicineType = {}));
var Review = /*#__PURE__*/ function() {
    "use strict";
    function Review(review) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Review);
        this.review = review;
    }
    var _proto = Review.prototype;
    _proto.shouldNotDisplayed = function shouldNotDisplayed(currentUserId) {
        if (!this.isPrivate) {
            return false;
        }
        return Number(currentUserId) !== Number(this.userId);
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Review, [
        {
            key: "id",
            get: function get() {
                return this.review.id;
            }
        },
        {
            key: "isPrivate",
            get: function get() {
                return this.review.isPrivate;
            }
        },
        {
            key: "userId",
            get: function get() {
                return this.review.userId;
            }
        },
        {
            key: "isLiked",
            get: function get() {
                return this.review.isLiked;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.review.title;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.review.content;
            }
        },
        {
            key: "writer",
            get: function get() {
                return this.review.writer;
            }
        },
        {
            key: "rating",
            get: function get() {
                return this.review.rating;
            }
        },
        {
            key: "comment",
            get: function get() {
                return this.review.comment;
            }
        },
        {
            key: "likeCount",
            get: function get() {
                return this.review.likeCount;
            }
        },
        {
            key: "tags",
            get: function get() {
                return this.review.tags;
            }
        },
        {
            key: "price",
            get: function get() {
                return this.review.price;
            }
        },
        {
            key: "createdAt",
            get: function get() {
                return this.review.createdAt;
            }
        },
        {
            key: "diagnosisCategoryName",
            get: function get() {
                return this.review.diagnosisCategoryName;
            }
        },
        {
            key: "doctor",
            get: function get() {
                return this.review.doctor;
            }
        }
    ]);
    return Review;
}();
var ReviewTag = /*#__PURE__*/ function() {
    "use strict";
    function ReviewTag(tag) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewTag);
        this.tag = tag;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewTag, [
        {
            key: "reviewId",
            get: function get() {
                return this.tag.reviewId;
            }
        },
        {
            key: "tagId",
            get: function get() {
                return this.tag.tagId;
            }
        },
        {
            key: "text",
            get: function get() {
                return this.tag.text;
            }
        }
    ]);
    return ReviewTag;
}();
var ReviewComment = /*#__PURE__*/ function() {
    "use strict";
    function ReviewComment(reviewComment) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewComment);
        this.reviewComment = reviewComment;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewComment, [
        {
            key: "createdAt",
            get: function get() {
                return this.reviewComment.createdAt;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.reviewComment.content;
            }
        }
    ]);
    return ReviewComment;
}();
var ReviewDiagnosis = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ReviewDiagnosis(reviewDiagnosis) {
        _class_call_check(this, ReviewDiagnosis);
        this.reviewDiagnosis = reviewDiagnosis;
    }
    _create_class(ReviewDiagnosis, [
        {
            key: "doctor",
            get: function get() {
                return this.reviewDiagnosis.doctor;
            }
        }
    ]);
    return ReviewDiagnosis;
}()));
var ReviewDiagnosisDoctor = /*#__PURE__*/ function() {
    "use strict";
    function ReviewDiagnosisDoctor(reviewDiagnosisDoctor) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewDiagnosisDoctor);
        this.reviewDiagnosisDoctor = reviewDiagnosisDoctor;
    }
    var _proto = ReviewDiagnosisDoctor.prototype;
    _proto.getDoctorDisplayName = function getDoctorDisplayName() {
        if (this.medicineType === MedicineType.OrientalDoctor) {
            return "".concat(this.name, " 한의사");
        }
        return "".concat(this.name, " 의사");
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewDiagnosisDoctor, [
        {
            key: "id",
            get: function get() {
                return this.reviewDiagnosisDoctor.id;
            }
        },
        {
            key: "medicineType",
            get: function get() {
                return this.reviewDiagnosisDoctor.medicineType;
            }
        },
        {
            key: "name",
            get: function get() {
                return this.reviewDiagnosisDoctor.name;
            }
        },
        {
            key: "profile",
            get: function get() {
                return this.reviewDiagnosisDoctor.profile;
            }
        }
    ]);
    return ReviewDiagnosisDoctor;
}();
var ReviewTagExposure;
(function(ReviewTagExposure) {
    ReviewTagExposure["ALWAYS"] = "ALWAYS";
    ReviewTagExposure["POSITIVE"] = "POSITIVE";
    ReviewTagExposure["NEGATIVE"] = "NEGATIVE";
    ReviewTagExposure["NONE"] = "NONE";
})(ReviewTagExposure || (ReviewTagExposure = {}));


/***/ }),

/***/ 8109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ request; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/hooks/auth/useAuth.ts
var useAuth = __webpack_require__(31310);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/entities/diagnosis/libs/index.ts + 1 modules
var libs = __webpack_require__(54674);
// EXTERNAL MODULE: ./src/shared/types/certification.ts
var certification = __webpack_require__(61607);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(4601);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/CertificationGuideStep.tsx









var CertificationGuideStep = function(param) {
    var onCertificationSuccess = param.onCertificationSuccess;
    var router = (0,next_router.useRouter)();
    var toast = (0,index_es/* useToast */.pm)().toast;
    var lastProcessedTimestampRef = (0,react.useRef)(0);
    var handleCertificationMessage = (0,react.useCallback)(function(message) {
        if (message.timestamp <= lastProcessedTimestampRef.current) {
            return;
        }
        lastProcessedTimestampRef.current = message.timestamp;
        if (message.type === certification/* CERTIFICATION_MESSAGE_TYPE.SUCCESS */.i.SUCCESS) {
            onCertificationSuccess();
            return;
        }
        toast({
            text: "본인인증에 실패했습니다. 다시 시도해주세요.",
            direction: "bottom"
        });
        return;
    }, [
        onCertificationSuccess,
        toast
    ]);
    var handleCertification = (0,react.useCallback)(function() {
        var currentUrl = window.location.origin + router.asPath;
        var returnUrl = "".concat(currentUrl).concat(currentUrl.includes("?") ? "&" : "?", "result=success");
        var errorUrl = "".concat(currentUrl).concat(currentUrl.includes("?") ? "&" : "?", "result=fail");
        var certificationUrl = "/phone-verification?returnUrl=".concat(encodeURIComponent(returnUrl), "&errorUrl=").concat(encodeURIComponent(errorUrl));
        var popupOptions = "width=480,height=812,top=100,left=100," + "menubar=no,toolbar=no,status=no,scrollbars=yes," + "resizable=yes,location=no";
        window.open(certificationUrl, "certification_popup", popupOptions);
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        var handlePostMessage = function(event) {
            if (event.origin !== window.location.origin) {
                return;
            }
            var message = event.data;
            if (message && message.type && message.timestamp) {
                handleCertificationMessage(message);
            }
        };
        var handleBroadcastMessage = function(event) {
            handleCertificationMessage(event.data);
        };
        window.addEventListener("message", handlePostMessage);
        var channel = null;
        if ("BroadcastChannel" in window) {
            channel = new BroadcastChannel(certification/* CERTIFICATION_CHANNEL_NAME */.B);
            channel.onmessage = handleBroadcastMessage;
        }
        return function() {
            window.removeEventListener("message", handlePostMessage);
            if (channel) {
                channel.close();
            }
        };
    }, [
        handleCertificationMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex min-h-screen w-full flex-col bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "box-border flex flex-col gap-[8px] px-[24px] pt-[12px] pb-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "typography-ui-24sb text-gray-900",
                        children: [
                            "마지막으로 안전한 진료를 위해",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "본인인증이 필요해요"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "typography-ui-17r text-gray-600",
                        children: "6개월마다 본인 명의 핸드폰 인증이 필요해요."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "box-border flex flex-1 flex-col items-center justify-center gap-[24px] px-[24px] pt-[40px] pb-[90px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative h-[240px] w-[232px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/certification/certification_guide_icon.png",
                        alt: "본인인증 안내",
                        width: 232,
                        height: 240,
                        style: {
                            objectFit: "cover"
                        },
                        priority: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full flex-col gap-[12px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                        params: {
                            eventName: libs/* EWebTreatmentRequestLog.ClickIdvSheet */.o5.ClickIdvSheet
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            size: "xl",
                            buttonColor: "primary",
                            buttonStyle: "contained",
                            onClick: handleCertification,
                            className: "w-full",
                            children: "본인인증"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ui_CertificationGuideStep = (CertificationGuideStep);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/components/templates/diagnosis/treatment-request/components/RequestAccordion.tsx + 7 modules
var RequestAccordion = __webpack_require__(39284);
// EXTERNAL MODULE: ./src/entities/diagnosis/index.ts + 5 modules
var diagnosis = __webpack_require__(63507);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ../../node_modules/vaul/dist/index.mjs + 34 modules
var dist = __webpack_require__(40057);
;// CONCATENATED MODULE: ./src/widgets/symptom-selection/ui/SymptomBottomSheet.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  inset: 0;\n  z-index: 260;\n  margin: 0 auto;\n  max-width: 768px;\n  background-color: rgba(0, 0, 0, 0.4);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 261;\n  margin: 0 auto;\n  max-width: 768px;\n  background-color: ",
        ";\n  border-radius: 10px 10px 0 0;\n  padding: 8px 20px 20px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.16);\n\n  &:focus-visible {\n    outline: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 20px;\n    padding: 0 4px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n  max-height: 400px;\n  margin-bottom: 24px;\n  flex: 1;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n\n    & > span {\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    &::before {\n      position: absolute;\n      content: '';\n      top: 50%;\n      left: 16px;\n      transform: translateY(-50%);\n      border-radius: 50%;\n      width: 22px;\n      height: 22px;\n      background-color: ",
        ";\n      border: ",
        ";\n      transition: border 0.2s ease;\n    }\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border-radius: 8px;\n  padding: 16px 16px 16px 54px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var SymptomBottomSheet = function(param) {
    var open = param.open, items = param.items, onClose = param.onClose, onSubmit = param.onSubmit;
    var ref = (0,react.useState)(null), selectedItem = ref[0], setSelectedItem = ref[1];
    var handleOpenChange = function(isOpen) {
        if (!isOpen) {
            setSelectedItem(null);
            onClose();
        }
    };
    var handleSubmit = function() {
        if (selectedItem) {
            onSubmit(selectedItem);
            setSelectedItem(null);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Root */.dy.Root, {
        modal: true,
        open: open,
        onOpenChange: handleOpenChange,
        dismissible: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Drawer.Portal */.dy.Portal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlay, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Handle */.dy.Handle, {
                            className: "mx-auto mb-[16px] h-[4px] w-[48px] flex-shrink-0 rounded-full bg-gray-300"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "증상 불러오기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                            children: items.map(function(item) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(RadioItem, {
                                    selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id,
                                    onClick: function() {
                                        return setSelectedItem(item);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.symptom
                                    })
                                }, item.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                buttonStyle: "contained",
                                buttonColor: "primary",
                                size: "xl",
                                disabled: !selectedItem,
                                className: "w-full",
                                onClick: handleSubmit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "불러오기"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ui_SymptomBottomSheet = (SymptomBottomSheet);
var StyledOverlay = (0,styled_components_browser_esm/* default */.ZP)(dist/* Drawer.Overlay */.dy.Overlay).withConfig({
    componentId: "sc-7ad5a2d8-0"
})(_templateObject());
var Content = (0,styled_components_browser_esm/* default */.ZP)(dist/* Drawer.Content */.dy.Content).withConfig({
    componentId: "sc-7ad5a2d8-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.white;
});
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-7ad5a2d8-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), theme.typography.UI22SB, theme.color.gray900);
});
var ListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ad5a2d8-3"
})(_templateObject4());
var RadioItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ad5a2d8-4"
})(_templateObject6(), function(param) {
    var theme = param.theme, selected = param.selected;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), theme.typography.UI15M, theme.color.gray20, theme.color.gray700, theme.color.white, selected ? "5px solid ".concat(theme.color.primary500) : "2px solid ".concat(theme.color.gray100), theme.color.gray50);
});
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ad5a2d8-5"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.color.gray100;
});

;// CONCATENATED MODULE: ./src/widgets/symptom-selection/ui/index.ts



;// CONCATENATED MODULE: ./src/widgets/symptom-selection/index.ts


// EXTERNAL MODULE: ./src/components/templates/diagnosis/treatment-request/components/RequestButton.tsx
var RequestButton = __webpack_require__(57418);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/lib/checkRestrictedTimeRange.ts
var RESTRICTED_START_HOUR = 20;
var RESTRICTED_START_MINUTE = 0;
var RESTRICTED_END_HOUR = 7;
var RESTRICTED_END_MINUTE = 40;
var checkRestrictedTimeRange = function() {
    var now = new Date();
    var currentHour = now.getHours();
    var currentMinute = now.getMinutes();
    var currentTimeInMinutes = currentHour * 60 + currentMinute;
    var restrictedStartInMinutes = RESTRICTED_START_HOUR * 60 + RESTRICTED_START_MINUTE;
    var restrictedEndInMinutes = RESTRICTED_END_HOUR * 60 + RESTRICTED_END_MINUTE;
    var isAfterRestrictedStart = currentTimeInMinutes >= restrictedStartInMinutes;
    var isBeforeRestrictedEnd = currentTimeInMinutes < restrictedEndInMinutes;
    return isAfterRestrictedStart || isBeforeRestrictedEnd;
};

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TimePeriodSection.tsx




var TimePeriodSection = function(param) {
    var title = param.title, schedules = param.schedules, treatmentRequest = param.treatmentRequest, selectBookingTimeSlot = param.selectBookingTimeSlot, _showWarning = param.showWarning, showWarning = _showWarning === void 0 ? false : _showWarning, warningMessage = param.warningMessage;
    if (!schedules || schedules.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-[8px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "typography-ui-13sb text-gray-700",
                children: title
            }),
            showWarning && warningMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center rounded-[8px] border-[#D3E6FF] border-[1px] border-solid bg-[#EFF6FF] px-[16px] py-[12px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "typography-ui-13m text-gray-500",
                    children: warningMessage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap gap-[8px]",
                children: schedules.map(function(time) {
                    var isSelected = time.isSelected(treatmentRequest.form.startTimeSlotValue, treatmentRequest.form.endTimeSlotValue);
                    var isDisabled = !time.isBookable;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                        params: {
                            eventName: libs/* TreatmentRequestLog.RequestClickBookingTime */.Js.RequestClickBookingTime
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            disabled: isDisabled,
                            onClick: function() {
                                selectBookingTimeSlot(time.startTimeSlot.value, time.endTimeSlot.value);
                            },
                            className: (0,style.cn)("typography-ui-15m flex h-[56px] w-[calc((100%-16px)/3)] flex-col items-center justify-center rounded-[8px] border border-solid transition-all duration-300 ease-out", isSelected && [
                                "border-primary-600 bg-primary-100 text-primary-700"
                            ], !isSelected && !isDisabled && [
                                "border-gray-100 bg-white text-gray-700 active:scale-95 active:border-gray-30 active:bg-gray-30 active:text-gray-700", 
                            ], isDisabled && [
                                "cursor-not-allowed border-gray-40 bg-gray-40 text-gray-300"
                            ]),
                            children: [
                                time.startTimeSlot.fromDisplayTime,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (0,style.cn)("typography-ui-13m", isSelected && "text-primary-700", !isSelected && !isDisabled && "text-gray-400", isDisabled && "text-gray-300"),
                                    children: [
                                        "~ ",
                                        time.endTimeSlot.toDisplayTime
                                    ]
                                })
                            ]
                        })
                    }, "time-".concat(time.startTimeSlot.value));
                })
            })
        ]
    });
};
/* harmony default export */ var ui_TimePeriodSection = (TimePeriodSection);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineBookingDays.tsx









var TelemedicineBookingDays = function(param) {
    var treatmentRequest = param.treatmentRequest, days = param.days, quickestMinutes = param.quickestMinutes, selectedDay = param.selectedDay, selectBookingTargetDate = param.selectBookingTargetDate, selectBookingTimeSlot = param.selectBookingTimeSlot, toggleAsapRequest = param.toggleAsapRequest, selectQuickMode = param.selectQuickMode, selectGeneralMode = param.selectGeneralMode;
    var isQuickScheduleMode = treatmentRequest.isWebQuickScheduleRequest();
    var hasScheduleModeSelected = treatmentRequest.hasScheduleModeSelected();
    var isRestrictedTimeRange = checkRestrictedTimeRange();
    (0,react.useEffect)(function() {
        if (isRestrictedTimeRange && !hasScheduleModeSelected) {
            selectGeneralMode();
        }
    }, [
        isRestrictedTimeRange,
        hasScheduleModeSelected,
        selectGeneralMode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-[20px] p-[0px_24px_32px]",
        children: [
            !isRestrictedTimeRange && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                        params: {
                            eventName: libs/* EWebTreatmentRequestLog.ClickQuickScheduleMode */.o5.ClickQuickScheduleMode
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: selectQuickMode,
                            className: (0,style.cn)("flex flex-col items-start gap-[2px] rounded-[8px] border border-solid p-[20px] transition-all", hasScheduleModeSelected && isQuickScheduleMode && "border-primary-700 bg-[#fff9f5]", (!hasScheduleModeSelected || !isQuickScheduleMode) && "border-gray-100 bg-white"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full items-center gap-[4px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (0,style.cn)("typography-ui-15sb", hasScheduleModeSelected && isQuickScheduleMode && "text-primary-800", (!hasScheduleModeSelected || !isQuickScheduleMode) && "text-gray-900"),
                                            children: "가장 빠른 시간에 진료받기"
                                        }),
                                        quickestMinutes !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-center rounded-[16px] bg-[#fff2ea] px-[8px] py-[2px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "typography-ui-12sb text-primary-700",
                                                children: [
                                                    quickestMinutes,
                                                    "분 내 진료"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "typography-ui-13r text-left text-gray-500",
                                    children: "최대한 빠르게 진료 가능한 의사를 찾아드려요."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                        params: {
                            eventName: libs/* EWebTreatmentRequestLog.ClickGeneralScheduleMode */.o5.ClickGeneralScheduleMode
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: selectGeneralMode,
                            className: (0,style.cn)("flex flex-col items-start gap-[2px] rounded-[8px] border border-solid p-[20px] transition-all", hasScheduleModeSelected && !isQuickScheduleMode && "border-primary-700 bg-[#fff9f5]", (!hasScheduleModeSelected || isQuickScheduleMode) && "border-gray-100 bg-white"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (0,style.cn)("typography-ui-15sb", hasScheduleModeSelected && !isQuickScheduleMode && "text-primary-800", (!hasScheduleModeSelected || isQuickScheduleMode) && "text-gray-900"),
                                    children: "원하는 시간에 진료받기"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "typography-ui-13r text-left text-gray-500",
                                    children: "내가 원하는 시간에 진료 가능한 의사를 찾아드려요."
                                })
                            ]
                        })
                    })
                ]
            }),
            (isRestrictedTimeRange || hasScheduleModeSelected && !isQuickScheduleMode) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-[8px]",
                children: days.map(function(day) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(RequestButton/* default */.Z, {
                        selected: (selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.targetDate) === day.targetDate,
                        onClick: function() {
                            return selectBookingTargetDate(day.targetDate);
                        },
                        text: day.displayName
                    }, "day-".concat(day.displayName));
                })
            }),
            !isQuickScheduleMode && selectedDay && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: selectedDay.isBookableDay ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-[16px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TimePeriodSection, {
                                    title: "새벽",
                                    schedules: selectedDay.dawnSchedules,
                                    treatmentRequest: treatmentRequest,
                                    selectBookingTimeSlot: selectBookingTimeSlot,
                                    showWarning: true,
                                    warningMessage: "새벽 시간대에는 진료 가능한 의사가 부족할 수 있어요."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TimePeriodSection, {
                                    title: "오전",
                                    schedules: selectedDay.morningSchedules,
                                    treatmentRequest: treatmentRequest,
                                    selectBookingTimeSlot: selectBookingTimeSlot
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TimePeriodSection, {
                                    title: "오후",
                                    schedules: selectedDay.afternoonSchedules,
                                    treatmentRequest: treatmentRequest,
                                    selectBookingTimeSlot: selectBookingTimeSlot
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TimePeriodSection, {
                                    title: "야간",
                                    schedules: selectedDay.nightSchedules,
                                    treatmentRequest: treatmentRequest,
                                    selectBookingTimeSlot: selectBookingTimeSlot,
                                    showWarning: true,
                                    warningMessage: "야간 시간대에는 진료 가능한 의사가 부족할 수 있어요."
                                })
                            ]
                        }),
                        treatmentRequest.shouldShowAsapRequest() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center gap-[12px] px-[4px] py-[4px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CheckItem */.M1, {
                                label: "예약한 시간보다 더 빨리 진료받고 싶어요",
                                checkboxProps: {
                                    checked: treatmentRequest.form.isAsapRequest,
                                    onCheckedChange: toggleAsapRequest
                                }
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "typography-ui-15m flex h-[44px] w-full items-center justify-center rounded-[8px] bg-gray-20 p-[12px] text-gray-400",
                    children: "예약이 꽉 찼어요"
                })
            })
        ]
    });
};
/* harmony default export */ var ui_TelemedicineBookingDays = (TelemedicineBookingDays);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/DiagnosisFormStep.tsx









var DiagnosisFormStep = function(param) {
    var client = param.client, bookingSchedulesInfo = param.bookingSchedulesInfo, treatmentRequest = param.treatmentRequest, accordionRefs = param.accordionRefs, selectedDayScheduleLength = param.selectedDayScheduleLength, selectedDay = param.selectedDay, ssnInputRef = param.ssnInputRef, categoryName = param.categoryName, isPreSignedUrlsLoading = param.isPreSignedUrlsLoading, detailSymptomInputRef = param.detailSymptomInputRef, recentlyDetailSymptomsCount = param.recentlyDetailSymptomsCount, isChronicDiseaseCategory = param.isChronicDiseaseCategory, chronicDiseaseCategoryWarningMessages = param.chronicDiseaseCategoryWarningMessages, chronicDiseaseCategoryPlaceholder = param.chronicDiseaseCategoryPlaceholder, isDoctorStepButtonDisabled = param.isDoctorStepButtonDisabled, selectedTimeSlotTitle = param.selectedTimeSlotTitle, userProfile = param.userProfile, selectBookingTargetDate = param.selectBookingTargetDate, selectBookingTimeSlot = param.selectBookingTimeSlot, toggleAsapRequest = param.toggleAsapRequest, selectQuickMode = param.selectQuickMode, selectGeneralMode = param.selectGeneralMode, updatePatientSsn = param.updatePatientSsn, resetPatientSsn = param.resetPatientSsn, updateSymptom = param.updateSymptom, onHandleChangeSymptomImage = param.onHandleChangeSymptomImage, removeSymptomImage = param.removeSymptomImage, openDetailSymptomsLoadBottomSheet = param.openDetailSymptomsLoadBottomSheet, requestCameraPermission = param.requestCameraPermission, handleDiagnosisStepNext = param.handleDiagnosisStepNext, diagnosisStepButtonText = param.diagnosisStepButtonText, isSymptomBottomSheetOpen = param.isSymptomBottomSheetOpen, recentlyDetailSymptoms = param.recentlyDetailSymptoms, onCloseSymptomBottomSheet = param.onCloseSymptomBottomSheet, onSymptomSelect = param.onSymptomSelect;
    var ref, _categoryId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "min-h-[calc(100vh-160px)] pb-[140px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestAccordion/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccordion/* default.Header */.Z.Header, {
                                title: selectedTimeSlotTitle,
                                iconName: "calendar_today"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccordion/* default.ContentBody */.Z.ContentBody, {
                                ref: accordionRefs.days,
                                contentLength: selectedDayScheduleLength,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineBookingDays, {
                                    treatmentRequest: treatmentRequest,
                                    days: bookingSchedulesInfo.daySchedulesGroupedByTimePeriod,
                                    quickestMinutes: bookingSchedulesInfo.getQuickestAvailableMinutes(),
                                    selectBookingTargetDate: selectBookingTargetDate,
                                    selectBookingTimeSlot: selectBookingTimeSlot,
                                    toggleAsapRequest: toggleAsapRequest,
                                    selectQuickMode: selectQuickMode,
                                    selectGeneralMode: selectGeneralMode,
                                    selectedDay: selectedDay
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestAccordion/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccordion/* default.Header */.Z.Header, {
                                title: treatmentRequest.validateSsn() ? (ref = userProfile === null || userProfile === void 0 ? void 0 : userProfile.name) !== null && ref !== void 0 ? ref : "" : "주민등록번호 뒷자리",
                                iconName: "id_card"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccordion/* default.ContentBody */.Z.ContentBody, {
                                ref: accordionRefs.ssn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccordion/* default.SSN */.Z.SSN, {
                                    client: client,
                                    ref: ssnInputRef,
                                    userProfile: userProfile,
                                    treatmentRequest: treatmentRequest,
                                    updatePatientSsn: updatePatientSsn,
                                    resetPatientSsn: resetPatientSsn
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestAccordion/* default */.Z, {
                        hiddenBorder: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccordion/* default.Header */.Z.Header, {
                                title: categoryName,
                                iconName: "content_paste"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccordion/* default.ContentBody */.Z.ContentBody, {
                                ref: accordionRefs.detailSymptom,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccordion/* default.DetailSymptom */.Z.DetailSymptom, {
                                    client: client,
                                    isImageUploading: isPreSignedUrlsLoading,
                                    ref: detailSymptomInputRef,
                                    shouldShowChildInfo: false,
                                    treatmentRequest: treatmentRequest,
                                    updateSymptom: updateSymptom,
                                    onHandleChangeSymptomImage: onHandleChangeSymptomImage,
                                    onDeleteSymptomImage: removeSymptomImage,
                                    recentlyDetailSymptomsCount: recentlyDetailSymptomsCount,
                                    openDetailSymptomsLoadBottomSheet: openDetailSymptomsLoadBottomSheet,
                                    requestCameraPermission: requestCameraPermission,
                                    isChronicDiseaseCategory: isChronicDiseaseCategory,
                                    chronicDiseaseCategoryWarningMessages: chronicDiseaseCategoryWarningMessages,
                                    chronicDiseaseCategoryPlaceholder: chronicDiseaseCategoryPlaceholder
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,style.cn)([
                    "fixed right-0 bottom-0 left-0 z-50 mx-auto w-full max-w-[600px]",
                    "desktop:absolute desktop:max-w-none", 
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,style.cn)([
                        "pointer-events-auto mx-auto flex w-full max-w-[600px] items-center justify-center bg-white px-[20px] pb-[16px]",
                        "desktop:max-w-none", 
                    ]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                        params: {
                            eventName: diagnosis/* EWebTreatmentRequestLog.ClickNextFromDiagnosisStep */.o5.ClickNextFromDiagnosisStep,
                            payload: (0,_object_spread/* default */.Z)({
                                categoryId: (_categoryId = treatmentRequest.form.categoryId) !== null && _categoryId !== void 0 ? _categoryId : "",
                                categoryName: categoryName
                            }, treatmentRequest.hasScheduleModeSelected() && {
                                scheduleMode: treatmentRequest.isWebQuickScheduleRequest() ? diagnosis/* EScheduleModeForLog.Quick */.pj.Quick : diagnosis/* EScheduleModeForLog.General */.pj.General
                            })
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            buttonColor: "primary",
                            size: "xl",
                            disabled: isDoctorStepButtonDisabled,
                            onClick: handleDiagnosisStepNext,
                            className: "w-full",
                            children: diagnosisStepButtonText
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SymptomBottomSheet, {
                open: isSymptomBottomSheetOpen,
                items: recentlyDetailSymptoms,
                onClose: onCloseSymptomBottomSheet,
                onSubmit: onSymptomSelect
            })
        ]
    });
};
/* harmony default export */ var ui_DiagnosisFormStep = (DiagnosisFormStep);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/DietGuideBottomSheet.tsx


var DietGuideBottomSheet = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BottomSheet */.R1, {
        type: "single",
        title: "다이어트 진료 안내",
        description: "다이어트 약물 처방은 비대면으로 가능해요!",
        open: isOpen,
        onOpenChange: function(open) {
            if (!open) {
                onClose();
            }
        },
        buttons: [
            {
                label: "확인했어요",
                variant: "primary",
                onClick: onClose
            }, 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/images/diet_diagnosis_bottom_sheet_guide.png",
                alt: "diet guide",
                className: "h-[160px] w-[312px] object-contain"
            })
        })
    });
};
/* harmony default export */ var ui_DietGuideBottomSheet = (DietGuideBottomSheet);

// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ../../node_modules/react-spring-bottom-sheet/dist/style.css
var dist_style = __webpack_require__(16789);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/modal/select-modal/report-select-modal/index.tsx
var report_select_modal = __webpack_require__(15392);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/constants/logs/doctor/index.ts
var doctor = __webpack_require__(71855);
// EXTERNAL MODULE: ./src/design-components/organisms/dnslide-tab/index.tsx
var dnslide_tab = __webpack_require__(25785);
// EXTERNAL MODULE: ./src/hooks/review/useReviewReportModal.tsx
var useReviewReportModal = __webpack_require__(68512);
// EXTERNAL MODULE: ./src/views/doctor/detail/index.ts + 37 modules
var detail = __webpack_require__(98406);
// EXTERNAL MODULE: ./src/views/doctor/detail/lib/index.ts + 2 modules
var lib = __webpack_require__(65640);
// EXTERNAL MODULE: ./src/views/doctor/detail/ui/doctor-summary/DoctorProfile.tsx
var DoctorProfile = __webpack_require__(45597);
// EXTERNAL MODULE: ./src/views/doctor/detail/ui/doctor-summary/DoctorReviewAndDepartments.tsx + 1 modules
var DoctorReviewAndDepartments = __webpack_require__(87848);
// EXTERNAL MODULE: ./src/views/doctor/reviews/index.ts + 6 modules
var reviews = __webpack_require__(83380);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/lodash/throttle.js
var throttle = __webpack_require__(12436);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./src/entities/medical-category/index.ts + 4 modules
var medical_category = __webpack_require__(7551);
// EXTERNAL MODULE: ./src/entities/non-benefit/index.ts + 16 modules
var non_benefit = __webpack_require__(65179);
// EXTERNAL MODULE: ./src/hooks/diagnosis/useGetDoctorIdByUserByTreatmentRequest.ts
var useGetDoctorIdByUserByTreatmentRequest = __webpack_require__(55214);
// EXTERNAL MODULE: ./src/hooks/doctor/useAddFamilyDoctor.ts
var useAddFamilyDoctor = __webpack_require__(79168);
// EXTERNAL MODULE: ./src/hooks/doctor/useGetDayOfWeek.ts
var useGetDayOfWeek = __webpack_require__(14185);
// EXTERNAL MODULE: ./src/hooks/doctor/useGetDoctorByUser.ts + 1 modules
var useGetDoctorByUser = __webpack_require__(37417);
// EXTERNAL MODULE: ./src/hooks/doctor/useRemoveFamilyDoctor.ts
var useRemoveFamilyDoctor = __webpack_require__(22224);
// EXTERNAL MODULE: ./src/hooks/login/useLoginViewModel.ts
var useLoginViewModel = __webpack_require__(97110);
// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
// EXTERNAL MODULE: ./src/services/doctor/DiagnosisCategoryService.ts
var DiagnosisCategoryService = __webpack_require__(33310);
// EXTERNAL MODULE: ./src/services/doctor/DoctorService.ts
var DoctorService = __webpack_require__(75014);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/diagnosis.ts
var types_diagnosis = __webpack_require__(20138);
// EXTERNAL MODULE: ./src/types/doctor.ts
var types_doctor = __webpack_require__(79051);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useDoctorDetailViewModel.ts




























var NonBenefitTreatmentPriceCategory = function NonBenefitTreatmentPriceCategory(name, id) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, NonBenefitTreatmentPriceCategory);
    this.name = name;
    this.id = id;
};
var DOCTOR_PROFILE_IMAGE_HEIGHT = 240;
var parseMedicalCategoryCategoryTypeOf = function(category) {
    switch(category){
        case medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT:
            return DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment;
        case medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT:
        default:
            return DiagnosisCategoryService/* ECategoryType.Department */.qm.Department;
    }
};
var useDoctorDetailViewModel = function() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, doctorPublicId = _query.doctorId, categoryId = _query.categoryId, type = _query.type, telemedicineTargetType = _query.telemedicineTargetType, _contactType = _query.contactType, contactType = _contactType === void 0 ? types_diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F : _contactType, _priceType = _query.priceType, priceType = _priceType === void 0 ? non_benefit/* DiagnosisPriceType.DiagnosisOnly */.dq.DiagnosisOnly : _priceType, isNeedReview = _query.isNeedReview;
    var isNonBenefitCategory = DiagnosisCategoryService/* default.isNonBenefitCategory */.ZP.isNonBenefitCategory(parseMedicalCategoryCategoryTypeOf(type), categoryId);
    var isDietCategory = DiagnosisCategoryService/* default.isDietCategory */.ZP.isDietCategory(categoryId);
    var loginViewModel = (0,useLoginViewModel/* default */.Z)();
    var logger = (0,useLogger/* default */.Z)();
    var dayOfWeek = (0,useGetDayOfWeek/* default */.Z)(dayjs_min_default()().format("YYYY-MM-DD")).dayOfWeek;
    var ref = (0,useGetDoctorByUser/* default */.ZP)({
        doctorId: doctorPublicId !== null && doctorPublicId !== void 0 ? doctorPublicId : "",
        telemedicineEligibleTargetType: telemedicineTargetType,
        dayOfWeek: dayOfWeek !== null && dayOfWeek !== void 0 ? dayOfWeek : undefined,
        contactType: contactType !== null && contactType !== void 0 ? contactType : undefined
    }), doctorDetail = ref.doctorDetail, isDoctorDetailLoading = ref.isDoctorDetailLoading, refetchDoctorByUser = ref.refetchDoctorByUser;
    var _id;
    var ref1 = (0,useGetDoctorIdByUserByTreatmentRequest/* default */.Z)((_id = doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.doctor.id) !== null && _id !== void 0 ? _id : "", contactType, !isDoctorDetailLoading && !categoryId), treatmentRequestDoctor = ref1.doctor;
    var openGoBackConfirmAlert = function() {
        setIsGoBackConfirmAlertOpened(true);
    };
    var closeGoBackConfirmAlert = function() {
        setIsGoBackConfirmAlertOpened(false);
    };
    var ref2 = (0,useAddFamilyDoctor/* default */.Z)(), handleAddFamilyDoctor = ref2.handleAddFamilyDoctor, setDoctorDetailCacheDataAfterAddFamilyDoctor = ref2.setDoctorDetailCacheDataAfterAddFamilyDoctor;
    var ref3 = (0,useRemoveFamilyDoctor/* default */.Z)(), handleRemoveFamilyDoctors = ref3.handleRemoveFamilyDoctors, setDoctorDetailCacheDataAfterRemoveFamilyDoctor = ref3.setDoctorDetailCacheDataAfterRemoveFamilyDoctor;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var addFamilyDoctor = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(doctorId) {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            handleAddFamilyDoctor(doctorId)
                        ];
                    case 1:
                        response = _state.sent();
                        toast({
                            text: "단골 의사로 등록했어요.\n더보기 메뉴에서 확인할 수 있어요."
                        });
                        logger.log({
                            eventName: doctor/* DoctorDetailLog.add_family_doctor */.d.add_family_doctor,
                            payload: {
                                doctorId: doctorId,
                                doctorPublicId: doctorPublicId !== null && doctorPublicId !== void 0 ? doctorPublicId : "",
                                telemedicineTargetType: telemedicineTargetType !== null && telemedicineTargetType !== void 0 ? telemedicineTargetType : "",
                                contactType: contactType !== null && contactType !== void 0 ? contactType : ""
                            }
                        });
                        setDoctorDetailCacheDataAfterAddFamilyDoctor({
                            doctorPublicId: doctorPublicId !== null && doctorPublicId !== void 0 ? doctorPublicId : "",
                            telemedicineEligibleTargetType: telemedicineTargetType !== null && telemedicineTargetType !== void 0 ? telemedicineTargetType : gql_schema/* TelemedicineTargetType.AlwaysEligible */.vw3.AlwaysEligible,
                            contactType: contactType === types_diagnosis/* EDiagnosisContactType.F2F */.d.F2F ? gql_schema/* DiagnosisContactType.F2F */.qnl.F2F : gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F,
                            isSelectedVaccination: false,
                            isAdded: response
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0,_instanceof/* default */.Z)(error, Error)) {
                            toast({
                                text: error.message
                            });
                            refetchDoctorByUser();
                        }
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function addFamilyDoctor(doctorId) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeFamilyDoctors = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(doctorIds) {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            handleRemoveFamilyDoctors(doctorIds)
                        ];
                    case 1:
                        response = _state.sent();
                        toast({
                            text: "단골 의사에서 제외했어요."
                        });
                        logger.log({
                            eventName: doctor/* DoctorDetailLog.remove_family_doctor */.d.remove_family_doctor,
                            payload: {
                                doctorIds: doctorIds.join(","),
                                doctorPublicId: doctorPublicId !== null && doctorPublicId !== void 0 ? doctorPublicId : "",
                                telemedicineTargetType: telemedicineTargetType !== null && telemedicineTargetType !== void 0 ? telemedicineTargetType : "",
                                contactType: contactType !== null && contactType !== void 0 ? contactType : ""
                            }
                        });
                        setDoctorDetailCacheDataAfterRemoveFamilyDoctor({
                            doctorPublicId: doctorPublicId !== null && doctorPublicId !== void 0 ? doctorPublicId : "",
                            telemedicineEligibleTargetType: telemedicineTargetType !== null && telemedicineTargetType !== void 0 ? telemedicineTargetType : gql_schema/* TelemedicineTargetType.AlwaysEligible */.vw3.AlwaysEligible,
                            contactType: contactType === types_diagnosis/* EDiagnosisContactType.F2F */.d.F2F ? gql_schema/* DiagnosisContactType.F2F */.qnl.F2F : gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F,
                            isSelectedVaccination: false,
                            isRemoved: response
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0,_instanceof/* default */.Z)(error, Error)) {
                            toast({
                                text: error.message
                            });
                            refetchDoctorByUser();
                        }
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function removeFamilyDoctors(doctorIds) {
            return _ref.apply(this, arguments);
        };
    }();
    var isFamilyDoctor = !!(doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.familyDoctorInfo);
    var handleUpdateFamilyDoctor = throttle_default()(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(doctorIds) {
            var doctorId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isFamilyDoctor) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            removeFamilyDoctors(doctorIds)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        doctorId = doctorIds.pop();
                        if (!doctorId) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            addFamilyDoctor(doctorId)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(doctorIds) {
            return _ref.apply(this, arguments);
        };
    }(), 500);
    var ref4 = (0,react.useState)(true), isHeaderTransparent = ref4[0], setIsHeaderTransparent = ref4[1];
    var ref5 = (0,react.useState)(false), isOperationTimeTableOpened = ref5[0], setIsOperationTimeTableOpened = ref5[1];
    var ref6 = (0,react.useState)(lib/* DoctorDetailTabType.NonBenefitPrice */.D.NonBenefitPrice), selectedTab = ref6[0], setSelectedTab = ref6[1];
    var ref7 = (0,react.useState)(), selectedNonBenefitTreatmentPriceCategory = ref7[0], setSelectedNonBenefitTreatmentCategory = ref7[1];
    var ref8 = (0,react.useState)(true), isPointPriceVisible = ref8[0], setIsPointPriceVisible = ref8[1];
    var ref9 = (0,react.useState)(false), isGoBackConfirmAlertOpened = ref9[0], setIsGoBackConfirmAlertOpened = ref9[1];
    var ref10 = (0,react.useState)(priceType === non_benefit/* DiagnosisPriceType.WithDispensation */.dq.WithDispensation), isWithDispensation = ref10[0], setIsWithDispensation = ref10[1];
    var diagnosisContactType = contactType === types_diagnosis/* EDiagnosisContactType.F2F */.d.F2F ? "대면" : "비대면";
    var toggleWithDispensation = function() {
        setIsWithDispensation(!isWithDispensation);
    };
    var toggleOperationTimeTable = function() {
        setIsOperationTimeTableOpened(!isOperationTimeTableOpened);
    };
    var getIsBookingAvailable = function() {
        var ref;
        if (!(doctorDetail === null || doctorDetail === void 0 ? void 0 : (ref = doctorDetail.diagnosisBookingSchedules) === null || ref === void 0 ? void 0 : ref.length)) {
            return false;
        }
        return DoctorService/* default.getIsBookingAvailable */.Z.getIsBookingAvailable(doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.diagnosisBookingSchedules, isNonF2FDiagnosis(), doctorDetail.doctor.isF2FBookable, doctorDetail.doctor.isNonF2FBookable, doctorDetail.doctor.isNonF2FNonBenefitBookable);
    };
    var onClickTab = function(props) {
        setSelectedTab(props.value);
        router.replace("#".concat(props.value), undefined, {
            scroll: false
        });
    };
    var getTabName = function(tabType, fallbackLabel) {
        var _obj;
        var tabNameMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, lib/* DoctorDetailTabType.DoctorProfile */.D.DoctorProfile, "의사 정보"), (0,_define_property/* default */.Z)(_obj, lib/* DoctorDetailTabType.NonBenefitPrice */.D.NonBenefitPrice, "진료비"), (0,_define_property/* default */.Z)(_obj, lib/* DoctorDetailTabType.BenefitPrice */.D.BenefitPrice, "진료비"), (0,_define_property/* default */.Z)(_obj, lib/* DoctorDetailTabType.Review */.D.Review, "진료 후기"), (0,_define_property/* default */.Z)(_obj, lib/* DoctorDetailTabType.Question */.D.Question, "질문"), (0,_define_property/* default */.Z)(_obj, lib/* DoctorDetailTabType.VaccinationPrice */.D.VaccinationPrice, "진료비"), _obj);
        var _tabType;
        return (_tabType = tabNameMap[tabType]) !== null && _tabType !== void 0 ? _tabType : fallbackLabel;
    };
    var goToReview = function() {
        onClickTab({
            label: "진료 후기",
            value: lib/* DoctorDetailTabType.Review */.D.Review
        });
    };
    var getCareerDisplayText = function(career) {
        switch(career.type){
            case types_doctor/* CareerType.Current */.gO.Current:
                return "현 ".concat(career.content);
            case types_doctor/* CareerType.Completion */.gO.Completion:
                return "".concat(career.content, " 수료");
            case types_doctor/* CareerType.Past */.gO.Past:
                return "전 ".concat(career.content);
            case types_doctor/* CareerType.Graduation */.gO.Graduation:
                return "".concat(career.content, " 졸업");
        }
    };
    var getNonBenefitPriceCategories = function() {
        var ref;
        if (!doctorDetail || !((ref = doctorDetail.nonBenefitTreatments) === null || ref === void 0 ? void 0 : ref.length)) {
            return [];
        }
        var categories = (0,_to_consumable_array/* default */.Z)(doctorDetail.nonBenefitTreatments);
        // 대면진료 + 다이어트 카테고리로 진입한 경우, 다이어트 카테고리만 노출
        if (isF2FDiagnosis() && isDietCategory) {
            var dietOnly = categories.filter(function(category) {
                return DiagnosisCategoryService/* default.isDietCategory */.ZP.isDietCategory(category.id);
            });
            return (0,_to_consumable_array/* default */.Z)(dietOnly.map(function(treatment) {
                return new NonBenefitTreatmentPriceCategory(treatment.name, treatment.id);
            }));
        }
        if (categoryId) {
            categories.sort(function(category) {
                return category.id === categoryId ? -1 : 1;
            });
        }
        return (0,_to_consumable_array/* default */.Z)(categories.map(function(treatment) {
            return new NonBenefitTreatmentPriceCategory(treatment.name, treatment.id);
        }));
    };
    var selectNonBenefitPriceCategory = function(category) {
        setSelectedNonBenefitTreatmentCategory(category);
    };
    var isCategorySelected = function(category) {
        return Boolean((selectedNonBenefitTreatmentPriceCategory === null || selectedNonBenefitTreatmentPriceCategory === void 0 ? void 0 : selectedNonBenefitTreatmentPriceCategory.id) === category.id);
    };
    var getNonBenefitTreatmentPriceList = function() {
        var ref, ref1;
        if (!doctorDetail || !((ref = doctorDetail.nonBenefitTreatments) === null || ref === void 0 ? void 0 : ref.length)) {
            return [];
        }
        var treatments = ((ref1 = doctorDetail.nonBenefitTreatments) === null || ref1 === void 0 ? void 0 : ref1.filter(function(treatment) {
            return treatment.id === (selectedNonBenefitTreatmentPriceCategory === null || selectedNonBenefitTreatmentPriceCategory === void 0 ? void 0 : selectedNonBenefitTreatmentPriceCategory.id);
        }).map(function(treatment) {
            return (0,non_benefit/* mapTreatmentWithPriceType */.tI)(treatment, isWithDispensation);
        })) || [];
        return (0,non_benefit/* groupAndSortTreatmentsByIngredientAndDosage */.wC)(treatments);
    };
    var getNonBenefitTreatmentPriceListByCategory = function(category) {
        var ref;
        if (!doctorDetail || !((ref = doctorDetail.nonBenefitTreatments) === null || ref === void 0 ? void 0 : ref.length)) {
            return [];
        }
        var treatments;
        if (!category) {
            treatments = doctorDetail.nonBenefitTreatments.map(function(treatment) {
                return (0,non_benefit/* mapTreatmentWithPriceType */.tI)(treatment, isWithDispensation);
            });
        } else {
            var ref1;
            treatments = ((ref1 = doctorDetail.nonBenefitTreatments) === null || ref1 === void 0 ? void 0 : ref1.filter(function(treatment) {
                return treatment.id === category.id;
            }).map(function(treatment) {
                return (0,non_benefit/* mapTreatmentWithPriceType */.tI)(treatment, isWithDispensation);
            })) || [];
        }
        return (0,non_benefit/* groupAndSortTreatmentsByIngredientAndDosage */.wC)(treatments);
    };
    var isDietCategoryFor = function(category) {
        if (!(category === null || category === void 0 ? void 0 : category.id)) return false;
        return isDietCategory;
    };
    var togglePointPrice = function() {
        setIsPointPriceVisible(!isPointPriceVisible);
    };
    var getDoctorDisplayName = function(name, medicineType) {
        if (medicineType === gql_schema/* MedicineType.OrientalDoctor */.UH9.OrientalDoctor) {
            return "".concat(name, " 한의사");
        }
        return "".concat(name, " 의사");
    };
    var getReviewStatisticGroupsForSummary = function() {
        if (!(doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.doctorDiagnosisTypeReviewRatingStatistics)) {
            return [];
        }
        var sortedReviewsStatistics = (0,_to_consumable_array/* default */.Z)(doctorDetail.doctorDiagnosisTypeReviewRatingStatistics).sort(function(prev, next) {
            if (prev.diagnosisTypeId === categoryId && prev.diagnosisType === (type === null || type === void 0 ? void 0 : type.toUpperCase())) {
                return -1;
            }
            if (Number(prev.averageRating) < Number(next.averageRating)) {
                return 1;
            }
            if (Number(prev.averageRating) > Number(next.averageRating)) {
                return -1;
            }
            return 0;
        });
        return sortedReviewsStatistics.slice(0, 3);
    };
    var getDisplayAverageRating = function() {
        if (!doctorDetail) {
            return "0";
        }
        return "".concat(doctorDetail.doctor.averageRating.toFixed(1));
    };
    var stringifyReviewCount = function(count) {
        if (count <= 100) {
            return "".concat(count);
        }
        return "".concat(Math.floor(count / 100) * 100, "+");
    };
    var getDisplayReviewCount = function() {
        if (!doctorDetail) {
            return "0";
        }
        return stringifyReviewCount(doctorDetail.doctor.reviewCount);
    };
    var hasNoCareer = function() {
        if (!doctorDetail) {
            return true;
        }
        return doctorDetail.doctor.career.length === 0;
    };
    var hasNoBadge = function() {
        if (!doctorDetail) {
            return true;
        }
        return doctorDetail.badges.length === 0;
    };
    var hasNoNotice = function() {
        if (!doctorDetail) {
            return true;
        }
        return !doctorDetail.notice.title || !doctorDetail.notice.content;
    };
    var getCalculatedTabs = function() {
        return (0,lib/* calculateDoctorTabs */.S)({
            type: parseMedicalCategoryCategoryTypeOf(type),
            categoryId: categoryId,
            hasNonBenefitPriceCategories: getNonBenefitPriceCategories().length > 0,
            isNonBenefitCategory: isNonBenefitCategory,
            isWebTelemedicineFlow: true,
            isNonF2FDiagnosis: isNonF2FDiagnosis(),
            isDietCategory: isDietCategory
        });
    };
    var getTabs = function() {
        if (!doctorDetail) {
            return [];
        }
        return getCalculatedTabs();
    };
    var getDoctorBookingStatus = function() {
        if (!(doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.diagnosisBookingSchedules.length)) {
            return types_doctor/* DoctorBookingStatus.BookingUnavailable */.CK.BookingUnavailable;
        }
        var today = dayjs_min_default()();
        var todaySchedule = doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.diagnosisBookingSchedules.find(function(schedule) {
            return today.isSame(schedule.targetDate, "date");
        });
        if ((todaySchedule === null || todaySchedule === void 0 ? void 0 : todaySchedule.status) === types_doctor/* BookingScheduleStatus.Bookable */.Uc.Bookable) {
            return types_doctor/* DoctorBookingStatus.TodayBookable */.CK.TodayBookable;
        }
        var tomorrow = dayjs_min_default()().add(1, "day");
        var tomorrowSchedule = doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.diagnosisBookingSchedules.find(function(schedule) {
            return tomorrow.isSame(schedule.targetDate, "date");
        });
        if ((tomorrowSchedule === null || tomorrowSchedule === void 0 ? void 0 : tomorrowSchedule.status) === types_doctor/* BookingScheduleStatus.Bookable */.Uc.Bookable) {
            return types_doctor/* DoctorBookingStatus.TomorrowBookable */.CK.TomorrowBookable;
        }
        return types_doctor/* DoctorBookingStatus.BookingUnavailable */.CK.BookingUnavailable;
    };
    var getDoctorBookingStatusText = function(status) {
        switch(status){
            case types_doctor/* DoctorBookingStatus.BookingUnavailable */.CK.BookingUnavailable:
                return "예약 마감";
            case types_doctor/* DoctorBookingStatus.TodayBookable */.CK.TodayBookable:
                return "오늘 예약";
            case types_doctor/* DoctorBookingStatus.TomorrowBookable */.CK.TomorrowBookable:
                return "내일 예약";
        }
    };
    var getHospitalAddress = function() {
        var ref;
        if (!doctorDetail) {
            return "";
        }
        if ((ref = doctorDetail.hospital) === null || ref === void 0 ? void 0 : ref.detailAddress) {
            return "".concat(doctorDetail.hospital.roadAddress, ", ").concat(doctorDetail.hospital.detailAddress);
        } else {
            var ref1;
            return ((ref1 = doctorDetail.hospital) === null || ref1 === void 0 ? void 0 : ref1.roadAddress) || "";
        }
    };
    var getDoctorTreatments = function() {
        if (!doctorDetail) {
            return [];
        }
        var treatments = (0,_to_consumable_array/* default */.Z)(doctorDetail.treatments);
        if (type == medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT) {
            treatments.sort(function(treatment) {
                return treatment.treatmentId === categoryId ? -1 : 1;
            });
        }
        return treatments;
    };
    var getDoctorDuties = function() {
        if (!doctorDetail) {
            return [];
        }
        if (contactType === types_diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F) {
            return doctorDetail.doctor.doctorDuties.nonF2f;
        }
        if (contactType === types_diagnosis/* EDiagnosisContactType.F2F */.d.F2F) {
            return doctorDetail.doctor.doctorDuties.f2f;
        }
        return [];
    };
    var callHospital = function() {
        if (!doctorDetail || !doctorDetail.hospital.tel) {
            return;
        }
        window.location.href = "tel:".concat(doctorDetail.hospital.tel);
    };
    var isNonF2FDiagnosis = function() {
        return contactType === types_diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F;
    };
    var isF2FDiagnosis = function() {
        return contactType === types_diagnosis/* EDiagnosisContactType.F2F */.d.F2F;
    };
    var shouldShowPointTermInfo = function() {
        return getNonBenefitPriceCategories().length !== 0;
    };
    var shouldShowNonBenefitCategoryHeader = function() {
        if (isF2FDiagnosis()) {
            return false;
        }
        return getNonBenefitPriceCategories().length !== 2; // [전체, 과목] 이렇게 있는경우가 있어 2로 지정
    };
    var isVisibleTodayDiagnosisSlotSelectBox = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!(doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.diagnosisBookingSchedules)) return;
        // 예약 받기 off
        if (!(doctorDetail === null || doctorDetail === void 0 ? void 0 : (ref = doctorDetail.diagnosisBookingSchedules) === null || ref === void 0 ? void 0 : ref.length)) return;
        var isEnabledDiagnosisRequest = doctorDetail === null || doctorDetail === void 0 ? void 0 : (ref1 = doctorDetail.diagnosisBookingSchedules) === null || ref1 === void 0 ? void 0 : ref1.some(function(schedule) {
            return schedule.status === types_doctor/* BookingScheduleStatus.Bookable */.Uc.Bookable;
        });
        return isEnabledDiagnosisRequest;
    }, [
        doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.diagnosisBookingSchedules
    ]);
    var shouldShowTreatmentSection = function() {
        if (!doctorDetail) {
            return false;
        }
        return doctorDetail.treatments.length > 0;
    };
    var getBenefitPriceSectionTitle = function() {
        if (type === medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT) {
            var department = doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.doctor.departments.find(function(dept) {
                return dept.id === categoryId;
            });
            return (department === null || department === void 0 ? void 0 : department.name) || "";
        }
        var treatment = doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.treatments.find(function(treat) {
            return treat.treatmentId === categoryId;
        });
        return (treatment === null || treatment === void 0 ? void 0 : treatment.treatmentName) || "";
    };
    (0,react.useEffect)(function() {
        if (isDoctorDetailLoading) {
            return;
        }
        if (!window.location.hash) {
            return;
        }
        if (document.readyState !== "complete") {
            return;
        }
        var elementId = window.location.hash.substring(1);
        var element = document.getElementById(elementId);
        if (element) {
            setTimeout(function() {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }, 200); // 시간에 따라 탭 이동이 안되는 경우가 있어서 200ms로 변경 (refactoring)
        }
    }, [
        isDoctorDetailLoading
    ]);
    (0,react.useEffect)(function() {
        if (!router) {
            return;
        }
        if (false) {}
        if (!window.location.hash) {
            return;
        }
        var tabType = window.location.hash.substring(1);
        setSelectedTab(tabType);
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        var onScroll = function() {
            if (window.scrollY >= DOCTOR_PROFILE_IMAGE_HEIGHT - theme/* default.size.mobileWebHeader.height */.Z.size.mobileWebHeader.height) {
                return setIsHeaderTransparent(false);
            }
            return setIsHeaderTransparent(true);
        };
        document.getElementsByTagName("html")[0].style.scrollBehavior = "smooth";
        window.addEventListener("scroll", onScroll);
        return function() {
            document.getElementsByTagName("html")[0].style.scrollBehavior = "";
            window.removeEventListener("scroll", onScroll);
        };
    }, []);
    (0,react.useEffect)(function() {
        var tabs = getCalculatedTabs();
        setSelectedTab(tabs[0].value);
    }, [
        doctorDetail
    ]);
    (0,react.useEffect)(function() {
        if (isDoctorDetailLoading) {
            return;
        }
        if (isNeedReview) {
            goToReview();
        }
    }, [
        isNeedReview,
        isDoctorDetailLoading
    ]);
    return {
        selectedTab: selectedTab,
        doctorDetail: doctorDetail,
        treatmentRequestDoctor: treatmentRequestDoctor,
        isOperationTimeTableOpened: isOperationTimeTableOpened,
        isPointPriceVisible: isPointPriceVisible,
        isLoggedIn: loginViewModel.isLoggedIn,
        isHeaderTransparent: isHeaderTransparent,
        isNonBenefitCategory: isNonBenefitCategory,
        isVisibleTodayDiagnosisSlotSelectBox: isVisibleTodayDiagnosisSlotSelectBox,
        isDoctorDetailLoading: isDoctorDetailLoading,
        isGoBackConfirmAlertOpened: isGoBackConfirmAlertOpened,
        isWithDispensation: isWithDispensation,
        diagnosisContactType: diagnosisContactType,
        contactType: contactType,
        isFamilyDoctor: isFamilyDoctor,
        handleUpdateFamilyDoctor: handleUpdateFamilyDoctor,
        categoryId: categoryId,
        diagnosisType: type,
        doctorPublicId: doctorPublicId,
        getDoctorTreatments: getDoctorTreatments,
        shouldShowTreatmentSection: shouldShowTreatmentSection,
        isNonF2FDiagnosis: isNonF2FDiagnosis,
        onClickTab: onClickTab,
        getTabName: getTabName,
        getTabs: getTabs,
        goToReview: goToReview,
        toggleOperationTimeTable: toggleOperationTimeTable,
        getCareerDisplayText: getCareerDisplayText,
        getNonBenefitPriceCategories: getNonBenefitPriceCategories,
        isCategorySelected: isCategorySelected,
        selectNonBenefitPriceCategory: selectNonBenefitPriceCategory,
        getNonBenefitTreatmentPriceList: getNonBenefitTreatmentPriceList,
        togglePointPrice: togglePointPrice,
        getNonBenefitTreatmentPriceListByCategory: getNonBenefitTreatmentPriceListByCategory,
        isDietCategoryFor: isDietCategoryFor,
        toggleWithDispensation: toggleWithDispensation,
        getDoctorDisplayName: getDoctorDisplayName,
        getReviewStatisticGroupsForSummary: getReviewStatisticGroupsForSummary,
        getDisplayAverageRating: getDisplayAverageRating,
        getDisplayReviewCount: getDisplayReviewCount,
        getDoctorDuties: getDoctorDuties,
        hasNoCareer: hasNoCareer,
        hasNoBadge: hasNoBadge,
        hasNoNotice: hasNoNotice,
        getIsBookingAvailable: getIsBookingAvailable,
        getDoctorBookingStatus: getDoctorBookingStatus,
        getDoctorBookingStatusText: getDoctorBookingStatusText,
        callHospital: callHospital,
        getHospitalAddress: getHospitalAddress,
        shouldShowPointTermInfo: shouldShowPointTermInfo,
        shouldShowNonBenefitCategoryHeader: shouldShowNonBenefitCategoryHeader,
        isF2FDiagnosis: isF2FDiagnosis,
        openGoBackConfirmAlert: openGoBackConfirmAlert,
        closeGoBackConfirmAlert: closeGoBackConfirmAlert,
        getBenefitPriceSectionTitle: getBenefitPriceSectionTitle
    };
};
/* harmony default export */ var hooks_useDoctorDetailViewModel = (useDoctorDetailViewModel);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/DoctorDetailInfo.tsx


















var DoctorDetailInfo = function(param) {
    var client = param.client, handleSelectDoctor = param.handleSelectDoctor, scrollContainerRef = param.scrollContainerRef;
    var ref;
    var doctorDetailViewModel = hooks_useDoctorDetailViewModel();
    var doctorReviewsViewModel = (0,reviews/* useDoctorReviewsViewModel */.FJ)();
    var ref1 = (0,useReviewReportModal/* default */.Z)(), showReportModal = ref1.showReportModal, onCloseReportModal = ref1.onCloseReportModal, reportItems = ref1.reportItems;
    var calculateScrollDepth = function() {
        if (!(scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current)) return 0;
        var container = scrollContainerRef.current;
        var scrollTop = container.scrollTop;
        var scrollHeight = container.scrollHeight;
        var clientHeight = container.clientHeight;
        var maxScroll = scrollHeight - clientHeight;
        if (maxScroll <= 0) return 0;
        var depth = Math.round(scrollTop / maxScroll * 100);
        return Math.min(Math.max(depth, 0), 100);
    };
    var onSelectDoctorByWebTelemedicine = function() {
        handleSelectDoctor === null || handleSelectDoctor === void 0 ? void 0 : handleSelectDoctor(doctorDetailViewModel.treatmentRequestDoctor, doctorDetailViewModel.doctorPublicId, doctorDetailViewModel.doctorDetail);
    };
    var renderDoctorInfoSections = function() {
        return doctorDetailViewModel.getTabs().map(function(tab) {
            switch(tab.value){
                case lib/* DoctorDetailTabType.BenefitPrice */.D.BenefitPrice:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detail/* BenefitPrice */.Ob, {
                        title: doctorDetailViewModel.getBenefitPriceSectionTitle()
                    }, tab.value);
                case lib/* DoctorDetailTabType.NonBenefitPrice */.D.NonBenefitPrice:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detail/* NonBenefitPrice */.hC, {
                        getNonBenefitPriceCategories: doctorDetailViewModel.getNonBenefitPriceCategories,
                        isCategorySelected: doctorDetailViewModel.isCategorySelected,
                        isLoggedIn: doctorDetailViewModel.isLoggedIn,
                        isPointPriceVisible: doctorDetailViewModel.isPointPriceVisible,
                        togglePointPrice: doctorDetailViewModel.togglePointPrice,
                        isWithDispensation: doctorDetailViewModel.isWithDispensation,
                        toggleWithDispensation: doctorDetailViewModel.toggleWithDispensation,
                        shouldShowPointTermInfo: doctorDetailViewModel.shouldShowPointTermInfo,
                        getNonBenefitTreatmentPriceListByCategory: doctorDetailViewModel.getNonBenefitTreatmentPriceListByCategory,
                        isDietCategoryFor: doctorDetailViewModel.isDietCategoryFor
                    }, tab.value);
                case lib/* DoctorDetailTabType.DoctorProfile */.D.DoctorProfile:
                    var ref, ref1, ref2, ref3;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detail/* DoctorIntroduction */.Xc, {
                        hasNoNotice: doctorDetailViewModel.hasNoNotice,
                        hasNoBadge: doctorDetailViewModel.hasNoBadge,
                        hasNoCareer: doctorDetailViewModel.hasNoCareer,
                        notice: (ref = doctorDetailViewModel.doctorDetail) === null || ref === void 0 ? void 0 : ref.notice,
                        badges: (ref1 = doctorDetailViewModel.doctorDetail) === null || ref1 === void 0 ? void 0 : ref1.badges,
                        doctor: (ref2 = doctorDetailViewModel.doctorDetail) === null || ref2 === void 0 ? void 0 : ref2.doctor,
                        getCareerDisplayText: doctorDetailViewModel.getCareerDisplayText,
                        doctorTreatments: doctorDetailViewModel.getDoctorTreatments(),
                        doctorDuties: doctorDetailViewModel.getDoctorDuties(),
                        callHospital: doctorDetailViewModel.callHospital,
                        shouldShowTreatmentSection: doctorDetailViewModel.shouldShowTreatmentSection,
                        hospital: (ref3 = doctorDetailViewModel.doctorDetail) === null || ref3 === void 0 ? void 0 : ref3.hospital,
                        diagnosisContactType: doctorDetailViewModel.diagnosisContactType,
                        openMap: function() {}
                    }, tab.value);
                case lib/* DoctorDetailTabType.Review */.D.Review:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detail/* DoctorReview */.Qg, {
                        isMobile: client.isMobile,
                        doctorReviewsViewModel: doctorReviewsViewModel,
                        shouldShowAllReviewsButton: false
                    }, tab.value);
                default:
                    return null;
            }
        });
    };
    if (doctorDetailViewModel.isDoctorDetailLoading || !doctorDetailViewModel.doctorDetail) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                        isAbsolute: true,
                        backgroundColor: "transparent"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Content */.Z.Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detail/* DoctorDetailSkeleton */.oN, {})
                })
            ]
        });
    }
    var _departments, _id, _id1, _name, _categoryId, _diagnosisType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-h-[calc(100vh-60px)]",
                    children: [
                        !client.isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-[40px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-[12px] self-stretch pb-[32px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorProfile/* default */.Z, {
                                        profileImageUrl: doctorDetailViewModel.doctorDetail.doctor.profileImageUrl,
                                        hospitalName: doctorDetailViewModel.doctorDetail.hospital.name,
                                        doctorName: doctorDetailViewModel.doctorDetail.doctor.name,
                                        doctorMedicineType: doctorDetailViewModel.doctorDetail.doctor.medicineType,
                                        isFamilyDoctor: doctorDetailViewModel.isFamilyDoctor,
                                        doctorId: doctorDetailViewModel.doctorDetail.doctor.id,
                                        handleUpdateFamilyDoctor: doctorDetailViewModel.handleUpdateFamilyDoctor,
                                        getDoctorDisplayName: doctorDetailViewModel.getDoctorDisplayName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-[24px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorReviewAndDepartments/* default */.Z, {
                                            doctorDetail: doctorDetailViewModel.doctorDetail,
                                            doctorDepartments: (_departments = (ref = doctorDetailViewModel.doctorDetail) === null || ref === void 0 ? void 0 : ref.doctor.departments) !== null && _departments !== void 0 ? _departments : [],
                                            totalReviewCount: doctorReviewsViewModel.totalCount,
                                            hasReview: doctorReviewsViewModel.hasReview,
                                            getDisplayAverageRating: doctorDetailViewModel.getDisplayAverageRating,
                                            goToReview: doctorDetailViewModel.goToReview
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "sticky top-0 z-[2] bg-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dnslide_tab/* default */.Z, {
                                value: doctorDetailViewModel.selectedTab,
                                children: doctorDetailViewModel.getTabs().map(function(tab) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                        params: {
                                            eventName: tab.value === lib/* DoctorDetailTabType.Review */.D.Review ? doctor/* DoctorDetailLog.DOCTOR_DETAIL_REVIEW_CLICK */.d.DOCTOR_DETAIL_REVIEW_CLICK : doctor/* DoctorDetailLog.DOCTOR_DETAIL_INFO_CLICK */.d.DOCTOR_DETAIL_INFO_CLICK,
                                            payload: {
                                                tabName: doctorDetailViewModel.getTabName(tab.value, tab.label),
                                                tabValue: tab.value,
                                                doctorId: (_id = (ref = doctorDetailViewModel.doctorDetail) === null || ref === void 0 ? void 0 : ref.doctor.id) !== null && _id !== void 0 ? _id : ""
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dnslide_tab/* default.Item */.Z.Item, {
                                            label: tab.label,
                                            isActive: tab.value === doctorDetailViewModel.selectedTab,
                                            onClick: function() {
                                                return doctorDetailViewModel.onClickTab(tab);
                                            }
                                        })
                                    }, tab.key);
                                })
                            })
                        }),
                        renderDoctorInfoSections(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(report_select_modal/* default */.Z, {
                            isVisible: showReportModal,
                            selectList: reportItems,
                            onClose: onCloseReportModal
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                        params: {
                            eventName: libs/* EWebTreatmentRequestLog.ClickTelemedicineRequestInDoctorDetail */.o5.ClickTelemedicineRequestInDoctorDetail,
                            payload: function() {
                                var ref, ref1;
                                return {
                                    doctorId: (_id1 = (ref = doctorDetailViewModel.doctorDetail) === null || ref === void 0 ? void 0 : ref.doctor.id) !== null && _id1 !== void 0 ? _id1 : "",
                                    doctorName: (_name = (ref1 = doctorDetailViewModel.doctorDetail) === null || ref1 === void 0 ? void 0 : ref1.doctor.name) !== null && _name !== void 0 ? _name : "",
                                    scrollDepth: calculateScrollDepth(),
                                    categoryId: (_categoryId = doctorDetailViewModel.categoryId) !== null && _categoryId !== void 0 ? _categoryId : "",
                                    diagnosisType: (_diagnosisType = doctorDetailViewModel.diagnosisType) !== null && _diagnosisType !== void 0 ? _diagnosisType : ""
                                };
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                                    size: "xl",
                                    onClick: onSelectDoctorByWebTelemedicine,
                                    children: [
                                        doctorDetailViewModel.doctorDetail.doctor.name,
                                        " 의사에게 진료받기"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "typography-ui-13m w-full pt-[12px] text-center text-gray-400",
                                    children: "진료가 끝나기 전에는 진료비가 결제되지 않아요"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ui_DoctorDetailInfo = (DoctorDetailInfo);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/DoctorDetailBottomSheet.tsx










var DoctorDetailBottomSheet = function(param) {
    var isOpen = param.isOpen, client = param.client, onClose = param.onClose, handleSelectDoctor = param.handleSelectDoctor, isEnabledScheduleAlertOpen = param.isEnabledScheduleAlertOpen, selectedStartDisplayTimeSlot = param.selectedStartDisplayTimeSlot, selectedDoctorDetail = param.selectedDoctorDetail, onCloseIsEnabledScheduleAlert = param.onCloseIsEnabledScheduleAlert;
    var router = (0,next_router.useRouter)();
    var doctorId = router.query.doctorId;
    var scrollContainerRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Drawer.Root */.dy.Root, {
                open: isOpen,
                dismissible: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Title */.dy.Title, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Portal */.dy.Portal, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Content */.dy.Content, {
                            className: "fixed right-0 bottom-0 left-0 z-[261] mx-auto h-full w-full bg-white transition-opacity duration-500",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                ref: scrollContainerRef,
                                className: "h-full overflow-y-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                        params: {
                                            eventName: libs/* EWebTreatmentRequestLog.CloseDoctorDetail */.o5.CloseDoctorDetail,
                                            payload: {
                                                doctorId: doctorId !== null && doctorId !== void 0 ? doctorId : ""
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex w-full justify-end p-[14px_16px]",
                                            onClick: onClose,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "p-[4px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "close"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DoctorDetailInfo, {
                                        client: client,
                                        handleSelectDoctor: handleSelectDoctor,
                                        scrollContainerRef: scrollContainerRef
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Alert */.bZ, {
                type: "single",
                title: "".concat(selectedStartDisplayTimeSlot, " 예약이 마감되었어요."),
                description: "".concat(selectedDoctorDetail === null || selectedDoctorDetail === void 0 ? void 0 : selectedDoctorDetail.doctor.name, " 의사의 ").concat(selectedStartDisplayTimeSlot, " 진료 예약이 마감 되었어요. 다른 의사를 선택해주세요."),
                open: isEnabledScheduleAlertOpen,
                buttons: [
                    {
                        label: "의사 다시 선택",
                        onClick: onCloseIsEnabledScheduleAlert
                    }, 
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_DoctorDetailBottomSheet = (DoctorDetailBottomSheet);

;// CONCATENATED MODULE: ./src/models/diagnosis/doctor-filter.ts

var EDoctorFilterType;
(function(EDoctorFilterType) {
    EDoctorFilterType["SPECIALIST"] = "SPECIALIST";
    EDoctorFilterType["GOOD_REVIEW"] = "GOOD_REVIEW";
    EDoctorFilterType["MANY_REVIEW"] = "MANY_REVIEW";
    EDoctorFilterType["FAST_RESPONSE"] = "FAST_RESPONSE";
    EDoctorFilterType["PUNCTUAL"] = "PUNCTUAL";
    EDoctorFilterType["HIGH_RETURN_RATE"] = "HIGH_RETURN_RATE";
    EDoctorFilterType["LOW_CANCEL_RATE"] = "LOW_CANCEL_RATE";
})(EDoctorFilterType || (EDoctorFilterType = {}));
var DOCTOR_FILTER_OPTIONS = [
    {
        type: EDoctorFilterType.SPECIALIST,
        label: "전문의",
        description: "내 증상 전문의",
        iconName: "badge"
    },
    {
        type: EDoctorFilterType.GOOD_REVIEW,
        label: "후기 좋음",
        description: "후기 평균 4.7 이상",
        iconName: "thumb_up"
    },
    {
        type: EDoctorFilterType.MANY_REVIEW,
        label: "후기 많음",
        description: "후기 200개 이상",
        iconName: "chat"
    },
    {
        type: EDoctorFilterType.FAST_RESPONSE,
        label: "응답 빠름",
        description: "진료 신청 3분 내 응답",
        iconName: "electric_bolt"
    },
    {
        type: EDoctorFilterType.PUNCTUAL,
        label: "시간 잘 지킴",
        description: "진료 지각율 5% 이하",
        iconName: "alarm_on"
    },
    {
        type: EDoctorFilterType.HIGH_RETURN_RATE,
        label: "재진율 높음",
        description: "재진율 40% 이상",
        iconName: "heart_smile"
    },
    {
        type: EDoctorFilterType.LOW_CANCEL_RATE,
        label: "취소율 낮음",
        description: "진료 취소율 3% 이하",
        iconName: "preliminary"
    }, 
];
var MAX_FILTER_SELECTION = 3;
var getSpecialistOnlyFromFilters = function(filters) {
    if (filters.length === 0) {
        return false;
    }
    return filters.includes(EDoctorFilterType.SPECIALIST);
};
var getHighReviewRatingFromFilters = function(filters) {
    return filters.includes(EDoctorFilterType.GOOD_REVIEW);
};
var getHighReviewCountFromFilters = function(filters) {
    return filters.includes(EDoctorFilterType.MANY_REVIEW);
};
var getLoadingMessageByFilterType = function(filterType, categoryName) {
    var displayCategoryName = categoryName || "증상/과목";
    var _obj;
    var loadingMessageMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, EDoctorFilterType.SPECIALIST, "".concat(displayCategoryName, "을(를) 전문으로 하는 의사 찾는 중...")), (0,_define_property/* default */.Z)(_obj, EDoctorFilterType.GOOD_REVIEW, "후기 좋은 의사 찾는 중..."), (0,_define_property/* default */.Z)(_obj, EDoctorFilterType.MANY_REVIEW, "후기 많은 의사 찾는 중..."), (0,_define_property/* default */.Z)(_obj, EDoctorFilterType.FAST_RESPONSE, "응답 빠른 의사 찾는 중..."), (0,_define_property/* default */.Z)(_obj, EDoctorFilterType.PUNCTUAL, "진료 시간 잘 지키는 의사 찾는 중..."), (0,_define_property/* default */.Z)(_obj, EDoctorFilterType.HIGH_RETURN_RATE, "재진율 높은 의사 찾는 중..."), (0,_define_property/* default */.Z)(_obj, EDoctorFilterType.LOW_CANCEL_RATE, "취소율 낮은 의사 찾는 중..."), _obj);
    return loadingMessageMap[filterType];
};

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/DoctorFilterOptionButton.tsx



var DoctorFilterOptionButton = function(param) {
    var option = param.option, isSelected = param.isSelected, canSelectMore = param.canSelectMore, onToggle = param.onToggle;
    var isDisabled = !isSelected && !canSelectMore;
    var handleClick = function() {
        if (isDisabled) {
            return;
        }
        onToggle(option.type);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: handleClick,
        disabled: isDisabled,
        className: "flex flex-col gap-[4px] rounded-[12px] border-[1px] border-solid p-[16px] transition-all ".concat(isSelected ? "border-primary-600 bg-[#fff9f5]" : isDisabled ? "cursor-not-allowed border-gray-100 bg-white opacity-40" : "border-gray-100 bg-white"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col items-start",
            children: [
                option.iconName && /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                    name: option.iconName,
                    size: 24,
                    color: theme/* default.color.primary700 */.Z.color.primary700,
                    filled: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "typography-ui-15sb mt-[4px] text-gray-900 leading-[22px]",
                    children: option.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "typography-ui-13r text-gray-500 leading-[18px]",
                    children: option.description
                })
            ]
        })
    });
};
/* harmony default export */ var ui_DoctorFilterOptionButton = (DoctorFilterOptionButton);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/DoctorFilterSelectionStep.tsx









var DoctorFilterSelectionStep = function(param) {
    var selectedFilters = param.selectedFilters, onToggleFilter = param.onToggleFilter, onNext = param.onNext;
    var selectedCount = selectedFilters.length;
    var isNextButtonDisabled = selectedCount === 0;
    var canSelectMore = selectedCount < MAX_FILTER_SELECTION;
    var isFilterSelected = function(filterType) {
        return selectedFilters.includes(filterType);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex h-full flex-col pb-[160px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-[24px] pt-[12px] pb-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-semibold text-[24px] text-gray-900 leading-[32px]",
                    children: "어떤 의사를 선호하시나요?"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1 overflow-y-auto px-[20px] py-[40px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-2 gap-[16px]",
                    children: DOCTOR_FILTER_OPTIONS.map(function(option) {
                        var isSelected = isFilterSelected(option.type);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: libs/* EWebTreatmentRequestLog.ClickDoctorFilterOption */.o5.ClickDoctorFilterOption,
                                payload: {
                                    filterType: option.type,
                                    isSelected: isSelected ? "true" : "false"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DoctorFilterOptionButton, {
                                option: option,
                                isSelected: isSelected,
                                canSelectMore: canSelectMore,
                                onToggle: onToggleFilter
                            })
                        }, option.type);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,style.cn)([
                    "fixed right-0 bottom-0 left-0 z-50 mx-auto w-full max-w-[600px]",
                    "desktop:absolute desktop:max-w-none", 
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,style.cn)([
                        "pointer-events-auto mx-auto flex w-full max-w-[600px] flex-col items-center justify-center bg-white px-[20px] pb-[16px]",
                        "desktop:max-w-none", 
                    ]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-[16px] flex items-center justify-center gap-[4px]",
                            children: [
                                selectedCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                            name: "check_circle",
                                            size: 14,
                                            color: theme/* default.color.green600 */.Z.color.green600,
                                            filled: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "font-medium text-[#40c057] text-[13px] leading-[18px]",
                                            children: [
                                                selectedCount,
                                                "개 선택"
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-medium text-[13px] text-gray-400 leading-[18px]",
                                    children: "0개 선택"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-medium text-[12px] text-gray-100 leading-[18px]",
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "font-medium text-[13px] text-gray-400 leading-[18px]",
                                    children: [
                                        "최대 ",
                                        MAX_FILTER_SELECTION,
                                        "개"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: libs/* EWebTreatmentRequestLog.ClickNextFromDoctorFilter */.o5.ClickNextFromDoctorFilter,
                                payload: {
                                    selectedCount: selectedCount
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                buttonColor: "primary",
                                size: "xl",
                                disabled: isNextButtonDisabled,
                                onClick: onNext,
                                className: "w-full",
                                children: "다음"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_DoctorFilterSelectionStep = (DoctorFilterSelectionStep);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/MaleGuideBottomSheet.tsx


var MaleGuideBottomSheet = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BottomSheet */.R1, {
        type: "single",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "발기부전약은",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "비대면 처방이 어려워요"
            ]
        }),
        description: "전립선, 염증 등 다른 증상은 비대면 진료가 가능해요.",
        open: isOpen,
        onOpenChange: function(open) {
            if (!open) {
                onClose();
            }
        },
        buttons: [
            {
                label: "확인했어요",
                variant: "primary",
                onClick: onClose
            }, 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://media.doctornow.co.kr/web_diagnosis_warning.webp",
                alt: "male guide",
                className: "h-[160px] w-[312px] object-contain"
            })
        })
    });
};
/* harmony default export */ var ui_MaleGuideBottomSheet = (MaleGuideBottomSheet);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/MaternityGuideBottomSheet.tsx


var MaternityGuideBottomSheet = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BottomSheet */.R1, {
        type: "vertical",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "사후피임약은",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "비대면 처방이 어려워요"
            ]
        }),
        description: "질염, 생리통 등 다른 증상은 비대면 진료가 가능해요!",
        open: isOpen,
        onOpenChange: function(open) {
            if (!open) {
                onClose();
            }
        },
        buttons: [
            {
                label: "확인했어요",
                variant: "primary",
                onClick: onClose
            }, 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://media.doctornow.co.kr/web_diagnosis_warning.webp",
                alt: "contraceptive guide",
                className: "h-[160px] w-[312px] object-contain"
            })
        })
    });
};
/* harmony default export */ var ui_MaternityGuideBottomSheet = (MaternityGuideBottomSheet);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/MentalHealthGuideBottomSheet.tsx


var MentalHealthGuideBottomSheet = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BottomSheet */.R1, {
        type: "single",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "향정신성의약품, 마약류는",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "비대면 처방이 어려워요"
            ]
        }),
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "향정신성의약품, 마약류, 오남용우려의약품으로",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "분류된 약품을 제외한 약은 비대면 처방이 가능해요."
            ]
        }),
        open: isOpen,
        onOpenChange: function(open) {
            if (!open) {
                onClose();
            }
        },
        buttons: [
            {
                label: "확인했어요",
                variant: "primary",
                onClick: onClose
            }, 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://media.doctornow.co.kr/web_diagnosis_warning.webp",
                alt: "mental health guide",
                className: "h-[160px] w-[312px] object-contain"
            })
        })
    });
};
/* harmony default export */ var ui_MentalHealthGuideBottomSheet = (MentalHealthGuideBottomSheet);

// EXTERNAL MODULE: ./src/components/molecules/loader/index.tsx + 1 modules
var loader = __webpack_require__(8366);
// EXTERNAL MODULE: ./src/components/templates/diagnosis/treatment-request/components/RequestSection.tsx + 5 modules
var RequestSection = __webpack_require__(96713);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/CardInstallmentBottomSheet.tsx

function CardInstallmentBottomSheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0 32px;\n"
    ]);
    CardInstallmentBottomSheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardInstallmentBottomSheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 500px;\n  overflow-y: scroll;\n"
    ]);
    CardInstallmentBottomSheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CardInstallmentBottomSheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > p {\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    CardInstallmentBottomSheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CardInstallmentBottomSheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: 56px;\n  padding: 16px 0px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  ",
        "\n"
    ]);
    CardInstallmentBottomSheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var CardInstallmentBottomSheet = function(props) {
    var open = props.open, title = props.title, list = props.list, onClick = props.onClick, getItemName = props.getItemName, isSelected = props.isSelected, onClose = props.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BottomSheet */.R1, {
        type: "single",
        title: title,
        open: open,
        onOpenChange: function(isOpen) {
            return !isOpen && onClose();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList, {
                children: list.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter, {
                        onClick: function() {
                            return onClick(item);
                        },
                        isSelected: isSelected && isSelected(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: getItemName(item)
                        })
                    }, "filter-".concat(getItemName(item)));
                })
            })
        })
    });
};
/* harmony default export */ var ui_CardInstallmentBottomSheet = (CardInstallmentBottomSheet);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17e79c25-0"
})(CardInstallmentBottomSheet_templateObject());
var FilterList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-17e79c25-1"
})(CardInstallmentBottomSheet_templateObject1());
var Filter = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-17e79c25-2"
})(CardInstallmentBottomSheet_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CardInstallmentBottomSheet_templateObject2(), theme.typography.UI16M, theme.color.gray800);
}, function(param) {
    var isSelected = param.isSelected;
    return "\n      ".concat(isSelected ? "background-color: ".concat(theme/* default.color.gray30 */.Z.color.gray30) : "background-color: ".concat(theme/* default.color.white */.Z.color.white), "; :\n      ");
});

// EXTERNAL MODULE: ./src/components/templates/card/register/CardRegisterTemplate.tsx + 6 modules
var CardRegisterTemplate = __webpack_require__(78798);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/CardRegisterBottomSheet.tsx





var CardRegisterBottomSheet = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onSuccessCardRegister = param.onSuccessCardRegister;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Drawer.Root */.dy.Root, {
        open: isOpen,
        dismissible: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Title */.dy.Title, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Portal */.dy.Portal, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Drawer.Content */.dy.Content, {
                    className: "fixed right-0 bottom-0 left-0 z-[261] mx-auto h-full w-full bg-white transition-opacity duration-500",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 left-0 z-[261] flex w-full justify-end p-[14px_16px]",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "p-[4px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                    name: "close"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-full overflow-y-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRegisterTemplate/* default */.Z, {
                                isWebTelemedicineFlow: true,
                                onSuccess: onSuccessCardRegister
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_CardRegisterBottomSheet = (CardRegisterBottomSheet);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/PaymentFormStep.tsx

function PaymentFormStep_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: calc(100dvh - 60px);\n  overflow-y: scroll;\n  padding-bottom: 140px;\n"
    ]);
    PaymentFormStep_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var PaymentFormStep = function(param) {
    var cardListWrapperRef = param.cardListWrapperRef, isUserPaymentsInfoRefetching = param.isUserPaymentsInfoRefetching, isUserPaymentsInfoFetched = param.isUserPaymentsInfoFetched, point = param.point, cardCompanyButton = param.cardCompanyButton, treatmentRequest = param.treatmentRequest, userPaymentsInfo = param.userPaymentsInfo, requestAgreementList = param.requestAgreementList, isRequestDiagnosisLoading = param.isRequestDiagnosisLoading, selectCard = param.selectCard, selectCardCompanyButton = param.selectCardCompanyButton, toggleRequestUsePoint = param.toggleRequestUsePoint, openCardInstallmentListBottomSheet = param.openCardInstallmentListBottomSheet, addCreditCard = param.addCreditCard, addKakaopay = param.addKakaopay, toggleTreatmentRequestAgreement = param.toggleTreatmentRequestAgreement, toggleTreatmentRequestAllAgreement = param.toggleTreatmentRequestAllAgreement, moveToAgreementLink = param.moveToAgreementLink, onSubmitRequestDiagnosis = param.onSubmitRequestDiagnosis, scrollToBottomAndCheckAllAgreement = param.scrollToBottomAndCheckAllAgreement, isCardRegisterBottomSheetOpen = param.isCardRegisterBottomSheetOpen, onCloseCardRegisterBottomSheet = param.onCloseCardRegisterBottomSheet, onSuccessCardRegister = param.onSuccessCardRegister, isCardInstallmentBottomSheetOpen = param.isCardInstallmentBottomSheetOpen, cardInstallments = param.cardInstallments, onCardInstallmentSelect = param.onCardInstallmentSelect, onCloseCardInstallmentBottomSheet = param.onCloseCardInstallmentBottomSheet;
    var isRequestButtonDisabled = (0,react.useMemo)(function() {
        return isRequestDiagnosisLoading || !treatmentRequest.validatePaymentStep() || !treatmentRequest.validateDiagnosisStepByWebDiagnosis() || !userPaymentsInfo.getValidationInstallmentByTreatmentRequest(treatmentRequest);
    }, [
        isRequestDiagnosisLoading,
        treatmentRequest,
        userPaymentsInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentFormStep_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestSection/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSection/* default.Header */.Z.Header, {
                                iconName: "credit_card",
                                title: "결제 수단"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSection/* default.ContentBody */.Z.ContentBody, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSection/* default.CardList */.Z.CardList, {
                                    ref: cardListWrapperRef,
                                    isPaymentsLoading: !isUserPaymentsInfoFetched && isUserPaymentsInfoRefetching,
                                    point: point,
                                    cardCompanyButton: cardCompanyButton,
                                    treatmentRequest: treatmentRequest,
                                    userPaymentsInfo: userPaymentsInfo,
                                    onSelectCard: selectCard,
                                    onSelectCardCompany: selectCardCompanyButton,
                                    onToggleRequestUsePoint: toggleRequestUsePoint,
                                    onOpenCardInstallmentBottomSheet: openCardInstallmentListBottomSheet,
                                    onAddCreditCard: addCreditCard,
                                    onAddKakaopay: addKakaopay,
                                    isWebTelemedicineFlow: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestSection/* default */.Z, {
                        hiddenBorder: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSection/* default.Header */.Z.Header, {
                                iconName: "checklist",
                                title: "약관 동의"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSection/* default.ContentBody */.Z.ContentBody, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSection/* default.AgreementList */.Z.AgreementList, {
                                    list: requestAgreementList,
                                    onSelectAgreement: toggleTreatmentRequestAgreement,
                                    onSelectAllAgreement: toggleTreatmentRequestAllAgreement,
                                    onMoveOutlink: moveToAgreementLink,
                                    isWebTelemedicineFlow: true
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                children: !treatmentRequest.isDisabledApproveCheckButton() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                    params: {
                        eventName: libs/* EWebTreatmentRequestLog.ClickSubmitDiagnosis */.o5.ClickSubmitDiagnosis,
                        payload: {
                            contactType: treatmentRequest.form.contactType
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        buttonColor: "primary",
                        size: "xl",
                        className: "w-full",
                        disabled: isRequestButtonDisabled,
                        onClick: onSubmitRequestDiagnosis,
                        children: isRequestDiagnosisLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {}) : !treatmentRequest.isDisabledApproveCheckButton() && !treatmentRequest.form.paymentId ? "결제 수단을 등록해주세요" : "진료 신청"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                    params: {
                        eventName: libs/* TreatmentRequestLog.RequestClickAutoAgreementCheck */.Js.RequestClickAutoAgreementCheck
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        buttonColor: "gray",
                        size: "xl",
                        className: "w-full",
                        disabled: !treatmentRequest.isDisabledApproveCheckButton(),
                        onClick: scrollToBottomAndCheckAllAgreement,
                        children: "진료 약관 확인 및 동의"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_CardRegisterBottomSheet, {
                isOpen: isCardRegisterBottomSheetOpen,
                onClose: onCloseCardRegisterBottomSheet,
                onSuccessCardRegister: onSuccessCardRegister
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_CardInstallmentBottomSheet, {
                open: isCardInstallmentBottomSheetOpen,
                title: "할부 기간을 선택해주세요",
                list: cardInstallments,
                onClick: onCardInstallmentSelect,
                getItemName: function(item) {
                    return item.text;
                },
                isSelected: function(item) {
                    return treatmentRequest.form.installmentMonth === item.installmentMonth;
                },
                onClose: onCloseCardInstallmentBottomSheet
            })
        ]
    });
};
/* harmony default export */ var ui_PaymentFormStep = (PaymentFormStep);
var PaymentFormStep_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e830bed1-0"
})(PaymentFormStep_templateObject());

// EXTERNAL MODULE: ./src/components/atom/icon/ValidationCheck.tsx
var ValidationCheck = __webpack_require__(23773);
// EXTERNAL MODULE: ./src/models/doctor/telemedicine.ts
var telemedicine = __webpack_require__(2426);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/SearchDoctorsSortFilterBottomSheet.tsx

function SearchDoctorsSortFilterBottomSheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  inset: 0;\n  z-index: 260;\n  margin: 0 auto;\n  max-width: 768px;\n  background-color: rgba(0, 0, 0, 0.4);\n"
    ]);
    SearchDoctorsSortFilterBottomSheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchDoctorsSortFilterBottomSheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 261;\n  margin: 0 auto;\n  max-width: 768px;\n  background-color: ",
        ";\n  border-radius: 10px 10px 0 0;\n  padding: 8px 20px 20px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.16);\n\n  &:focus-visible {\n    outline: none;\n  }\n"
    ]);
    SearchDoctorsSortFilterBottomSheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchDoctorsSortFilterBottomSheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 20px;\n    padding: 0 4px;\n  "
    ]);
    SearchDoctorsSortFilterBottomSheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchDoctorsSortFilterBottomSheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SearchDoctorsSortFilterBottomSheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchDoctorsSortFilterBottomSheet_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    SearchDoctorsSortFilterBottomSheet_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchDoctorsSortFilterBottomSheet_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  "
    ]);
    SearchDoctorsSortFilterBottomSheet_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchDoctorsSortFilterBottomSheet_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px 0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  ",
        "\n"
    ]);
    SearchDoctorsSortFilterBottomSheet_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var DOCTOR_SORT_KEY = {
    DEFAULT: {
        id: 0,
        value: telemedicine/* EDoctorSortType.DEFAULT */._c.DEFAULT,
        name: "기본순",
        toastMessage: "별점, 응답시간 등을 고려한 추천 순으로 정렬했어요."
    },
    REVIEW_COUNT: {
        id: 1,
        value: telemedicine/* EDoctorSortType.REVIEW_COUNT */._c.REVIEW_COUNT,
        name: "후기많은순",
        toastMessage: "후기가 많은 순으로 정렬했어요."
    },
    REVIEW_AVERAGE: {
        id: 2,
        value: telemedicine/* EDoctorSortType.REVIEW_AVERAGE_RATING */._c.REVIEW_AVERAGE_RATING,
        name: "별점높은순",
        toastMessage: "별점이 높은 순으로 정렬했어요."
    },
    DISTANCE: {
        id: 3,
        value: telemedicine/* EDoctorSortType.DISTANCE */._c.DISTANCE,
        name: "가까운순",
        toastMessage: "현재 위치와 가까운 순으로 정렬했어요."
    }
};
var DOCTOR_SORT_KEY_LIST = Object.values(DOCTOR_SORT_KEY);
var SearchDoctorSortFilterBottomSheet = function(param) {
    var open = param.open, selectedSortKey = param.selectedSortKey, onClickClose = param.onClickClose, handleSearchDoctorSortFilterSelect = param.handleSearchDoctorSortFilterSelect;
    var handleOpenChange = function(isOpen) {
        if (!isOpen) {
            onClickClose();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Root */.dy.Root, {
        modal: true,
        open: open,
        onOpenChange: handleOpenChange,
        dismissible: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Drawer.Portal */.dy.Portal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorsSortFilterBottomSheet_StyledOverlay, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDoctorsSortFilterBottomSheet_Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer.Handle */.dy.Handle, {
                            className: "mx-auto mb-[16px] h-[4px] w-[48px] flex-shrink-0 rounded-full bg-gray-300"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorsSortFilterBottomSheet_Title, {
                            children: "정렬 기준을 선택해주세요"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorsSortFilterBottomSheet_ListWrapper, {
                            children: DOCTOR_SORT_KEY_LIST.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                    params: {
                                        eventName: libs/* EWebTreatmentRequestLog.ClickDoctorSort */.o5.ClickDoctorSort,
                                        payload: {
                                            sort_type: item.value
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortItem, {
                                        onClick: function() {
                                            return handleSearchDoctorSortFilterSelect(item);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: item.name
                                            }),
                                            selectedSortKey === item.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidationCheck/* default */.Z, {
                                                size: 22
                                            })
                                        ]
                                    })
                                }, item.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var SearchDoctorsSortFilterBottomSheet = (SearchDoctorSortFilterBottomSheet);
var SearchDoctorsSortFilterBottomSheet_StyledOverlay = (0,styled_components_browser_esm/* default */.ZP)(dist/* Drawer.Overlay */.dy.Overlay).withConfig({
    componentId: "sc-2db25b40-0"
})(SearchDoctorsSortFilterBottomSheet_templateObject());
var SearchDoctorsSortFilterBottomSheet_Content = (0,styled_components_browser_esm/* default */.ZP)(dist/* Drawer.Content */.dy.Content).withConfig({
    componentId: "sc-2db25b40-1"
})(SearchDoctorsSortFilterBottomSheet_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.white;
});
var SearchDoctorsSortFilterBottomSheet_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-2db25b40-2"
})(SearchDoctorsSortFilterBottomSheet_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SearchDoctorsSortFilterBottomSheet_templateObject2(), theme.typography.UI22SB, theme.color.gray900);
});
var SearchDoctorsSortFilterBottomSheet_ListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2db25b40-3"
})(SearchDoctorsSortFilterBottomSheet_templateObject4());
var SortItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2db25b40-4"
})(SearchDoctorsSortFilterBottomSheet_templateObject6(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SearchDoctorsSortFilterBottomSheet_templateObject5(), theme.typography.UI16R, theme.color.gray900, theme.color.gray20);
});

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/SleepDisorderGuideBottomSheet.tsx


var SleepDisorderGuideBottomSheet = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BottomSheet */.R1, {
        type: "single",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "졸피뎀 등 향정신성 의약품은",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "비대면 처방이 어려워요"
            ]
        }),
        description: "멜라토닌, 항히스타민제 등은 비대면 처방이 가능해요!",
        open: isOpen,
        onOpenChange: function(open) {
            if (!open) {
                onClose();
            }
        },
        buttons: [
            {
                label: "확인했어요",
                variant: "primary",
                onClick: onClose
            }, 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://media.doctornow.co.kr/web_diagnosis_warning.webp",
                alt: "sleep disorder guide",
                className: "h-[160px] w-[312px] object-contain"
            })
        })
    });
};
/* harmony default export */ var ui_SleepDisorderGuideBottomSheet = (SleepDisorderGuideBottomSheet);

;// CONCATENATED MODULE: ./src/components/atom/icon/qna/TooltipTailUp.tsx

var TooltipTailUp = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.348 1.3568C5.95633 0.730128 5.04367 0.730129 4.652 1.3568L0.499999 8L10.5 8L6.348 1.3568Z",
            fill: "#3D4551"
        })
    });
};
/* harmony default export */ var qna_TooltipTailUp = (TooltipTailUp);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineDoctorFilter.tsx







var TelemedicineDoctorFilter = function(param) {
    var treatmentRequest = param.treatmentRequest, openSearchDoctorSortFilterBottomSheet = param.openSearchDoctorSortFilterBottomSheet;
    var ref = (0,react.useState)(false), isTooltipOpen = ref[0], setIsTooltipOpen = ref[1];
    var handleTooltipOpen = function() {
        setIsTooltipOpen(true);
    };
    var handleTooltipClose = function() {
        setIsTooltipOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between bg-white px-[24px] py-[12px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[4px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "typography-ui-17sb text-gray-700",
                        children: [
                            "나에게 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-green-700",
                                children: "딱 맞는"
                            }),
                            " 의사"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onMouseEnter: handleTooltipOpen,
                                onMouseLeave: handleTooltipClose,
                                className: "flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                    name: "info",
                                    size: 16,
                                    color: theme/* default.color.gray300 */.Z.color.gray300
                                })
                            }),
                            isTooltipOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-[24px] left-[-25px] z-10 flex flex-col items-start",
                                onMouseEnter: handleTooltipOpen,
                                onMouseLeave: handleTooltipClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative flex flex-col items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute top-[-8px] left-[30px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_TooltipTailUp, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex w-[180px] items-center gap-[6px] rounded-[8px] bg-gray-700 px-[12px] py-[7px] text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "typography-ui-13m text-center text-white",
                                                children: [
                                                    "내가 선택한 시간, 조건과 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "일치하는 의사들만 보여드려요."
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                params: {
                    eventName: libs/* EWebTreatmentRequestLog.ClickDoctorSort */.o5.ClickDoctorSort,
                    payload: {
                        current_sort: treatmentRequest.getSortKey()
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: openSearchDoctorSortFilterBottomSheet,
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-13m text-gray-500",
                            children: treatmentRequest.getSortKeyName()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "swap_vert",
                            size: 16,
                            color: theme/* default.color.gray500 */.Z.color.gray500
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_TelemedicineDoctorFilter = (TelemedicineDoctorFilter);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineDoctorItem.tsx





var getFilterLabel = function(filterType, professionalDepartmentName) {
    if (filterType === EDoctorFilterType.SPECIALIST && professionalDepartmentName) {
        return "".concat(professionalDepartmentName, "전문의");
    }
    var filterOption = DOCTOR_FILTER_OPTIONS.find(function(option) {
        return option.type === filterType;
    });
    if (!filterOption) {
        return "";
    }
    return filterOption.label.replace(/\s+/g, "");
};
var TelemedicineDoctorItem = function(props) {
    var doctor = props.doctor, selectedFilters = props.selectedFilters;
    var shouldShowReview = doctor === null || doctor === void 0 ? void 0 : doctor.review.isReviewAverageRatingOverZero;
    var filterTags = (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.filter(function(filterType) {
        if (filterType === EDoctorFilterType.SPECIALIST) {
            return !!doctor.professionalDepartmentName;
        }
        return true;
    }).map(function(filterType) {
        return {
            type: filterType,
            label: getFilterLabel(filterType, doctor.professionalDepartmentName)
        };
    }).filter(function(tag) {
        return tag.label;
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex items-center justify-between pr-[16px] pl-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col gap-[12px] pt-[20px] pb-[24px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "typography-ui-13r text-gray-400",
                                children: doctor.hospitalName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-[8px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "typography-ui-19sb text-gray-900",
                                        children: doctor.doctorNameFullText
                                    }),
                                    shouldShowReview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "star",
                                                color: theme/* default.color.yellow500 */.Z.color.yellow500,
                                                size: 16,
                                                filled: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "typography-ui-13m text-gray-700",
                                                children: doctor.review.reviewAverageText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "typography-ui-13r text-gray-400",
                                                children: [
                                                    "(",
                                                    doctor.review.reviewCountText,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    filterTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap items-center gap-[4px]",
                        children: filterTags.map(function(tag) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex h-[20px] items-center gap-[2px] rounded-[4px] bg-green-100 px-[4px] py-[1px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "check",
                                        size: 14,
                                        color: theme/* default.color.green800 */.Z.color.green800
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "typography-ui-12m text-green-800",
                                        children: tag.label
                                    })
                                ]
                            }, tag.type);
                        })
                    }),
                    doctor.medicinePricing && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "typography-ui-20sb text-gray-900",
                        children: [
                            doctor.medicinePricing.medicinePriceDisplayPrice,
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative pb-[8px]",
                children: doctor.profileUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "aspect-square h-[120px] w-[120px]",
                            src: doctor.profileUrl,
                            alt: "".concat(doctor.doctorName, " 의사 사진")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,style.cn)([
                                "absolute right-0 bottom-[8px] left-0 h-[32px] w-[120px]",
                                {
                                    "bg-gradient-to-t from-white to-transparent": doctor.profileUrl
                                }, 
                            ])
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_TelemedicineDoctorItem = (TelemedicineDoctorItem);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineDoctorListEmpty.tsx


var TelemedicineDoctorListEmpty = function() {
    var router = (0,next_router.useRouter)();
    var handleBackClick = function() {
        router.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex h-full min-h-[492px] w-full flex-col items-center justify-center gap-[24px] px-[24px] pb-[80px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full shrink-0 flex-col gap-[8px] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "typography-ui-17sb w-full text-gray-900",
                        children: "예약 가능한 의사가 없어요"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "typography-ui-13r w-full text-gray-400",
                        children: "선호 의사 조건을 변경하거나, 진료 시간을 변경해보세요."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: handleBackClick,
                className: "flex h-[32px] shrink-0 items-center justify-center gap-[4px] rounded-[8px] border border-gray-100 border-solid bg-white px-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "typography-ui-13m whitespace-pre text-gray-600",
                    children: "선호 조건 변경"
                })
            })
        ]
    });
};
/* harmony default export */ var ui_TelemedicineDoctorListEmpty = (TelemedicineDoctorListEmpty);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineDoctorList.tsx








var DOCTOR_LIST_LOAD_MORE_COUNT = 10;
var TelemedicineDoctorList = function(param) {
    var searchDoctors = param.searchDoctors, hasNextPageSearchDoctors = param.hasNextPageSearchDoctors, fetchNextPageSearchDoctors = param.fetchNextPageSearchDoctors, onOpenDoctorDetailBottomSheet = param.onOpenDoctorDetailBottomSheet, getDoctorDetailOpenCount = param.getDoctorDetailOpenCount, treatmentRequest = param.treatmentRequest, selectedFilters = param.selectedFilters;
    var getScrollDepth = (0,react.useCallback)(function() {
        var currentScrollY = window.scrollY;
        var documentHeight = document.documentElement.scrollHeight;
        var windowHeight = window.innerHeight;
        var footerElement = document.querySelector("footer");
        var footerHeight = footerElement ? footerElement.offsetHeight : 0;
        var maxScrollableHeight = documentHeight - windowHeight - footerHeight;
        var scrollDepth = 0;
        if (maxScrollableHeight > 0) {
            scrollDepth = Math.min(100, Math.max(0, Math.round(currentScrollY / maxScrollableHeight * 100)));
        }
        return scrollDepth;
    }, []);
    var handleDoctorClick = function(doctorId) {
        return function(e) {
            e.stopPropagation();
            onOpenDoctorDetailBottomSheet(doctorId);
        };
    };
    var showEmptyView = !searchDoctors || searchDoctors.length === 0;
    if (showEmptyView) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineDoctorListEmpty, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: searchDoctors === null || searchDoctors === void 0 ? void 0 : searchDoctors.map(function(doctor, index, array) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                params: {
                                    eventName: libs/* EWebTreatmentRequestLog.ClickReqDoctorSelect */.o5.ClickReqDoctorSelect,
                                    payload: function() {
                                        var scrollDepth = getScrollDepth();
                                        var ref;
                                        var totalDoctorsCount = (ref = searchDoctors === null || searchDoctors === void 0 ? void 0 : searchDoctors.length) !== null && ref !== void 0 ? ref : 0;
                                        var hasLessThan10Doctors = totalDoctorsCount < 10;
                                        var doctorDetailOpenCount = getDoctorDetailOpenCount();
                                        var _categoryId, _categoryType;
                                        return {
                                            doctorId: doctor.doctorPublicId,
                                            scrollDepth: scrollDepth,
                                            totalDoctorsCount: totalDoctorsCount,
                                            hasLessThan10Doctors: hasLessThan10Doctors.toString(),
                                            navigationCount: doctorDetailOpenCount,
                                            categoryId: (_categoryId = treatmentRequest.form.categoryId) !== null && _categoryId !== void 0 ? _categoryId : "",
                                            diagnosisType: (_categoryType = treatmentRequest.form.categoryType) !== null && _categoryType !== void 0 ? _categoryType : ""
                                        };
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: handleDoctorClick(doctor.doctorPublicId),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineDoctorItem, {
                                        doctor: doctor,
                                        selectedFilters: selectedFilters
                                    })
                                })
                            }),
                            index !== array.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[1px] w-full bg-gray-30"
                            })
                        ]
                    }, doctor.doctorPublicId);
                })
            }),
            hasNextPageSearchDoctors && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-[10px] px-[24px] pt-[16px] pb-[40px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                    params: {
                        eventName: libs/* EWebTreatmentRequestLog.ClickLoadMoreDoctorsButton */.o5.ClickLoadMoreDoctorsButton
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        size: "l",
                        buttonColor: "gray",
                        buttonStyle: "outlined",
                        onClick: fetchNextPageSearchDoctors,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "typography-ui-17sb text-gray-600",
                            children: [
                                "의사 ",
                                DOCTOR_LIST_LOAD_MORE_COUNT,
                                "명 더 보기"
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ui_TelemedicineDoctorList = (TelemedicineDoctorList);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useMinimumLoadingDuration.ts

var useMinimumLoadingDuration = function(param) {
    var isLoading = param.isLoading, minimumDurationMs = param.minimumDurationMs;
    var ref = (0,react.useState)(isLoading), shouldShowLoading = ref[0], setShouldShowLoading = ref[1];
    var loadingStartTimeRef = (0,react.useRef)(isLoading ? Date.now() : null);
    (0,react.useEffect)(function() {
        if (isLoading) {
            if (loadingStartTimeRef.current === null) {
                loadingStartTimeRef.current = Date.now();
            }
            setShouldShowLoading(true);
        } else {
            if (loadingStartTimeRef.current !== null) {
                var elapsedTime = Date.now() - loadingStartTimeRef.current;
                var remainingTime = Math.max(0, minimumDurationMs - elapsedTime);
                if (remainingTime > 0) {
                    var timeoutId = setTimeout(function() {
                        setShouldShowLoading(false);
                        loadingStartTimeRef.current = null;
                    }, remainingTime);
                    return function() {
                        clearTimeout(timeoutId);
                    };
                } else {
                    setShouldShowLoading(false);
                    loadingStartTimeRef.current = null;
                }
            } else {
                setShouldShowLoading(false);
            }
        }
    }, [
        isLoading,
        minimumDurationMs
    ]);
    return shouldShowLoading;
};

// EXTERNAL MODULE: ./src/components/atom/spinner/index.tsx + 1 modules
var spinner = __webpack_require__(16718);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineDoctorListLoading.tsx





var SLIDE_INTERVAL_MS = 1000;
var TelemedicineDoctorListLoading = function(param) {
    var categoryName = param.categoryName, _selectedFilters = param.selectedFilters, selectedFilters = _selectedFilters === void 0 ? [] : _selectedFilters;
    var displayCategoryName = categoryName || "증상/과목";
    var hasFilters = selectedFilters.length > 0;
    var ref = (0,react.useState)(0), currentFilterIndex = ref[0], setCurrentFilterIndex = ref[1];
    var prevFiltersRef = (0,react.useRef)("");
    var currentFiltersKey = JSON.stringify(selectedFilters);
    (0,react.useEffect)(function() {
        if (prevFiltersRef.current !== currentFiltersKey) {
            setCurrentFilterIndex(0);
            prevFiltersRef.current = currentFiltersKey;
        }
    }, [
        currentFiltersKey
    ]);
    (0,react.useEffect)(function() {
        if (!hasFilters || selectedFilters.length <= 1) {
            setCurrentFilterIndex(0);
            return;
        }
        var intervalId = setInterval(function() {
            setCurrentFilterIndex(function(prev) {
                var nextIndex = (prev + 1) % selectedFilters.length;
                return nextIndex;
            });
        }, SLIDE_INTERVAL_MS);
        return function() {
            clearInterval(intervalId);
        };
    }, [
        hasFilters,
        currentFiltersKey,
        selectedFilters.length
    ]);
    var getLoadingMessage = function() {
        if (!hasFilters) {
            return "".concat(displayCategoryName, "을 전문으로 하는 의사 찾는 중...");
        }
        var currentFilter = selectedFilters[currentFilterIndex];
        return getLoadingMessageByFilterType(currentFilter, displayCategoryName);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "box-border flex min-h-[100vh] flex-col items-center justify-center gap-[40px] px-[20px] pt-[40px] pb-[80px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
                size: 48,
                color: theme/* default.color.primary600 */.Z.color.primary600
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center gap-[12px] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "typography-ui-19sb text-gray-900",
                        children: "나에게 적합한 의사를 찾고 있어요"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative h-[22px] w-full overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "typography-ui-15r flex flex-col text-gray-500 transition-transform duration-500 ease-in-out",
                            style: {
                                transform: hasFilters && selectedFilters.length > 1 ? "translateY(-".concat(currentFilterIndex * 22, "px)") : "translateY(0)"
                            },
                            children: hasFilters && selectedFilters.length > 1 ? selectedFilters.map(function(filter, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h-[22px] flex-shrink-0 leading-[22px]",
                                    children: getLoadingMessageByFilterType(filter, displayCategoryName)
                                }, "".concat(filter, "-").concat(index));
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h-[22px] flex-shrink-0 leading-[22px]",
                                children: getLoadingMessage()
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_TelemedicineDoctorListLoading = (TelemedicineDoctorListLoading);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineDoctorSelect.tsx







var MIN_LOADING_DURATION_MS = 3000;
var TelemedicineDoctorSelect = function(param) {
    var client = param.client, searchDoctors = param.searchDoctors, isLoadingSearchDoctors = param.isLoadingSearchDoctors, hasNextPageSearchDoctors = param.hasNextPageSearchDoctors, treatmentRequest = param.treatmentRequest, categoryName = param.categoryName, selectedFilters = param.selectedFilters, isSearchDoctorSortFilterBottomSheetOpen = param.isSearchDoctorSortFilterBottomSheetOpen, selectedSortKey = param.selectedSortKey, handleSearchDoctorSpecialistOnlySelect = param.handleSearchDoctorSpecialistOnlySelect, handleSearchDoctorSortFilterSelect = param.handleSearchDoctorSortFilterSelect, fetchNextPageSearchDoctors = param.fetchNextPageSearchDoctors, openSearchDoctorSortFilterBottomSheet = param.openSearchDoctorSortFilterBottomSheet, closeSearchDoctorSortFilterBottomSheet = param.closeSearchDoctorSortFilterBottomSheet, onOpenDoctorDetailBottomSheet = param.onOpenDoctorDetailBottomSheet, getDoctorDetailOpenCount = param.getDoctorDetailOpenCount, isDoctorDetailBottomSheetOpen = param.isDoctorDetailBottomSheetOpen, onCloseDoctorDetailBottomSheet = param.onCloseDoctorDetailBottomSheet, handleSelectDoctor = param.handleSelectDoctor, isEnabledScheduleAlertOpen = param.isEnabledScheduleAlertOpen, selectedStartDisplayTimeSlot = param.selectedStartDisplayTimeSlot, selectedDoctorDetail = param.selectedDoctorDetail, onCloseIsEnabledScheduleAlert = param.onCloseIsEnabledScheduleAlert;
    var shouldShowLoading = useMinimumLoadingDuration({
        isLoading: isLoadingSearchDoctors,
        minimumDurationMs: MIN_LOADING_DURATION_MS
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            shouldShowLoading || isLoadingSearchDoctors ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineDoctorListLoading, {
                categoryName: categoryName,
                selectedFilters: selectedFilters
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "min-h-[calc(100vh-160px)] ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-[8px] px-[24px] pt-[12px] pb-[12px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "typography-ui-24sb text-gray-900",
                            children: "원하는 의사를 선택해주세요"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineDoctorFilter, {
                        treatmentRequest: treatmentRequest,
                        openSearchDoctorSortFilterBottomSheet: openSearchDoctorSortFilterBottomSheet,
                        handleSearchDoctorSpecialistOnlySelect: handleSearchDoctorSpecialistOnlySelect
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-px bg-gray-40"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineDoctorList, {
                        searchDoctors: searchDoctors,
                        fetchNextPageSearchDoctors: fetchNextPageSearchDoctors,
                        hasNextPageSearchDoctors: hasNextPageSearchDoctors,
                        onOpenDoctorDetailBottomSheet: onOpenDoctorDetailBottomSheet,
                        getDoctorDetailOpenCount: getDoctorDetailOpenCount,
                        treatmentRequest: treatmentRequest,
                        selectedFilters: selectedFilters
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorsSortFilterBottomSheet, {
                open: isSearchDoctorSortFilterBottomSheetOpen,
                onClickClose: closeSearchDoctorSortFilterBottomSheet,
                selectedSortKey: selectedSortKey,
                handleSearchDoctorSortFilterSelect: handleSearchDoctorSortFilterSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DoctorDetailBottomSheet, {
                client: client,
                isOpen: isDoctorDetailBottomSheetOpen,
                onClose: onCloseDoctorDetailBottomSheet,
                handleSelectDoctor: handleSelectDoctor,
                isEnabledScheduleAlertOpen: isEnabledScheduleAlertOpen,
                selectedStartDisplayTimeSlot: selectedStartDisplayTimeSlot,
                selectedDoctorDetail: selectedDoctorDetail,
                onCloseIsEnabledScheduleAlert: onCloseIsEnabledScheduleAlert
            })
        ]
    });
};
/* harmony default export */ var ui_TelemedicineDoctorSelect = (TelemedicineDoctorSelect);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(54073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../../node_modules/lodash/every.js
var every = __webpack_require__(39794);
var every_default = /*#__PURE__*/__webpack_require__.n(every);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/entities/doctor/index.ts + 6 modules
var entities_doctor = __webpack_require__(92998);
// EXTERNAL MODULE: ./src/entities/telemedicine/index.ts + 6 modules
var entities_telemedicine = __webpack_require__(42491);
// EXTERNAL MODULE: ./src/entities/user/index.ts + 9 modules
var entities_user = __webpack_require__(87254);
// EXTERNAL MODULE: ./src/hooks/common/useUserProfiles.ts
var useUserProfiles = __webpack_require__(77503);
// EXTERNAL MODULE: ./src/hooks/common/useWebViewFocused.ts
var useWebViewFocused = __webpack_require__(48190);
// EXTERNAL MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts + 1 modules
var useGetDiagnosisCategories = __webpack_require__(57710);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/models/common/index.ts + 33 modules
var common = __webpack_require__(18044);
// EXTERNAL MODULE: ./src/models/diagnosis/index.ts
var models_diagnosis = __webpack_require__(39591);
// EXTERNAL MODULE: ./src/recoil/atoms/common/user.ts
var common_user = __webpack_require__(3818);
// EXTERNAL MODULE: ./src/services/non-benefit/index.ts
var services_non_benefit = __webpack_require__(72495);
// EXTERNAL MODULE: ./src/types/common.ts
var types_common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(30918);
// EXTERNAL MODULE: ./src/utils/report.ts + 289 modules
var report = __webpack_require__(80162);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/constants/telemedicineRequestHeaderTitles.ts


var _obj;
var TELEMEDICINE_REQUEST_HEADER_TITLES = (_obj = {}, (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis, "진료 신청서"), (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.DoctorFilter */.cR.DoctorFilter, "나에게 맞는 의사 찾기"), (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.Doctor */.cR.Doctor, "의사 선택"), (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.Payment */.cR.Payment, "결제 정보 입력"), (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.CertificationGuide */.cR.CertificationGuide, "본인인증"), _obj);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/constants/index.ts



;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useRefreshPrevention.ts



var useRefreshPrevention = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _enabled = options.enabled, enabled = _enabled === void 0 ? true : _enabled, _modalTitle = options.modalTitle, modalTitle = _modalTitle === void 0 ? "페이지를 새로고침하시겠어요?" : _modalTitle, _modalMessage = options.modalMessage, modalMessage = _modalMessage === void 0 ? "작성 중인 내용이 사라질 수 있습니다." : _modalMessage, _skipReload = options.skipReload, skipReload = _skipReload === void 0 ? false : _skipReload, _onCancelText = options.onCancelText, onCancelText = _onCancelText === void 0 ? "취소" : _onCancelText, _onConfirmText = options.onConfirmText, onConfirmText = _onConfirmText === void 0 ? "새로고침" : _onConfirmText, onConfirm = options.onConfirm, onCancel = options.onCancel;
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var shouldPreventRef = (0,react.useRef)(false);
    var enabledRef = (0,react.useRef)(enabled);
    (0,react.useEffect)(function() {
        enabledRef.current = enabled;
    }, [
        enabled
    ]);
    (0,react.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var handleKeyDown = function(event) {
            var isNormalRefresh = event.key === "F5" || (event.ctrlKey || event.metaKey) && event.key === "r" || (event.ctrlKey || event.metaKey) && event.key === "R";
            var isHardRefresh = event.key === "F5" && event.shiftKey || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === "r" || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === "R";
            var isRefreshKey = isNormalRefresh || isHardRefresh;
            if (isRefreshKey) {
                event.preventDefault();
                shouldPreventRef.current = true;
                showModal({
                    type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                    props: {
                        title: modalTitle,
                        message: modalMessage,
                        buttons: [
                            {
                                type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                                label: onCancelText,
                                onClick: function() {
                                    closeModal();
                                    shouldPreventRef.current = false;
                                    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                                }
                            },
                            {
                                type: modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                                label: onConfirmText,
                                onClick: function() {
                                    closeModal();
                                    shouldPreventRef.current = false;
                                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
                                    if (!skipReload) {
                                        window.location.reload();
                                    }
                                }
                            }, 
                        ]
                    }
                });
            }
        };
        var handleBeforeUnload = function(event) {
            if (enabledRef.current) {
                event.preventDefault();
                event.returnValue = "";
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("beforeunload", handleBeforeUnload);
        return function() {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        enabled,
        modalTitle,
        modalMessage,
        showModal,
        closeModal,
        onConfirm,
        onCancel
    ]);
    return {
        shouldPrevent: shouldPreventRef.current
    };
};
/* harmony default export */ var hooks_useRefreshPrevention = (useRefreshPrevention);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useCategoryGuideBottomSheet.ts





var BottomSheetType = {
    MATERNITY: "maternity",
    MALE: "male",
    MENTAL_HEALTH: "mentalHealth",
    DIET: "diet",
    SLEEP_DISORDER: "sleepDisorder",
    NONE: null
};
var MATERNITY_RELATED_TREATMENT_CATEGORY_IDS = [
    "584",
    "586"
];
var MATERNITY_RELATED_DEPARTMENT_CATEGORY_IDS = [
    "10"
];
var MALE_RELATED_TREATMENT_CATEGORY_IDS = [
    "606"
];
var MALE_RELATED_DEPARTMENT_CATEGORY_IDS = [
    "9"
];
var MENTAL_HEALTH_RELATED_TREATMENT_CATEGORY_IDS = [
    "8",
    "588",
    "589"
];
var MENTAL_HEALTH_RELATED_DEPARTMENT_CATEGORY_IDS = [
    "7"
];
var DIET_TREATMENT_CATEGORY_ID = "12";
var SLEEP_DISORDER_TREATMENT_CATEGORY_ID = "619";
var useCategoryGuideBottomSheet = function() {
    var ref = (0,react.useState)(BottomSheetType.NONE), activeSheet = ref[0], setActiveSheet = ref[1];
    var states = (0,react.useMemo)(function() {
        return {
            isMaternityGuideBottomSheetOpen: activeSheet === BottomSheetType.MATERNITY,
            isMaleGuideBottomSheetOpen: activeSheet === BottomSheetType.MALE,
            isMentalHealthGuideBottomSheetOpen: activeSheet === BottomSheetType.MENTAL_HEALTH,
            isDietGuideBottomSheetOpen: activeSheet === BottomSheetType.DIET,
            isSleepDisorderGuideBottomSheetOpen: activeSheet === BottomSheetType.SLEEP_DISORDER
        };
    }, [
        activeSheet
    ]);
    var actions = (0,react.useMemo)(function() {
        var closeAll = function() {
            return setActiveSheet(BottomSheetType.NONE);
        };
        return {
            openMaternityGuideBottomSheet: function() {
                return setActiveSheet(BottomSheetType.MATERNITY);
            },
            closeMaternityGuideBottomSheet: closeAll,
            openMaleGuideBottomSheet: function() {
                return setActiveSheet(BottomSheetType.MALE);
            },
            closeMaleGuideBottomSheet: closeAll,
            openMentalHealthGuideBottomSheet: function() {
                return setActiveSheet(BottomSheetType.MENTAL_HEALTH);
            },
            closeMentalHealthGuideBottomSheet: closeAll,
            openDietGuideBottomSheet: function() {
                return setActiveSheet(BottomSheetType.DIET);
            },
            closeDietGuideBottomSheet: closeAll,
            openSleepDisorderGuideBottomSheet: function() {
                return setActiveSheet(BottomSheetType.SLEEP_DISORDER);
            },
            closeSleepDisorderGuideBottomSheet: closeAll
        };
    }, []);
    var openActionMap = (0,react.useMemo)(function() {
        var _obj;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MATERNITY_RELATED_TREATMENT_CATEGORY_IDS.reduce(function(acc, id) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, "".concat(id, ":").concat(medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT), actions.openMaternityGuideBottomSheet));
        }, {}), MATERNITY_RELATED_DEPARTMENT_CATEGORY_IDS.reduce(function(acc, id) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, "".concat(id, ":").concat(medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT), actions.openMaternityGuideBottomSheet));
        }, {}), MALE_RELATED_TREATMENT_CATEGORY_IDS.reduce(function(acc, id) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, "".concat(id, ":").concat(medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT), actions.openMaleGuideBottomSheet));
        }, {}), MALE_RELATED_DEPARTMENT_CATEGORY_IDS.reduce(function(acc, id) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, "".concat(id, ":").concat(medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT), actions.openMaleGuideBottomSheet));
        }, {}), MENTAL_HEALTH_RELATED_TREATMENT_CATEGORY_IDS.reduce(function(acc, id) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, "".concat(id, ":").concat(medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT), actions.openMentalHealthGuideBottomSheet));
        }, {}), MENTAL_HEALTH_RELATED_DEPARTMENT_CATEGORY_IDS.reduce(function(acc, id) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, "".concat(id, ":").concat(medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT), actions.openMentalHealthGuideBottomSheet));
        }, {})), (_obj = {}, (0,_define_property/* default */.Z)(_obj, "".concat(DIET_TREATMENT_CATEGORY_ID, ":").concat(medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT), actions.openDietGuideBottomSheet), (0,_define_property/* default */.Z)(_obj, "".concat(SLEEP_DISORDER_TREATMENT_CATEGORY_ID, ":").concat(medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT), actions.openSleepDisorderGuideBottomSheet), _obj));
    }, [
        actions
    ]);
    return {
        categoryGuideBottomSheetStates: states,
        categoryGuideBottomSheetActions: actions,
        categoryGuideBottomSheetOpenActionMap: openActionMap
    };
};
/* harmony default export */ var hooks_useCategoryGuideBottomSheet = (useCategoryGuideBottomSheet);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useStepValidation.ts






var useStepValidation = function(param) {
    var step = param.step, treatmentRequest = param.treatmentRequest, isRequiredDataFetched = param.isRequiredDataFetched;
    var router = (0,useCustomRouter/* default */.Z)().router;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var hasValidatedRef = (0,react.useRef)(false);
    var currentStepRef = (0,react.useRef)(step);
    (0,react.useEffect)(function() {
        if (currentStepRef.current !== step) {
            hasValidatedRef.current = false;
            currentStepRef.current = step;
        }
        if (!isRequiredDataFetched || hasValidatedRef.current) {
            return;
        }
        var isDiagnosisStepValid = function() {
            var form = treatmentRequest.form;
            return !!(form.categoryId && form.categoryType && form.bookingTargetDate && form.startTimeSlotValue !== -1 && // -1은 미선택 초깃값
            form.endTimeSlotValue !== -1);
        };
        var isDoctorStepValid = function() {
            return isDiagnosisStepValid();
        };
        var isPaymentStepValid = function() {
            return isDiagnosisStepValid() && !!treatmentRequest.form.doctorId;
        };
        var redirectToFirstStep = function() {
            toast({
                text: "진료 신청서를 다시 작성해 주세요.",
                direction: "bottom"
            });
            router.replace(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path + (0,url/* addQueryString */.sC)({
                step: models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis,
                type: router.query.type,
                categoryId: router.query.categoryId
            }));
        };
        if (step === models_diagnosis/* EDiagnosisStep.Doctor */.cR.Doctor && !isDoctorStepValid()) {
            redirectToFirstStep();
            return;
        }
        if (step === models_diagnosis/* EDiagnosisStep.Payment */.cR.Payment && !isPaymentStepValid()) {
            redirectToFirstStep();
            return;
        }
        hasValidatedRef.current = true;
    }, [
        step,
        treatmentRequest,
        isRequiredDataFetched,
        router,
        toast
    ]);
};
/* harmony default export */ var hooks_useStepValidation = (useStepValidation);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineAccordion.ts



var useTelemedicineAccordion = function() {
    var dayRef = (0,react.useRef)(null);
    var isVisitBrandRef = (0,react.useRef)(null);
    var requestCallRef = (0,react.useRef)(null);
    var ssnRef = (0,react.useRef)(null);
    var childInfoRef = (0,react.useRef)(null);
    var detailSymptomRef = (0,react.useRef)(null);
    var accordionRefs = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, AccordionState.Days, dayRef), (0,_define_property/* default */.Z)(_obj, AccordionState.IsVisitBrand, isVisitBrandRef), (0,_define_property/* default */.Z)(_obj, AccordionState.RequestCallType, requestCallRef), (0,_define_property/* default */.Z)(_obj, AccordionState.Ssn, ssnRef), (0,_define_property/* default */.Z)(_obj, AccordionState.ChildInfo, childInfoRef), (0,_define_property/* default */.Z)(_obj, AccordionState.DetailSymptom, detailSymptomRef), _obj;
    }, []);
    var openSection = function(state, options) {
        var ref;
        (ref = accordionRefs[state].current) === null || ref === void 0 ? void 0 : ref.openSection(options);
    };
    var closeSection = function(state) {
        var ref;
        (ref = accordionRefs[state].current) === null || ref === void 0 ? void 0 : ref.closeSection();
    };
    var toggleSection = function(state) {
        var ref;
        (ref = accordionRefs[state].current) === null || ref === void 0 ? void 0 : ref.toggleSection();
    };
    return {
        accordionRefs: accordionRefs,
        openSection: openSection,
        closeSection: closeSection,
        toggleSection: toggleSection
    };
};

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineAgreement.ts





var useTelemedicineAgreement = function(param) {
    var treatmentRequest = param.treatmentRequest, contactType = param.contactType, updateForm = param.updateForm, client = param.client;
    var ref = (0,react.useState)(common/* treatmentRequestAgreements.filter */.tz.filter(function(agreement) {
        return agreement.contactTypeList.includes(contactType);
    })), requestAgreementList = ref[0], setRequestAgreementList = ref[1];
    var toggleTreatmentRequestAgreement = function(selectedTerm) {
        var newTermList = requestAgreementList.map(function(item) {
            if (item.text === selectedTerm.text) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                    selected: !item.selected
                });
            }
            return item;
        });
        setRequestAgreementList(newTermList);
        var isAgreement = newTermList.every(function(term) {
            return term.selected;
        });
        var form = treatmentRequest.updateRequestAgreement(isAgreement);
        updateForm(function() {
            return form;
        });
    };
    var toggleTreatmentRequestAllAgreement = function() {
        var isAgreement = requestAgreementList.every(function(term) {
            return term.selected;
        });
        var newTermList = requestAgreementList.map(function(term) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, term), {
                selected: !isAgreement
            });
        });
        setRequestAgreementList(newTermList);
        var form = treatmentRequest.updateRequestAgreement(!isAgreement);
        updateForm(function() {
            return form;
        });
    };
    var scrollToBottom = function() {
        window.scrollTo({
            left: 0,
            top: document.body.scrollHeight,
            behavior: "smooth"
        });
    };
    var scrollToBottomAndCheckAllAgreement = function() {
        if (client.clientType !== app/* ClientType.WEB */.B.WEB) {
            scrollToBottom();
        }
        toggleTreatmentRequestAllAgreement();
    };
    return {
        requestAgreementList: requestAgreementList,
        toggleTreatmentRequestAgreement: toggleTreatmentRequestAgreement,
        toggleTreatmentRequestAllAgreement: toggleTreatmentRequestAllAgreement,
        scrollToBottomAndCheckAllAgreement: scrollToBottomAndCheckAllAgreement,
        scrollToBottom: scrollToBottom
    };
};

// EXTERNAL MODULE: ./src/entities/telemedicine/hooks/useSearchDoctorsInfinity.ts
var useSearchDoctorsInfinity = __webpack_require__(56289);
// EXTERNAL MODULE: ./src/parsers/common/index.ts
var parsers_common = __webpack_require__(61169);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useDoctorFilterToggle.ts




var useDoctorFilterToggle = function() {
    var toast = (0,index_es/* useToast */.pm)().toast;
    var ref = (0,react.useState)([]), selectedFilters = ref[0], setSelectedFilters = ref[1];
    var specialistOnly = (0,react.useMemo)(function() {
        return getSpecialistOnlyFromFilters(selectedFilters);
    }, [
        selectedFilters
    ]);
    var highReviewRating = (0,react.useMemo)(function() {
        return getHighReviewRatingFromFilters(selectedFilters);
    }, [
        selectedFilters
    ]);
    var highReviewCount = (0,react.useMemo)(function() {
        return getHighReviewCountFromFilters(selectedFilters);
    }, [
        selectedFilters
    ]);
    var handleToggleFilter = function(filterType) {
        setSelectedFilters(function(prev) {
            if (prev.includes(filterType)) {
                return prev.filter(function(f) {
                    return f !== filterType;
                });
            }
            if (prev.length >= MAX_FILTER_SELECTION) {
                toast({
                    text: "최대 ".concat(MAX_FILTER_SELECTION, "개까지 선택할 수 있어요"),
                    direction: "bottom"
                });
                return prev;
            }
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                filterType
            ]);
        });
    };
    return {
        selectedFilters: selectedFilters,
        specialistOnly: specialistOnly,
        highReviewRating: highReviewRating,
        highReviewCount: highReviewCount,
        handleToggleFilter: handleToggleFilter
    };
};

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineDoctorSelection.ts
















var useTelemedicineDoctorSelection = function(param) {
    var queries = param.queries, treatmentRequest = param.treatmentRequest, updateFormFromTreatmentRequest = param.updateFormFromTreatmentRequest, step = param.step;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var router = (0,useCustomRouter/* default */.Z)().router;
    var type = queries.type, categoryId = queries.categoryId;
    var shouldEnableQuery = step === models_diagnosis/* EDiagnosisStep.Doctor */.cR.Doctor;
    var ref = (0,react.useState)(false), isSearchDoctorSortFilterBottomSheetOpen = ref[0], setIsSearchDoctorSortFilterBottomSheetOpen = ref[1];
    var ref1 = (0,react.useState)(null), doctorPublicId = ref1[0], setDoctorPublicId = ref1[1];
    var doctorDetailOpenCountRef = (0,react.useRef)(0);
    var originalTypeRef = (0,react.useRef)(undefined);
    var ref2 = useDoctorFilterToggle(), selectedFilters = ref2.selectedFilters, specialistOnly = ref2.specialistOnly, highReviewRating = ref2.highReviewRating, highReviewCount = ref2.highReviewCount, handleToggleFilter = ref2.handleToggleFilter;
    var ref3 = (0,useSearchDoctorsInfinity/* default */.Z)({
        categoryType: type,
        categoryId: categoryId,
        targetDate: treatmentRequest.form.bookingTargetDate,
        startTimeSlotValue: treatmentRequest.form.startTimeSlotValue,
        endTimeSlotValue: treatmentRequest.form.endTimeSlotValue,
        sortType: treatmentRequest.form.sortKey,
        specialistOnly: specialistOnly,
        highReviewRating: highReviewRating,
        highReviewCount: highReviewCount,
        geoPoint: treatmentRequest.getGeoPoint(),
        enabled: shouldEnableQuery
    }), searchDoctors = ref3.searchDoctors, isLoadingSearchDoctors = ref3.isLoadingSearchDoctors, fetchNextPageSearchDoctors = ref3.fetchNextPageSearchDoctors, hasNextPageSearchDoctors = ref3.hasNextPageSearchDoctors;
    var openSearchDoctorSortFilterBottomSheet = function() {
        setIsSearchDoctorSortFilterBottomSheetOpen(true);
    };
    var closeSearchDoctorSortFilterBottomSheet = function() {
        setIsSearchDoctorSortFilterBottomSheetOpen(false);
    };
    var requestGeolocation = function() {
        return new Promise(function(resolve, reject) {
            if (!navigator.geolocation) {
                reject(new Error("Geolocation is not supported"));
                return;
            }
            navigator.geolocation.getCurrentPosition(function(position) {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            }, function(error) {
                reject(error);
            }, {
                enableHighAccuracy: false,
                timeout: 7000
            });
        });
    };
    var handleSearchDoctorSortFilterSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(sortKey) {
            var geoPoint, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(sortKey.value === telemedicine/* EDoctorSortType.DISTANCE */._c.DISTANCE)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            requestGeolocation()
                        ];
                    case 2:
                        geoPoint = _state.sent();
                        treatmentRequest.updateGeoPoint(geoPoint);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        toast({
                            text: "위치 권한 허용 후 다시 시도해주세요",
                            direction: "bottom"
                        });
                        return [
                            2
                        ];
                    case 4:
                        treatmentRequest.updateSortKey(sortKey.value);
                        updateFormFromTreatmentRequest(treatmentRequest);
                        router.replace("".concat(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path) + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                            sortKey: sortKey.value
                        })));
                        closeSearchDoctorSortFilterBottomSheet();
                        toast({
                            text: sortKey.toastMessage,
                            direction: "bottom"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearchDoctorSortFilterSelect(sortKey) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSearchDoctorSpecialistOnlySelect = function(isSpecialistOnly) {
        var hasSpecialistFilter = selectedFilters.includes(EDoctorFilterType.SPECIALIST);
        if (isSpecialistOnly !== hasSpecialistFilter) {
            handleToggleFilter(EDoctorFilterType.SPECIALIST);
        }
    };
    var incrementDoctorDetailOpenCount = function() {
        doctorDetailOpenCountRef.current += 1;
    };
    var getDoctorDetailOpenCount = function() {
        return doctorDetailOpenCountRef.current;
    };
    var onOpenDoctorDetailBottomSheet = function(doctorPublicId) {
        setDoctorPublicId(doctorPublicId);
        incrementDoctorDetailOpenCount();
        var convertedType = (0,parsers_common/* parseMedicalCategoryCategoryTypeOf */.x3)(type !== null && type !== void 0 ? type : medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT);
        router.push("".concat(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path) + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            doctorId: doctorPublicId,
            type: convertedType
        })));
    };
    var onCloseDoctorDetailBottomSheet = function() {
        router.back();
    };
    var getDoctorIdByQueryString = function() {
        return router.query.doctorId;
    };
    var onSelectDoctor = function(doctor, doctorPublicId) {
        if (!doctor) {
            return;
        }
        treatmentRequest.initializeTreatmentRequestFromDoctor(doctor);
        if (doctorPublicId) {
            treatmentRequest.updateDoctorPid(doctorPublicId);
        }
        updateFormFromTreatmentRequest(treatmentRequest);
        router.push("".concat(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path) + (0,url/* addQueryString */.sC)({
            type: originalTypeRef.current,
            categoryId: categoryId,
            step: models_diagnosis/* EDiagnosisStep.Payment */.cR.Payment
        }));
    };
    var isDoctorStepButtonDisabled = (0,react.useMemo)(function() {
        var category = treatmentRequest.getCategory();
        if (!category) {
            return true;
        }
        var baseValidation = !treatmentRequest.validateDiagnosisStepByWebDiagnosis();
        return baseValidation;
    }, [
        treatmentRequest
    ]);
    var handleFilterSelectionNext = function() {
        if (selectedFilters.length === 0) {
            toast({
                text: "최소 1개 이상의 필터를 선택해주세요",
                direction: "bottom"
            });
            return;
        }
        router.push("".concat(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path) + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            step: models_diagnosis/* EDiagnosisStep.Doctor */.cR.Doctor
        })));
    };
    return {
        doctorPublicId: doctorPublicId,
        searchDoctors: searchDoctors,
        isLoadingSearchDoctors: isLoadingSearchDoctors,
        hasNextPageSearchDoctors: hasNextPageSearchDoctors,
        isSearchDoctorSortFilterBottomSheetOpen: isSearchDoctorSortFilterBottomSheetOpen,
        setDoctorPublicId: setDoctorPublicId,
        fetchNextPageSearchDoctors: fetchNextPageSearchDoctors,
        openSearchDoctorSortFilterBottomSheet: openSearchDoctorSortFilterBottomSheet,
        closeSearchDoctorSortFilterBottomSheet: closeSearchDoctorSortFilterBottomSheet,
        handleSearchDoctorSortFilterSelect: handleSearchDoctorSortFilterSelect,
        handleSearchDoctorSpecialistOnlySelect: handleSearchDoctorSpecialistOnlySelect,
        incrementDoctorDetailOpenCount: incrementDoctorDetailOpenCount,
        getDoctorDetailOpenCount: getDoctorDetailOpenCount,
        onOpenDoctorDetailBottomSheet: onOpenDoctorDetailBottomSheet,
        onCloseDoctorDetailBottomSheet: onCloseDoctorDetailBottomSheet,
        getDoctorIdByQueryString: getDoctorIdByQueryString,
        onSelectDoctor: onSelectDoctor,
        isDoctorStepButtonDisabled: isDoctorStepButtonDisabled,
        selectedFilters: selectedFilters,
        handleToggleFilter: handleToggleFilter,
        handleFilterSelectionNext: handleFilterSelectionNext
    };
};

// EXTERNAL MODULE: ./src/parsers/diagnosis/index.ts
var parsers_diagnosis = __webpack_require__(77453);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineFormState.ts







var useTelemedicineFormState = function(param) {
    var queries = param.queries;
    var type = queries.type, categoryId = queries.categoryId, _sortKey = queries.sortKey, sortKey = _sortKey === void 0 ? telemedicine/* EDoctorSortType.DEFAULT */._c.DEFAULT : _sortKey, _inflowType = queries.inflowType, inflowType = _inflowType === void 0 ? null : _inflowType;
    var parsedDeprecatedCategoryType = (0,parsers_common/* parseDeprecatedMedicalCategoryCategoryTypeOf */.hk)(type !== null && type !== void 0 ? type : medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT);
    var ref = (0,react.useState)((0,parsers_diagnosis/* parseTreatmentRequestFormData */.V)({
        doctorId: "",
        categoryType: parsedDeprecatedCategoryType,
        categoryId: categoryId,
        targetDate: "",
        inflowType: inflowType,
        contactType: types_diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F,
        sortKey: sortKey
    })), treatmentRequestForm = ref[0], setTreatmentRequestForm = ref[1];
    var treatmentRequest = (0,react.useMemo)(function() {
        return new models_diagnosis/* TreatmentRequest */.qL(treatmentRequestForm);
    }, [
        treatmentRequestForm
    ]);
    var updateForm = (0,react.useCallback)(function(updater) {
        setTreatmentRequestForm(updater);
    }, []);
    var updateFormFromTreatmentRequest = (0,react.useCallback)(function(request) {
        setTreatmentRequestForm(request.getForm());
    }, []);
    return {
        treatmentRequestForm: treatmentRequestForm,
        treatmentRequest: treatmentRequest,
        setTreatmentRequestForm: setTreatmentRequestForm,
        updateForm: updateForm,
        updateFormFromTreatmentRequest: updateFormFromTreatmentRequest
    };
};

// EXTERNAL MODULE: ./src/entities/card/hooks/index.ts + 2 modules
var hooks = __webpack_require__(46951);
// EXTERNAL MODULE: ./src/entities/card/index.ts + 6 modules
var card = __webpack_require__(81518);
// EXTERNAL MODULE: ./src/hooks/common/common.gql.impl.tsx
var common_gql_impl = __webpack_require__(41793);
;// CONCATENATED MODULE: ./src/hooks/common/usePollingUserPayments.ts





var POLLING_INTERVAL_MS = 1000;
var MAX_POLLING_DURATION_MS = 120000;
var REMAINING_TIME_UPDATE_INTERVAL_MS = 100;
var PAYMENT_REGISTRATION_FAILURE_MESSAGE = "결제수단을 등록하는데 실패했습니다";
var parseUserPayments = function(data) {
    var payments = data.userPayments.map(function(payment) {
        return {
            canInstallment: payment.canInstallment,
            cardName: payment.cardName,
            cardNumber: payment.cardNumber,
            id: payment.id,
            isApproved: payment.isApproved,
            isDefault: payment.isDefault,
            payCompany: (0,card/* convertCardPayCompany */.us)(payment.payCompany)
        };
    });
    return new common/* UserPaymentsInfo */._u(payments);
};
var structuralSharingUserPayments = function(oldData, newData) {
    if (!oldData || !newData) return newData;
    if (!oldData.userPayments || !newData.userPayments) return newData;
    var oldPayments = oldData.userPayments;
    var newPayments = newData.userPayments;
    if (oldPayments.length !== newPayments.length) return newData;
    var hasChanged = !oldPayments.every(function(oldPayment, index) {
        return oldPayment.id === newPayments[index].id;
    });
    return hasChanged ? newData : oldData;
};
var usePollingUserPayments = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _enabled = options.enabled, enabled = _enabled === void 0 ? true : _enabled, _enablePolling = options.enablePolling, enablePolling = _enablePolling === void 0 ? false : _enablePolling;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var ref = (0,react.useState)(false), isPolling = ref[0], setIsPolling = ref[1];
    var ref1 = (0,react.useState)(0), remainingTime = ref1[0], setRemainingTime = ref1[1];
    var startTimeRef = (0,react.useRef)(null);
    var elapsedTimeRef = (0,react.useRef)(0);
    var timerRef = (0,react.useRef)(null);
    var visibilityCheckIntervalRef = (0,react.useRef)(null);
    var initialPaymentCountRef = (0,react.useRef)(0);
    var ref2 = (0,common_gql_impl/* useUserPaymentsQuery */.JQ)({}, {
        enabled: enabled || isPolling,
        refetchInterval: enablePolling && isPolling ? POLLING_INTERVAL_MS : false,
        select: parseUserPayments,
        keepPreviousData: true,
        notifyOnChangeProps: [
            "data"
        ],
        structuralSharing: structuralSharingUserPayments
    }), _data = ref2.data, data = _data === void 0 ? new common/* UserPaymentsInfo */._u([]) : _data, refetch = ref2.refetch, isRefetching = ref2.isRefetching, isFetched = ref2.isFetched;
    var clearTimers = (0,react.useCallback)(function() {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (visibilityCheckIntervalRef.current) {
            clearInterval(visibilityCheckIntervalRef.current);
            visibilityCheckIntervalRef.current = null;
        }
    }, []);
    var stopPolling = (0,react.useCallback)(function() {
        setIsPolling(false);
        setRemainingTime(0);
        startTimeRef.current = null;
        elapsedTimeRef.current = 0;
        initialPaymentCountRef.current = 0;
        clearTimers();
    }, [
        clearTimers
    ]);
    var startPolling = (0,react.useCallback)(function() {
        if (!enablePolling) return;
        stopPolling();
        var now = Date.now();
        startTimeRef.current = now;
        elapsedTimeRef.current = 0;
        initialPaymentCountRef.current = data.payments.length;
        setIsPolling(true);
        setRemainingTime(MAX_POLLING_DURATION_MS);
        timerRef.current = setTimeout(function() {
            toast({
                text: PAYMENT_REGISTRATION_FAILURE_MESSAGE,
                direction: "bottom"
            });
            stopPolling();
        }, MAX_POLLING_DURATION_MS);
        visibilityCheckIntervalRef.current = setInterval(function() {
            if (startTimeRef.current && document.visibilityState === "visible") {
                var elapsed = Date.now() - startTimeRef.current;
                var remaining = Math.max(0, MAX_POLLING_DURATION_MS - elapsed);
                setRemainingTime(remaining);
            }
        }, REMAINING_TIME_UPDATE_INTERVAL_MS);
    }, [
        enablePolling,
        stopPolling,
        toast,
        data
    ]);
    (0,react.useEffect)(function() {
        if (!enablePolling) return;
        var handleVisibilityChange = function() {
            if (!startTimeRef.current) return;
            if (document.visibilityState === "hidden") {
                var elapsed = Date.now() - startTimeRef.current;
                elapsedTimeRef.current = elapsed;
                setIsPolling(false);
                clearTimers();
            } else if (document.visibilityState === "visible") {
                var remainingDuration = MAX_POLLING_DURATION_MS - elapsedTimeRef.current;
                if (remainingDuration <= 0) {
                    toast({
                        text: PAYMENT_REGISTRATION_FAILURE_MESSAGE,
                        direction: "bottom"
                    });
                    stopPolling();
                    return;
                }
                startTimeRef.current = Date.now() - elapsedTimeRef.current;
                setIsPolling(true);
                setRemainingTime(remainingDuration);
                timerRef.current = setTimeout(function() {
                    toast({
                        text: PAYMENT_REGISTRATION_FAILURE_MESSAGE,
                        direction: "bottom"
                    });
                    stopPolling();
                }, remainingDuration);
                visibilityCheckIntervalRef.current = setInterval(function() {
                    if (startTimeRef.current && document.visibilityState === "visible") {
                        var elapsed = Date.now() - startTimeRef.current;
                        var remaining = Math.max(0, MAX_POLLING_DURATION_MS - elapsed);
                        setRemainingTime(remaining);
                    }
                }, REMAINING_TIME_UPDATE_INTERVAL_MS);
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return function() {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            clearTimers();
        };
    }, [
        enablePolling,
        clearTimers,
        stopPolling,
        toast
    ]);
    (0,react.useEffect)(function() {
        if (!isPolling) return;
        var currentPaymentCount = data.payments.length;
        var hasNewPayment = currentPaymentCount > initialPaymentCountRef.current;
        if (hasNewPayment) {
            stopPolling();
        }
    }, [
        isPolling,
        data,
        stopPolling
    ]);
    return {
        userPaymentsInfo: data,
        refetchUserPayments: refetch,
        isUserPaymentsInfoRefetching: isRefetching,
        isUserPaymentsInfoFetched: isFetched,
        startPollingUserPayments: startPolling,
        stopPollingUserPayments: stopPolling,
        isPollingUserPayments: isPolling,
        remainingTime: Math.ceil(remainingTime / 1000)
    };
};
/* harmony default export */ var common_usePollingUserPayments = (usePollingUserPayments);

// EXTERNAL MODULE: ./src/hooks/common/useUserPointAmount.ts
var useUserPointAmount = __webpack_require__(69319);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicinePayment.ts












var useTelemedicinePayment = function(param) {
    var treatmentRequest = param.treatmentRequest, updateForm = param.updateForm, client = param.client;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var point = (0,useUserPointAmount/* default */.Z)(treatmentRequest.shouldShowPointUseRequest()).point;
    var ref = common_usePollingUserPayments({
        enabled: false,
        enablePolling: true
    }), userPaymentsInfo = ref.userPaymentsInfo, refetchUserPayments = ref.refetchUserPayments, isUserPaymentsInfoRefetching = ref.isUserPaymentsInfoRefetching, isUserPaymentsInfoFetched = ref.isUserPaymentsInfoFetched, startPollingUserPayments = ref.startPollingUserPayments, isPollingUserPayments = ref.isPollingUserPayments;
    var onSubmitReadyKakaopayRegistration = (0,hooks/* useReadyKakaopayRegistration */.Dg)().onSubmitReadyKakaopayRegistration;
    var ref1 = (0,react.useState)(), cardCompanyButton = ref1[0], setCardCompanyButton = ref1[1];
    var treatmentRequestRef = (0,react.useRef)(treatmentRequest);
    var updateFormRef = (0,react.useRef)(updateForm);
    var previousPollingRef = (0,react.useRef)(false);
    var previousPaymentCountRef = (0,react.useRef)(0);
    var isInitializedRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        treatmentRequestRef.current = treatmentRequest;
    }, [
        treatmentRequest
    ]);
    (0,react.useEffect)(function() {
        updateFormRef.current = updateForm;
    }, [
        updateForm
    ]);
    (0,react.useEffect)(function() {
        if (!isInitializedRef.current) {
            previousPaymentCountRef.current = userPaymentsInfo.payments.length;
            isInitializedRef.current = true;
        }
    }, [
        userPaymentsInfo.payments.length
    ]);
    (0,react.useEffect)(function() {
        var wasPolling = previousPollingRef.current;
        var isNowNotPolling = !isPollingUserPayments;
        var currentPaymentCount = userPaymentsInfo.payments.length;
        var hasNewPayment = isInitializedRef.current && currentPaymentCount > previousPaymentCountRef.current;
        if (wasPolling && isNowNotPolling && hasNewPayment) {
            var firstPayment = userPaymentsInfo.payments[0];
            if (firstPayment) {
                var currentRequest = treatmentRequestRef.current;
                var form = currentRequest.selectCard(firstPayment.id);
                updateFormRef.current(function(prev) {
                    return (0,_object_spread/* default */.Z)({}, prev, form);
                });
                if (firstPayment.payCompany === common/* CardPayCompany.Kakaopay */.sw.Kakaopay) {
                    setCardCompanyButton(CardCompanyButtonType.KAKAOPAY);
                } else {
                    setCardCompanyButton(CardCompanyButtonType.ANOTHER);
                }
                previousPaymentCountRef.current = currentPaymentCount;
            }
        }
        previousPollingRef.current = isPollingUserPayments;
    }, [
        isPollingUserPayments,
        userPaymentsInfo
    ]);
    var selectCard = (0,react.useCallback)(function(paymentId) {
        var currentRequest = treatmentRequestRef.current;
        var form = currentRequest.selectCard(paymentId);
        updateFormRef.current(function(prev) {
            return (0,_object_spread/* default */.Z)({}, prev, form);
        });
    }, []);
    var updateInstallment = (0,react.useCallback)(function(installmentMonth) {
        var currentRequest = treatmentRequestRef.current;
        var form = currentRequest.updateInstallment(installmentMonth);
        updateFormRef.current(function() {
            return form;
        });
    }, []);
    var toggleRequestUsePoint = (0,react.useCallback)(function() {
        if (point < 100) {
            toast({
                text: "100P 이상부터 사용할 수 있어요.",
                direction: "bottom"
            });
            return;
        }
        var currentRequest = treatmentRequestRef.current;
        var form = currentRequest.toggleRequestUsePoint();
        updateFormRef.current(function() {
            return form;
        });
    }, [
        point,
        toast
    ]);
    var selectCardCompanyButton = (0,react.useCallback)(function(company) {
        setCardCompanyButton(company);
    }, []);
    var selectAddress = (0,react.useCallback)(function(selectedAddress) {
        var currentRequest = treatmentRequestRef.current;
        var _userAddressId;
        updateFormRef.current(function(prevForm) {
            return currentRequest.selectAddress(prevForm, (_userAddressId = selectedAddress.userAddressId) !== null && _userAddressId !== void 0 ? _userAddressId : "");
        });
    }, []);
    var addKakaopay = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var result, nextRedirectMobileUrl, nextRedirectPcUrl, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        onSubmitReadyKakaopayRegistration()
                    ];
                case 1:
                    result = _state.sent();
                    nextRedirectMobileUrl = result.nextRedirectMobileUrl, nextRedirectPcUrl = result.nextRedirectPcUrl;
                    if (client.clientType === app/* ClientType.WEB */.B.WEB) {
                        window.open(nextRedirectPcUrl);
                        startPollingUserPayments();
                        return [
                            2
                        ];
                    }
                    if (client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB) {
                        window.open(nextRedirectMobileUrl);
                        startPollingUserPayments();
                        return [
                            2
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    if ((0,_instanceof/* default */.Z)(error, Error)) {
                        toast({
                            text: (0,_instanceof/* default */.Z)(error, Error) ? error.message : "카카오페이 등록 정보를 가져오는데 실패했습니다.",
                            direction: "bottom"
                        });
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        client.clientType,
        onSubmitReadyKakaopayRegistration,
        startPollingUserPayments,
        toast
    ]);
    var selectInitCreditCard = (0,react.useCallback)(function(paymentsInfo) {
        var currentRequest = treatmentRequestRef.current;
        var defaultPayment = paymentsInfo.findDefaultPayment();
        if (defaultPayment) {
            var form = currentRequest.selectCard(defaultPayment.id);
            updateFormRef.current(function(prev) {
                return (0,_object_spread/* default */.Z)({}, prev, form);
            });
            if (defaultPayment.payCompany === common/* CardPayCompany.Kakaopay */.sw.Kakaopay) {
                selectCardCompanyButton(CardCompanyButtonType.KAKAOPAY);
            } else {
                selectCardCompanyButton(CardCompanyButtonType.ANOTHER);
            }
        } else {
            selectCardCompanyButton(CardCompanyButtonType.ANOTHER);
        }
    }, [
        selectCardCompanyButton
    ]);
    return {
        point: point,
        cardCompanyButton: cardCompanyButton,
        userPaymentsInfo: userPaymentsInfo,
        isUserPaymentsInfoRefetching: isUserPaymentsInfoRefetching,
        isUserPaymentsInfoFetched: isUserPaymentsInfoFetched,
        selectCard: selectCard,
        updateInstallment: updateInstallment,
        toggleRequestUsePoint: toggleRequestUsePoint,
        selectCardCompanyButton: selectCardCompanyButton,
        selectAddress: selectAddress,
        addKakaopay: addKakaopay,
        refetchUserPayments: refetchUserPayments,
        selectInitCreditCard: selectInitCreditCard
    };
};

// EXTERNAL MODULE: ./src/hooks/diagnosis/useRequestDiagnosisV2.ts
var useRequestDiagnosisV2 = __webpack_require__(1528);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineRequestSubmission.ts















var useTelemedicineRequestSubmission = function(param) {
    var bookingSchedulesInfo = param.bookingSchedulesInfo, categoriesInfo = param.categoriesInfo;
    var ref = (0,react.useState)(false), isRequestDiagnosisLoading = ref[0], setIsRequestDiagnosisLoading = ref[1];
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var router = (0,useCustomRouter/* default */.Z)().router;
    var mutateRequestDiagnosis = (0,useRequestDiagnosisV2/* default */.Z)().mutateRequestDiagnosis;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var moveToCertificationGuide = (0,react.useCallback)(function() {
        router.push("".concat(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path) + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            step: models_diagnosis/* EDiagnosisStep.CertificationGuide */.cR.CertificationGuide
        })));
    }, [
        router
    ]);
    var moveToDiagnosisStep = (0,react.useCallback)(function() {
        router.push("".concat(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path) + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            step: models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis
        })));
    }, [
        router
    ]);
    var getParsedCategoryType = function(categoryType) {
        return categoryType === models_diagnosis/* DiagnosisCategoryType.Treatment */.P2.Treatment ? medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT : medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT;
    };
    var getCategoryName = function(categoryId, categoryType) {
        return categoriesInfo.getCategoryNameByIdAndType(categoryId, getParsedCategoryType(categoryType));
    };
    var requestDiagnosis = (0,react.useCallback)(debounce_default()(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(options) {
            var _skipCertificationCheck, skipCertificationCheck;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        skipCertificationCheck = (_skipCertificationCheck = options.skipCertificationCheck) !== null && _skipCertificationCheck !== void 0 ? _skipCertificationCheck : false;
                        if (isRequestDiagnosisLoading) {
                            return [
                                2
                            ];
                        }
                        if (!options.treatmentRequest.form.inflowType) {
                            toast({
                                text: "진료 유형을 선택해주세요",
                                direction: "bottom"
                            });
                            return [
                                2
                            ];
                        }
                        if (!skipCertificationCheck && options.isUserNeedVerificationForDiagnosis) {
                            moveToCertificationGuide();
                            return [
                                2
                            ];
                        }
                        setIsRequestDiagnosisLoading(true);
                        return [
                            4,
                            mutateRequestDiagnosis({
                                request: useRequestDiagnosisV2/* default.parseRequestDiagnosisFromTreatmentRequest */.Z.parseRequestDiagnosisFromTreatmentRequest(options.treatmentRequest)
                            }, {
                                onSuccess: function() {
                                    var diagnosisDate = bookingSchedulesInfo.getSelectedTimeSlotTitle(options.treatmentRequest);
                                    var doctorPid = options.treatmentRequest.form.doctorPid;
                                    if (!doctorPid) {
                                        return;
                                    }
                                    var _categoryId, _categoryType;
                                    var categoryName = getCategoryName((_categoryId = options.treatmentRequest.form.categoryId) !== null && _categoryId !== void 0 ? _categoryId : "", (_categoryType = options.treatmentRequest.form.categoryType) !== null && _categoryType !== void 0 ? _categoryType : models_diagnosis/* DiagnosisCategoryType.Treatment */.P2.Treatment);
                                    router.replace("/telemedicine/request-complete" + (0,url/* addQueryString */.sC)({
                                        diagnosisDate: diagnosisDate,
                                        medicalCategoryName: categoryName,
                                        doctorId: doctorPid
                                    }));
                                },
                                onError: function(error) {
                                    setIsRequestDiagnosisLoading(false);
                                    showModal({
                                        type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                                        props: {
                                            title: error.message,
                                            buttons: [
                                                {
                                                    type: modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                                                    label: "확인",
                                                    onClick: function() {
                                                        closeModal();
                                                        switch(error.code){
                                                            case "BookingDeadLineExceeded":
                                                                moveToDiagnosisStep();
                                                                break;
                                                            default:
                                                                break;
                                                        }
                                                    }
                                                }, 
                                            ],
                                            onClickOverlay: closeModal
                                        }
                                    });
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(options) {
            return _ref.apply(this, arguments);
        };
    }(), 1000, {
        leading: true,
        trailing: false
    }), [
        bookingSchedulesInfo,
        categoriesInfo
    ] // 최초 호출 및 필수 의존성 추가
    );
    return {
        requestDiagnosis: requestDiagnosis,
        isRequestDiagnosisLoading: isRequestDiagnosisLoading
    };
};

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineSchedule.ts







var useTelemedicineSchedule = function(param) {
    var treatmentRequest = param.treatmentRequest, bookingSchedulesInfo = param.bookingSchedulesInfo, updateFormFromTreatmentRequest = param.updateFormFromTreatmentRequest, accordionRefs = param.accordionRefs, focusSsnInput = param.focusSsnInput;
    var logger = (0,useLogger/* default */.Z)();
    var treatmentRequestRef = (0,react.useRef)(treatmentRequest);
    var updateFormFromTreatmentRequestRef = (0,react.useRef)(updateFormFromTreatmentRequest);
    (0,react.useEffect)(function() {
        treatmentRequestRef.current = treatmentRequest;
    }, [
        treatmentRequest
    ]);
    (0,react.useEffect)(function() {
        updateFormFromTreatmentRequestRef.current = updateFormFromTreatmentRequest;
    }, [
        updateFormFromTreatmentRequest
    ]);
    var selectedDay = (0,react.useMemo)(function() {
        return bookingSchedulesInfo.findSelectedDayScheduleGroupedByTimePeriod(treatmentRequest);
    }, [
        bookingSchedulesInfo,
        treatmentRequest
    ]);
    var selectedDayScheduleLength = (0,react.useMemo)(function() {
        var _length, _length1, _length2, _length3;
        return ((_length = selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.dawnSchedules.length) !== null && _length !== void 0 ? _length : 0) + ((_length1 = selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.morningSchedules.length) !== null && _length1 !== void 0 ? _length1 : 0) + ((_length2 = selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.afternoonSchedules.length) !== null && _length2 !== void 0 ? _length2 : 0) + ((_length3 = selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.nightSchedules.length) !== null && _length3 !== void 0 ? _length3 : 0);
    }, [
        selectedDay
    ]);
    var selectBookingTargetDate = (0,react.useCallback)(function(bookingTargetDate) {
        var currentRequest = treatmentRequestRef.current;
        currentRequest.selectBookingTargetDate(bookingTargetDate);
        updateFormFromTreatmentRequestRef.current(currentRequest);
    }, []);
    var selectBookingTimeSlot = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(startTimeSlotValue, endTimeSlotValue) {
            var ref, ref1, currentRequest, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentRequest = treatmentRequestRef.current;
                        currentRequest.selectBookingTimeSlot(startTimeSlotValue, endTimeSlotValue);
                        updateFormFromTreatmentRequestRef.current(currentRequest);
                        logger.log({
                            eventName: libs/* EWebTreatmentRequestLog.ClickRequestTime */.o5.ClickRequestTime
                        });
                        if (currentRequest.isInHospitalDelivery()) {
                            ;
                            (ref2 = accordionRefs[AccordionState.Days].current) === null || ref2 === void 0 ? void 0 : ref2.closeSection();
                            return [
                                2
                            ];
                        }
                        (ref = accordionRefs[AccordionState.Days].current) === null || ref === void 0 ? void 0 : ref.closeSection();
                        (ref1 = accordionRefs[AccordionState.Ssn].current) === null || ref1 === void 0 ? void 0 : ref1.openSection({
                            scroll: true
                        });
                        return [
                            4,
                            focusSsnInput()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(startTimeSlotValue, endTimeSlotValue) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accordionRefs,
        focusSsnInput,
        logger
    ]);
    var toggleAsapRequest = (0,react.useCallback)(function() {
        var currentRequest = treatmentRequestRef.current;
        currentRequest.toggleAsapRequest();
        updateFormFromTreatmentRequestRef.current(currentRequest);
    }, []);
    var selectQuickMode = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, currentRequest;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentRequest = treatmentRequestRef.current;
                    currentRequest.setScheduleMode(models_diagnosis/* TreatmentRequestInflowType.WEB_QUICK */.FT.WEB_QUICK);
                    updateFormFromTreatmentRequestRef.current(currentRequest);
                    (ref = accordionRefs[AccordionState.Days].current) === null || ref === void 0 ? void 0 : ref.closeSection();
                    (ref1 = accordionRefs[AccordionState.Ssn].current) === null || ref1 === void 0 ? void 0 : ref1.openSection({
                        scroll: false
                    });
                    return [
                        4,
                        focusSsnInput()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        accordionRefs,
        focusSsnInput
    ]);
    var selectGeneralMode = (0,react.useCallback)(function() {
        var ref;
        var currentRequest = treatmentRequestRef.current;
        currentRequest.setScheduleMode(models_diagnosis/* TreatmentRequestInflowType.WEB_GENERAL */.FT.WEB_GENERAL);
        var firstDay = bookingSchedulesInfo.daySchedulesGroupedByTimePeriod[0];
        if (firstDay) {
            currentRequest.selectBookingTargetDate(firstDay.targetDate);
        }
        updateFormFromTreatmentRequestRef.current(currentRequest);
        (ref = accordionRefs[AccordionState.Days].current) === null || ref === void 0 ? void 0 : ref.openSection();
    }, [
        accordionRefs,
        bookingSchedulesInfo
    ]);
    var toggleQuickScheduleMode = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var currentRequest, ref, ref1, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentRequest = treatmentRequestRef.current;
                    currentRequest.toggleQuickScheduleMode();
                    updateFormFromTreatmentRequestRef.current(currentRequest);
                    if (!!currentRequest.isWebQuickScheduleRequest()) return [
                        3,
                        1
                    ];
                    (ref = accordionRefs[AccordionState.Days].current) === null || ref === void 0 ? void 0 : ref.openSection();
                    return [
                        3,
                        3
                    ];
                case 1:
                    (ref1 = accordionRefs[AccordionState.Days].current) === null || ref1 === void 0 ? void 0 : ref1.closeSection();
                    (ref2 = accordionRefs[AccordionState.Ssn].current) === null || ref2 === void 0 ? void 0 : ref2.openSection({
                        scroll: false
                    });
                    return [
                        4,
                        focusSsnInput()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        accordionRefs,
        focusSsnInput
    ]);
    var selectInitSchedule = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(targetDate) {
            var ref, currentRequest, currentSelectedDate, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentRequest = treatmentRequestRef.current;
                        currentSelectedDate = currentRequest.form.bookingTargetDate;
                        if (currentRequest.isWebQuickScheduleRequest()) {
                            ;
                            (ref1 = accordionRefs[AccordionState.Days].current) === null || ref1 === void 0 ? void 0 : ref1.openSection();
                            return [
                                2
                            ];
                        }
                        if (!targetDate) {
                            ;
                            logger.log({
                                eventName: libs/* TreatmentRequestLog.RequestPageInWithoutTargetDate */.Js.RequestPageInWithoutTargetDate
                            });
                            (ref2 = accordionRefs[AccordionState.Days].current) === null || ref2 === void 0 ? void 0 : ref2.openSection();
                            return [
                                2
                            ];
                        }
                        logger.log({
                            eventName: libs/* TreatmentRequestLog.RequestPageInWithTargetDate */.Js.RequestPageInWithTargetDate
                        });
                        if (targetDate !== currentSelectedDate) {
                            currentRequest.selectBookingTargetDate(targetDate);
                            updateFormFromTreatmentRequestRef.current(currentRequest);
                        }
                        (ref = accordionRefs[AccordionState.Ssn].current) === null || ref === void 0 ? void 0 : ref.openSection();
                        return [
                            4,
                            focusSsnInput()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(targetDate) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accordionRefs,
        focusSsnInput,
        logger
    ]);
    return {
        selectedDay: selectedDay,
        selectedDayScheduleLength: selectedDayScheduleLength,
        selectBookingTargetDate: selectBookingTargetDate,
        selectBookingTimeSlot: selectBookingTimeSlot,
        toggleAsapRequest: toggleAsapRequest,
        selectQuickMode: selectQuickMode,
        selectGeneralMode: selectGeneralMode,
        toggleQuickScheduleMode: toggleQuickScheduleMode,
        selectInitSchedule: selectInitSchedule
    };
};

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineSsn.ts










var useTelemedicineSsn = function(param) {
    var treatmentRequest = param.treatmentRequest, updateForm = param.updateForm, accordionRefs = param.accordionRefs, hasVideoRequestCallType = param.hasVideoRequestCallType, detailSymptomInputRef = param.detailSymptomInputRef;
    var logger = (0,useLogger/* default */.Z)();
    var ssnInputRef = (0,react.useRef)(null);
    var blurActiveElement = function() {
        if ((0,_instanceof/* default */.Z)(document.activeElement, HTMLElement)) {
            document.activeElement.blur();
        }
    };
    var focusDetailSymptomInput = (0,react.useCallback)(function() {
        return new Promise(function(resolve) {
            logger.log({
                eventName: libs/* EWebTreatmentRequestLog.ClickRequestTypeOpen */.o5.ClickRequestTypeOpen
            });
            requestAnimationFrame(function() {
                var ref;
                (ref = detailSymptomInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                resolve();
            });
        });
    }, [
        logger
    ]);
    var nextFlowAfterSsn = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        blurActiveElement();
                        if (hasVideoRequestCallType) {
                            ;
                            (ref2 = accordionRefs[AccordionState.Ssn].current) === null || ref2 === void 0 ? void 0 : ref2.closeSection();
                            (ref3 = accordionRefs[AccordionState.RequestCallType].current) === null || ref3 === void 0 ? void 0 : ref3.openSection({
                                scroll: false
                            });
                            return [
                                2
                            ];
                        }
                        (ref = accordionRefs[AccordionState.Ssn].current) === null || ref === void 0 ? void 0 : ref.closeSection();
                        (ref1 = accordionRefs[AccordionState.DetailSymptom].current) === null || ref1 === void 0 ? void 0 : ref1.openSection({
                            scroll: false
                        });
                        return [
                            4,
                            focusDetailSymptomInput()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function nextFlowAfterSsn() {
            return _ref.apply(this, arguments);
        };
    }();
    var updatePatientSsn = debounce_default()(function(patientSsn) {
        var form = treatmentRequest.updatePatientSsn(patientSsn);
        var ssnInputStatus = treatmentRequest.getCurrentSsnStatus();
        updateForm(function(prev) {
            return (0,_object_spread/* default */.Z)({}, prev, form);
        });
        if (ssnInputStatus !== models_diagnosis/* SsnInputStatus.Completed */.D2.Completed) {
            return;
        }
        logger.log({
            eventName: libs/* TreatmentRequestLog.RequestSuccessSsn */.Js.RequestSuccessSsn
        });
        nextFlowAfterSsn();
    }, 150);
    var resetPatientSsn = function() {
        var form = treatmentRequest.resetPatientSsn();
        updateForm(function(prev) {
            return (0,_object_spread/* default */.Z)({}, prev, form);
        });
    };
    var focusSsnInput = function() {
        return new Promise(function(resolve) {
            requestAnimationFrame(function() {
                var ref;
                (ref = ssnInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                resolve();
            });
        });
    };
    return {
        ssnInputRef: ssnInputRef,
        updatePatientSsn: updatePatientSsn,
        resetPatientSsn: resetPatientSsn,
        focusSsnInput: focusSsnInput
    };
};

// EXTERNAL MODULE: ./src/hooks/diagnosis/useDiagnosisAttachmentPreSignedUrls.ts
var useDiagnosisAttachmentPreSignedUrls = __webpack_require__(30862);
// EXTERNAL MODULE: ./src/utils/image.ts
var utils_image = __webpack_require__(60288);
;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineSymptom.ts










var MAX_SYMPTOM_IMAGE_COUNT = 4;
var useTelemedicineSymptom = function(param) {
    var treatmentRequest = param.treatmentRequest, updateForm = param.updateForm, detailSymptomInputRef = param.detailSymptomInputRef, userTargetId = param.userTargetId;
    var logger = (0,useLogger/* default */.Z)();
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var ref1 = (0,useDiagnosisAttachmentPreSignedUrls/* default */.Z)(), mutatePresignedUrls = ref1.mutatePresignedUrls, isPreSignedUrlsLoading = ref1.isPreSignedUrlsLoading;
    var updateSymptom = function(symptom) {
        var form = treatmentRequest.updateSymptom(symptom);
        updateForm(function() {
            return form;
        });
    };
    var updateSymptomImages = function(imageUrls) {
        var form = treatmentRequest.updateSymptomImages(imageUrls);
        updateForm(function() {
            return form;
        });
    };
    var removeSymptomImage = function(index) {
        var form = treatmentRequest.removeSymptomImage(index);
        updateForm(function() {
            return form;
        });
    };
    var uploadImageToS3 = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(files) {
            var ref, success, imageFileList, symptomImages;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            mutatePresignedUrls({
                                files: files
                            })
                        ];
                    case 1:
                        ref = _state.sent(), success = ref.success, imageFileList = ref.imageFileList;
                        if (success) {
                            symptomImages = imageFileList.map(function(image) {
                                return {
                                    fileUrl: image.preSignedUrl,
                                    thumbnailUrl: image.thumbnailUrl
                                };
                            });
                            updateSymptomImages(symptomImages);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadImageToS3(files) {
            return _ref.apply(this, arguments);
        };
    }();
    var onHandleChangeSymptomImage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var attachedFile, enabledImageCount, filteredImages, convertedImages, images, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!e.target.files) return [
                            3,
                            4
                        ];
                        attachedFile = Array.from(e.target.files);
                        enabledImageCount = MAX_SYMPTOM_IMAGE_COUNT - treatmentRequest.form.symptomInfo.attachFiles.length;
                        if (!(enabledImageCount > 0)) return [
                            3,
                            4
                        ];
                        filteredImages = attachedFile.slice(0, enabledImageCount).filter(function(image) {
                            var isImage = image.type.includes("image");
                            if (!isImage) {
                                showModal({
                                    type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                                    props: {
                                        title: "사진 파일을 올려주세요",
                                        message: "jpg, jpeg, png 확장자만 올릴 수 있어요.",
                                        buttons: [
                                            {
                                                type: modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                                label: "확인",
                                                onClick: function() {
                                                    closeModal();
                                                }
                                            }, 
                                        ]
                                    }
                                });
                                return false;
                            }
                            return isImage;
                        });
                        return [
                            4,
                            Promise.all(filteredImages.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(image) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!image.type.includes("heic")) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0,utils_image/* convertHeic */.RW)(image)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    image
                                                ];
                                        }
                                    });
                                });
                                return function(image) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        convertedImages = _state.sent();
                        return [
                            4,
                            Promise.all(convertedImages.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(image) {
                                    var _tmp;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _tmp = {};
                                                return [
                                                    4,
                                                    (0,utils_image/* onCompressImage */.VM)(image, {
                                                        maxSizeMB: 5
                                                    })
                                                ];
                                            case 1:
                                                _tmp.origin = _state.sent();
                                                return [
                                                    4,
                                                    (0,utils_image/* onCompressImage */.VM)(image, {
                                                        maxSizeMB: 0.2,
                                                        maxWidthOrHeight: 300
                                                    })
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    (_tmp.thumbnail = _state.sent(), _tmp)
                                                ];
                                        }
                                    });
                                });
                                return function(image) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        images = _state.sent();
                        return [
                            4,
                            uploadImageToS3(images)
                        ];
                    case 3:
                        _state.sent();
                        e.target.value = "";
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        if ((0,_instanceof/* default */.Z)(error, Error)) {
                            (0,report/* debugReport */.cl)("진료신청서 > 사진 업로드 실패 userTargetId: ".concat(userTargetId), {
                                message: error.message
                            }, error);
                        }
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onHandleChangeSymptomImage(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMedicineSelect = function(item) {
        var ref, ref1;
        logger.log({
            eventName: libs/* TreatmentRequestLog.RequestClickNonBenefitCategory */.Js.RequestClickNonBenefitCategory
        });
        treatmentRequest.updateTreatmentMedicineId(item.id);
        updateForm(function() {
            return treatmentRequest.getForm();
        });
        (ref = detailSymptomInputRef.current) === null || ref === void 0 ? void 0 : ref.scroll();
        (ref1 = detailSymptomInputRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
    };
    return {
        isPreSignedUrlsLoading: isPreSignedUrlsLoading,
        updateSymptom: updateSymptom,
        removeSymptomImage: removeSymptomImage,
        onHandleChangeSymptomImage: onHandleChangeSymptomImage,
        handleMedicineSelect: handleMedicineSelect
    };
};

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/useTelemedicineRequestViewModel.ts














































var CardCompanyButtonType;
(function(CardCompanyButtonType) {
    CardCompanyButtonType["KAKAOPAY"] = "KAKAOPAY";
    CardCompanyButtonType["ANOTHER"] = "ANOTHER";
})(CardCompanyButtonType || (CardCompanyButtonType = {}));
var AccordionState;
(function(AccordionState) {
    AccordionState["Days"] = "days";
    AccordionState["IsVisitBrand"] = "isVisitBrand";
    AccordionState["Ssn"] = "ssn";
    AccordionState["ChildInfo"] = "childInfo";
    AccordionState["DetailSymptom"] = "detailSymptom";
    AccordionState["RequestCallType"] = "requestCallType";
})(AccordionState || (AccordionState = {}));
var chronicDiseaseCategoryIds = [
    "607",
    "570",
    "569",
    "611"
];
var DEFAULT_CHRONIC_DISEASE_CATEGORY_WARNING_MESSAGES = [
    "병원에서 진행한 혈액 검사 결과가 있다면 더 좋아요.",
    "복용 중인 약의 이름을 입력해주세요.",
    "약이나 약 봉투 또는 처방전을 찍어 함께 올려주세요.", 
];
var chronicDiseaseCategoryWarningMessageMap = {
    "607": [
        "가장 최근 측정한 혈압 수치를 입력해주세요."
    ].concat((0,_to_consumable_array/* default */.Z)(DEFAULT_CHRONIC_DISEASE_CATEGORY_WARNING_MESSAGES)),
    "570": [
        "가장 최근 측정한 콜레스테롤 수치를 입력해주세요."
    ].concat((0,_to_consumable_array/* default */.Z)(DEFAULT_CHRONIC_DISEASE_CATEGORY_WARNING_MESSAGES)),
    "569": [
        "가장 최근 측정한 당화혈색소, 공복 혈당을 입력해주세요.", 
    ].concat((0,_to_consumable_array/* default */.Z)(DEFAULT_CHRONIC_DISEASE_CATEGORY_WARNING_MESSAGES)),
    "611": [
        "가장 최근 측정한 요산 수치를 입력해주세요."
    ].concat((0,_to_consumable_array/* default */.Z)(DEFAULT_CHRONIC_DISEASE_CATEGORY_WARNING_MESSAGES))
};
var chronicDiseaseCategoryPlaceholderMap = {
    "607": "복용 중인 약, 혈압 수치를 입력해주세요",
    "570": "복용 중인 약, 콜레스테롤 수치를 입력해주세요",
    "569": "복용 중인 약, 당화혈색소, 공복 혈당을 입력해주세요",
    "611": "복용 중인 약, 요산 수치를 입력해주세요"
};
var useTelemedicineRequestViewModel = function(client) {
    var logger = (0,useLogger/* default */.Z)();
    var isFocused = (0,useWebViewFocused/* default */.Z)();
    var toast = (0,index_es/* useToast */.pm)().toast;
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var router = (0,useCustomRouter/* default */.Z)().router;
    var user = (0,es.useRecoilValue)(common_user/* userState */.KL);
    var refetchUser = (0,entities_user/* useRefetchUser */.mD)().refetchUser;
    var getQuickDiagnosisDoctorInfo = (0,entities_doctor/* useQuickDiagnosisDoctor */.Aj)().getQuickDiagnosisDoctorInfo;
    var queries = router.query;
    var type = queries.type, categoryId = queries.categoryId, userTargetId = queries.userTargetId, _step = queries.step, step = _step === void 0 ? models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis : _step, _targetDate = queries.targetDate, targetDate = _targetDate === void 0 ? "" : _targetDate, _contactType = queries.contactType, contactType = _contactType === void 0 ? types_diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F : _contactType;
    var detailSymptomInputRef = (0,react.useRef)(null);
    var reVisitBrandWrapperRef = (0,react.useRef)(null);
    var cardListWrapperRef = (0,react.useRef)(null);
    var ref1 = (0,useUserProfiles/* default */.Z)(), userProfiles = ref1.userProfiles, isUserProfilesFetched = ref1.isUserProfilesFetched;
    var ref2 = (0,diagnosis/* useDiagnosesByUserV2 */.QB)({
        size: 5
    }), recentlyDetailSymptoms = ref2.recentlyDetailSymptoms, recentlyDetailSymptomsCount = ref2.recentlyDetailSymptomsCount;
    var categoriesInfo = (0,useGetDiagnosisCategories/* default */.Z)().categoriesInfo;
    var ref3 = (0,entities_telemedicine/* useGetBookingSchedules */.pH)(), bookingSchedulesInfo = ref3.bookingSchedulesInfo, isBookingSchedulesFetched = ref3.isBookingSchedulesFetched;
    var ref4 = (0,react.useState)(false), isCardInstallmentBottomSheetOpen = ref4[0], setIsCardInstallmentBottomSheetOpen = ref4[1];
    var ref5 = (0,react.useState)(false), isRadioBottomSheetOpen = ref5[0], setIsRadioBottomSheetOpen = ref5[1];
    var ref6 = (0,react.useState)(null), selectedDoctorDetail = ref6[0], setSelectedDoctorPublicId = ref6[1];
    var ref7 = (0,react.useState)(false), isEnabledScheduleAlertOpen = ref7[0], setIsEnabledScheduleAlertOpen = ref7[1];
    var ref8 = (0,react.useState)(""), selectedStartDisplayTimeSlot = ref8[0], setSelectedStartDisplayTimeSlot = ref8[1];
    var ref9 = hooks_useCategoryGuideBottomSheet(), categoryGuideBottomSheetStates = ref9.categoryGuideBottomSheetStates, categoryGuideBottomSheetActions = ref9.categoryGuideBottomSheetActions, categoryGuideBottomSheetOpenActionMap = ref9.categoryGuideBottomSheetOpenActionMap;
    var formState = useTelemedicineFormState({
        queries: queries
    });
    var treatmentRequest = formState.treatmentRequest, updateForm = formState.updateForm, updateFormFromTreatmentRequest = formState.updateFormFromTreatmentRequest;
    var accordion = useTelemedicineAccordion();
    var accordionRefs = accordion.accordionRefs;
    var ref10 = useTelemedicineSsn({
        treatmentRequest: treatmentRequest,
        updateForm: updateForm,
        accordionRefs: accordionRefs,
        hasVideoRequestCallType: treatmentRequest.form.hasVideoRequestCallType,
        detailSymptomInputRef: detailSymptomInputRef
    }), ssnInputRef = ref10.ssnInputRef, updatePatientSsn = ref10.updatePatientSsn, resetPatientSsn = ref10.resetPatientSsn, focusSsnInput = ref10.focusSsnInput;
    var ref11 = useTelemedicineSymptom({
        treatmentRequest: treatmentRequest,
        updateForm: updateForm,
        detailSymptomInputRef: detailSymptomInputRef,
        userTargetId: userTargetId
    }), isPreSignedUrlsLoading = ref11.isPreSignedUrlsLoading, updateSymptom = ref11.updateSymptom, removeSymptomImage = ref11.removeSymptomImage, onHandleChangeSymptomImage = ref11.onHandleChangeSymptomImage, handleMedicineSelect = ref11.handleMedicineSelect;
    var ref12 = useTelemedicineSchedule({
        treatmentRequest: treatmentRequest,
        bookingSchedulesInfo: bookingSchedulesInfo,
        updateFormFromTreatmentRequest: updateFormFromTreatmentRequest,
        accordionRefs: accordionRefs,
        focusSsnInput: focusSsnInput
    }), selectedDay = ref12.selectedDay, selectedDayScheduleLength = ref12.selectedDayScheduleLength, selectBookingTargetDate = ref12.selectBookingTargetDate, selectBookingTimeSlot = ref12.selectBookingTimeSlot, toggleAsapRequest = ref12.toggleAsapRequest, selectQuickMode = ref12.selectQuickMode, selectGeneralMode = ref12.selectGeneralMode, toggleQuickScheduleMode = ref12.toggleQuickScheduleMode, selectInitSchedule = ref12.selectInitSchedule;
    var ref13 = useTelemedicinePayment({
        treatmentRequest: treatmentRequest,
        updateForm: updateForm,
        client: client
    }), point = ref13.point, cardCompanyButton = ref13.cardCompanyButton, userPaymentsInfo = ref13.userPaymentsInfo, isUserPaymentsInfoRefetching = ref13.isUserPaymentsInfoRefetching, isUserPaymentsInfoFetched = ref13.isUserPaymentsInfoFetched, selectCard = ref13.selectCard, updateInstallment = ref13.updateInstallment, toggleRequestUsePoint = ref13.toggleRequestUsePoint, selectCardCompanyButton = ref13.selectCardCompanyButton, selectAddress = ref13.selectAddress, addKakaopay = ref13.addKakaopay, refetchUserPayments = ref13.refetchUserPayments, selectInitCreditCard = ref13.selectInitCreditCard;
    var ref14 = useTelemedicineDoctorSelection({
        queries: queries,
        treatmentRequest: treatmentRequest,
        updateFormFromTreatmentRequest: updateFormFromTreatmentRequest,
        step: step
    }), doctorPublicId = ref14.doctorPublicId, setDoctorPublicId = ref14.setDoctorPublicId, searchDoctors = ref14.searchDoctors, isLoadingSearchDoctors = ref14.isLoadingSearchDoctors, hasNextPageSearchDoctors = ref14.hasNextPageSearchDoctors, isSearchDoctorSortFilterBottomSheetOpen = ref14.isSearchDoctorSortFilterBottomSheetOpen, fetchNextPageSearchDoctors = ref14.fetchNextPageSearchDoctors, openSearchDoctorSortFilterBottomSheet = ref14.openSearchDoctorSortFilterBottomSheet, closeSearchDoctorSortFilterBottomSheet = ref14.closeSearchDoctorSortFilterBottomSheet, handleSearchDoctorSortFilterSelect = ref14.handleSearchDoctorSortFilterSelect, handleSearchDoctorSpecialistOnlySelect = ref14.handleSearchDoctorSpecialistOnlySelect, onOpenDoctorDetailBottomSheet = ref14.onOpenDoctorDetailBottomSheet, getDoctorDetailOpenCount = ref14.getDoctorDetailOpenCount, onCloseDoctorDetailBottomSheet = ref14.onCloseDoctorDetailBottomSheet, getDoctorIdByQueryString = ref14.getDoctorIdByQueryString, onSelectDoctor = ref14.onSelectDoctor, isDoctorStepButtonDisabled = ref14.isDoctorStepButtonDisabled, selectedFilters = ref14.selectedFilters, handleToggleFilter = ref14.handleToggleFilter, handleFilterSelectionNext = ref14.handleFilterSelectionNext;
    var ref15 = useTelemedicineAgreement({
        treatmentRequest: treatmentRequest,
        contactType: contactType,
        updateForm: updateForm,
        client: client
    }), requestAgreementList = ref15.requestAgreementList, toggleTreatmentRequestAgreement = ref15.toggleTreatmentRequestAgreement, toggleTreatmentRequestAllAgreement = ref15.toggleTreatmentRequestAllAgreement, scrollToBottomAndCheckAllAgreement = ref15.scrollToBottomAndCheckAllAgreement, scrollToBottom = ref15.scrollToBottom;
    var ref16 = useTelemedicineRequestSubmission({
        bookingSchedulesInfo: bookingSchedulesInfo,
        categoriesInfo: categoriesInfo
    }), requestDiagnosis = ref16.requestDiagnosis, isRequestDiagnosisLoading = ref16.isRequestDiagnosisLoading;
    var onCertificationSuccess = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        refetchUser()
                    ];
                case 1:
                    _state.sent();
                    if (!treatmentRequest.form.doctorPid) {
                        return [
                            2
                        ];
                    }
                    requestDiagnosis({
                        skipCertificationCheck: true,
                        treatmentRequest: treatmentRequest,
                        isUserNeedVerificationForDiagnosis: (ref = user === null || user === void 0 ? void 0 : user.isNeedVerificationForDiagnosis) !== null && ref !== void 0 ? ref : false
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        refetchUser,
        treatmentRequest,
        user,
        requestDiagnosis
    ]);
    var isRequiredDataFetched = (0,react.useMemo)(function() {
        return every_default()([
            isUserPaymentsInfoFetched,
            isBookingSchedulesFetched,
            isUserProfilesFetched
        ]);
    }, [
        isUserPaymentsInfoFetched,
        isBookingSchedulesFetched,
        isUserProfilesFetched
    ]);
    var _categoryId;
    var isChronicDiseaseCategory = chronicDiseaseCategoryIds.includes((_categoryId = treatmentRequest.form.categoryId) !== null && _categoryId !== void 0 ? _categoryId : "");
    var _categoryId1, ref17;
    var chronicDiseaseCategoryWarningMessages = (ref17 = chronicDiseaseCategoryWarningMessageMap[(_categoryId1 = treatmentRequest.form.categoryId) !== null && _categoryId1 !== void 0 ? _categoryId1 : ""]) !== null && ref17 !== void 0 ? ref17 : [];
    var _categoryId2;
    var chronicDiseaseCategoryPlaceholder = chronicDiseaseCategoryPlaceholderMap[(_categoryId2 = treatmentRequest.form.categoryId) !== null && _categoryId2 !== void 0 ? _categoryId2 : ""];
    var getHeaderTitle = function() {
        return TELEMEDICINE_REQUEST_HEADER_TITLES[step];
    };
    var getCategoryName = (0,react.useCallback)(function() {
        var categoryType = type;
        return categoriesInfo.getCategoryNameByIdAndType(categoryId, categoryType);
    }, [
        type,
        categoryId,
        categoriesInfo
    ]);
    var requestCameraPermission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    true
                ];
            });
        });
        return function requestCameraPermission() {
            return _ref.apply(this, arguments);
        };
    }();
    var hasDetailMedicine = function(treatmentMedicineId) {
        return services_non_benefit/* NonBenefitService.hasDetailMedicineTreatment */.a.hasDetailMedicineTreatment(treatmentMedicineId);
    };
    var exitTreatmentRequestPage = (0,react.useCallback)(function() {
        showModal({
            type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
            props: {
                title: "진료 신청을 그만둘까요?",
                message: "작성 중이던 내용은 저장되지 않아요.",
                buttons: [
                    {
                        type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                        label: "그만두기",
                        onClick: function() {
                            logger.log({
                                eventName: diagnosis/* TreatmentRequestLog.RequestClickStopInModal */.Js.RequestClickStopInModal
                            });
                            router.back();
                            closeModal();
                        }
                    },
                    {
                        type: modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                        label: "계속 작성",
                        onClick: function() {
                            logger.log({
                                eventName: diagnosis/* TreatmentRequestLog.RequestClickContinueInModal */.Js.RequestClickContinueInModal
                            });
                            closeModal();
                        }
                    }, 
                ],
                onClickOverlay: function() {
                    closeModal();
                }
            }
        });
    }, [
        showModal,
        logger,
        client.isWebView,
        router,
        closeModal
    ]);
    var moveToBack = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (step === models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis) {
                        logger.log({
                            eventName: diagnosis/* TreatmentRequestLog.RequestPrevStepFromDiagnosis */.Js.RequestPrevStepFromDiagnosis
                        });
                        exitTreatmentRequestPage();
                        return [
                            2
                        ];
                    }
                    if (step === models_diagnosis/* EDiagnosisStep.DoctorFilter */.cR.DoctorFilter) {
                        logger.log({
                            eventName: diagnosis/* TreatmentRequestLog.RequestPrevStepFromDiagnosis */.Js.RequestPrevStepFromDiagnosis
                        });
                    }
                    if (step === models_diagnosis/* EDiagnosisStep.Payment */.cR.Payment) {
                        logger.log({
                            eventName: diagnosis/* TreatmentRequestLog.RequestPrevStepFromPayment */.Js.RequestPrevStepFromPayment
                        });
                        setDoctorPublicId(null);
                    }
                    if (step === models_diagnosis/* EDiagnosisStep.CertificationGuide */.cR.CertificationGuide) {
                        logger.log({
                            eventName: diagnosis/* EWebTreatmentRequestLog.ClickIdvSheetClose */.o5.ClickIdvSheetClose
                        });
                    }
                    router.back();
                    return [
                        4,
                        (0,date/* sleep */._v)(100)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        step,
        logger,
        router,
        setDoctorPublicId,
        exitTreatmentRequestPage
    ]);
    var openDetailSymptomsLoadBottomSheet = function() {
        if (recentlyDetailSymptoms.length === 0) {
            toast({
                text: "최근 진료가 없어 증상을 불러올 수 없어요.",
                direction: "bottom"
            });
            return;
        }
        setIsRadioBottomSheetOpen(true);
    };
    var closeRadioBottomSheet = function() {
        setIsRadioBottomSheetOpen(false);
    };
    var handleSymptomSelect = function(selectedSymptom) {
        logger.log({
            eventName: diagnosis/* TreatmentRequestLog.RequestSelectLoadDetailSymptom */.Js.RequestSelectLoadDetailSymptom
        });
        updateSymptom(selectedSymptom.symptom);
        closeRadioBottomSheet();
    };
    var openCardInstallmentListBottomSheet = function() {
        setIsCardInstallmentBottomSheetOpen(true);
    };
    var closeCardInstallmentBottomSheet = function() {
        setIsCardInstallmentBottomSheetOpen(false);
    };
    var handleInstallmentSelect = function(item) {
        updateInstallment(item.installmentMonth);
        closeCardInstallmentBottomSheet();
    };
    var nextStep = (0,react.useCallback)(debounce_default()(function(step, currentCategoryId, currentType) {
        router.push("".concat(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path) + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            step: step,
            categoryId: currentCategoryId,
            type: currentType
        })));
    }, 300, {
        leading: true,
        trailing: false
    }), [
        categoryId,
        type
    ]);
    var updateQuickDoctorInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var quickDoctorInfo, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!type || !categoryId) {
                            toast({
                                text: "진료 카테고리 정보가 없습니다.",
                                direction: "bottom"
                            });
                            return [
                                2,
                                false
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getQuickDiagnosisDoctorInfo({
                                medicalCategory: {
                                    type: type,
                                    id: categoryId
                                },
                                contactType: contactType
                            })
                        ];
                    case 2:
                        quickDoctorInfo = _state.sent();
                        if (!quickDoctorInfo.doctorId) {
                            toast({
                                text: "빠른 진료가 가능한 의사를 찾을 수 없습니다.",
                                direction: "bottom"
                            });
                            return [
                                2,
                                false
                            ];
                        }
                        updateForm(function(prev) {
                            var updated = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                isAsapRequest: true,
                                doctorId: quickDoctorInfo.doctorId,
                                doctorPid: quickDoctorInfo.doctorPid,
                                bookingTargetDate: quickDoctorInfo.targetDate,
                                startTimeSlotValue: quickDoctorInfo.startTimeSlotValue,
                                endTimeSlotValue: quickDoctorInfo.endTimeSlotValue
                            });
                            return updated;
                        });
                        return [
                            2,
                            true
                        ];
                    case 3:
                        error = _state.sent();
                        if ((0,_instanceof/* default */.Z)(error, Error)) {
                            (0,report/* errorReport */.Y)("빠른 진료 예약 중 오류 발생", {}, error);
                        }
                        toast({
                            text: "빠른 진료 예약에 실패했습니다. 일반 예약을 이용해주세요.",
                            direction: "bottom"
                        });
                        return [
                            2,
                            false
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function updateQuickDoctorInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDiagnosisStepNext = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_event) {
            var isSuccess;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!treatmentRequest.isWebQuickScheduleRequest()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            updateQuickDoctorInfo()
                        ];
                    case 1:
                        isSuccess = _state.sent();
                        if (isSuccess) {
                            nextStep(models_diagnosis/* EDiagnosisStep.Payment */.cR.Payment, categoryId, type);
                        }
                        return [
                            2
                        ];
                    case 2:
                        nextStep(models_diagnosis/* EDiagnosisStep.DoctorFilter */.cR.DoctorFilter, categoryId, type);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDiagnosisStepNext(_event) {
            return _ref.apply(this, arguments);
        };
    }();
    var getDiagnosisStepButtonText = function() {
        return treatmentRequest.isWebQuickScheduleRequest() ? "다음" : "의사 선택하기";
    };
    var addCreditCard = function() {
        onOpenRegisterCardBottomSheet();
    };
    var onSuccessCardRegister = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, firstPayment;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onCloseRegisterCardBottomSheet();
                        return [
                            4,
                            refetchUserPayments()
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.data) {
                            firstPayment = result.data.payments[0];
                            if (firstPayment) {
                                selectCard(firstPayment.id);
                                if (firstPayment.payCompany === common/* CardPayCompany.Kakaopay */.sw.Kakaopay) {
                                    selectCardCompanyButton(CardCompanyButtonType.KAKAOPAY);
                                } else {
                                    selectCardCompanyButton(CardCompanyButtonType.ANOTHER);
                                }
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSuccessCardRegister() {
            return _ref.apply(this, arguments);
        };
    }();
    var updateUserProfile = (0,react.useCallback)(function(userProfile) {
        treatmentRequest.updateUserProfile({
            isSsnChanged: userProfile.isSsnChanged,
            originalPatientBirth: userProfile.birthDate,
            patientRelation: userProfile.relation,
            patientBirth: userProfile.displayedBirthDate,
            targetId: userProfile.targetId
        });
        if (userProfile.relation === common/* UserProfileRelationType.Children */.h6.Children) {
            updateForm(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    patient: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.patient), {
                        patientAge: userProfile.age
                    })
                });
            });
        } else {
            updateFormFromTreatmentRequest(treatmentRequest);
        }
    }, [
        treatmentRequest,
        updateForm,
        updateFormFromTreatmentRequest
    ]);
    var moveToAgreementLink = function(url) {
        window.open(url);
    };
    var shouldShowQuickDiagnosisInfoBanner = function() {
        return treatmentRequest.isQuickMatchRequest();
    };
    var getUserProfile = function() {
        return userProfiles.getUserProfileByTargetId(userTargetId);
    };
    var onOpenRegisterCardBottomSheet = function() {
        router.push("".concat(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path) + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            cardRegister: "general"
        })));
    };
    var onCloseRegisterCardBottomSheet = function() {
        router.back();
    };
    var getIsGeneralCardRegister = function() {
        return router.query.cardRegister === "general";
    };
    var handleCategorySelectDepartment = function(department) {
        var ref, ref1;
        logger.log({
            eventName: diagnosis/* TreatmentRequestLog.RequestSelectCategory */.Js.RequestSelectCategory,
            payload: {
                type: "department",
                categoryId: department.id
            }
        });
        treatmentRequest.selectTreatmentRequestDepartment(department);
        updateFormFromTreatmentRequest(treatmentRequest);
        (ref = detailSymptomInputRef.current) === null || ref === void 0 ? void 0 : ref.scroll();
        (ref1 = detailSymptomInputRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
    };
    var shouldShowDiagnosisFormStep = function() {
        return step === models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis;
    };
    var shouldShowDoctorFilterStep = function() {
        return step === models_diagnosis/* EDiagnosisStep.DoctorFilter */.cR.DoctorFilter;
    };
    var shouldShowDoctorSelectStep = function() {
        return step === models_diagnosis/* EDiagnosisStep.Doctor */.cR.Doctor;
    };
    var shouldShowPaymentStep = function() {
        return step === models_diagnosis/* EDiagnosisStep.Payment */.cR.Payment;
    };
    var shouldShowCertificationGuideStep = function() {
        return step === models_diagnosis/* EDiagnosisStep.CertificationGuide */.cR.CertificationGuide;
    };
    var selectedTimeSlotTitle = (0,react.useMemo)(function() {
        var shouldShowQuickModeTitle = true;
        return bookingSchedulesInfo.getSelectedTimeSlotTitle(treatmentRequest, shouldShowQuickModeTitle);
    }, [
        bookingSchedulesInfo,
        treatmentRequest
    ]);
    var getIsEnabledSchedule = function(diagnosisBookingSchedules) {
        if (!diagnosisBookingSchedules || diagnosisBookingSchedules.length === 0) {
            return false;
        }
        var _form = treatmentRequest.form, bookingTargetDate = _form.bookingTargetDate, startTimeSlotValue = _form.startTimeSlotValue, endTimeSlotValue = _form.endTimeSlotValue;
        var matchingDateSchedule = diagnosisBookingSchedules.find(function(schedule) {
            return schedule.targetDate === bookingTargetDate;
        });
        if (!matchingDateSchedule) {
            return false;
        }
        var matchingTimeSlot = matchingDateSchedule.schedules.find(function(slot) {
            return slot.startTimeSlot.value === startTimeSlotValue && slot.endTimeSlot.value === endTimeSlotValue;
        });
        if (!matchingTimeSlot) {
            return false;
        }
        setSelectedStartDisplayTimeSlot(matchingTimeSlot.startTimeSlot.displayTime);
        return matchingTimeSlot.bookingStatus === types_doctor/* BookingScheduleTypeVo.Bookable */.Ts.Bookable;
    };
    var handleSelectDoctor = function(doctor, doctorPublicId, doctorDetail) {
        setSelectedDoctorPublicId(doctorDetail !== null && doctorDetail !== void 0 ? doctorDetail : null);
        var isEnabledSchedule = getIsEnabledSchedule(doctorDetail === null || doctorDetail === void 0 ? void 0 : doctorDetail.diagnosisBookingSchedules);
        if (!isEnabledSchedule) {
            setIsEnabledScheduleAlertOpen(true);
            return;
        }
        onSelectDoctor(doctor, doctorPublicId);
    };
    var onCloseIsEnabledScheduleAlert = function() {
        (0,url/* deleteQueryString */.OB)("doctorId");
        setIsEnabledScheduleAlertOpen(false);
    };
    var getReceiptLocationInfo = function() {
        if (!navigator.geolocation) {
            return;
        }
        navigator.geolocation.getCurrentPosition(function(param) {
            var coords = param.coords;
            treatmentRequest.updateReceiptLocation({
                latitude: coords.latitude,
                longitude: coords.longitude
            });
            updateFormFromTreatmentRequest(treatmentRequest);
        });
    };
    var onSubmitRequestDiagnosis = function() {
        var ref;
        requestDiagnosis({
            treatmentRequest: treatmentRequest,
            isUserNeedVerificationForDiagnosis: (ref = user === null || user === void 0 ? void 0 : user.isNeedVerificationForDiagnosis) !== null && ref !== void 0 ? ref : false
        });
    };
    (0,react.useEffect)(function() {
        getReceiptLocationInfo();
    }, []);
    (0,react.useEffect)(function() {
        if (isFocused) {
            Promise.allSettled([
                refetchUserPayments()
            ]);
        }
    }, [
        isFocused,
        refetchUserPayments
    ]);
    var isInitializedRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (!isRequiredDataFetched || isInitializedRef.current) {
            return;
        }
        if (bookingSchedulesInfo.daySchedules.length) {
            selectInitSchedule(targetDate);
        }
        if (userProfiles.hasUserProfiles()) {
            var userProfile = userProfiles.getUserProfileByTargetId(userTargetId);
            if (userProfile) {
                updateUserProfile(userProfile);
            }
        }
        if (!treatmentRequest.form.paymentId) {
            selectInitCreditCard(userPaymentsInfo);
        }
        isInitializedRef.current = true;
    }, [
        isRequiredDataFetched,
        targetDate,
        userTargetId,
        bookingSchedulesInfo,
        userProfiles,
        treatmentRequest,
        userPaymentsInfo,
        selectInitSchedule,
        selectInitCreditCard,
        updateUserProfile, 
    ]);
    hooks_useStepValidation({
        step: step,
        treatmentRequest: treatmentRequest,
        isRequiredDataFetched: isRequiredDataFetched
    });
    hooks_useRefreshPrevention({
        enabled: true,
        skipReload: true,
        modalTitle: "페이지를 새로고침하시겠어요?",
        modalMessage: "새로고침하면 작성 중이던 내용이 사라져요.",
        onCancelText: "새로고침",
        onConfirmText: "계속작성",
        onCancel: function() {
            logger.log({
                eventName: diagnosis/* TreatmentRequestLog.RequestClickStopInModal */.Js.RequestClickStopInModal,
                payload: {
                    contactType: contactType
                }
            });
            router.replace(types_common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path + (0,url/* addQueryString */.sC)({
                step: models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis,
                categoryId: categoryId,
                type: type
            }));
        },
        onConfirm: function() {
            logger.log({
                eventName: diagnosis/* TreatmentRequestLog.RequestClickContinueInModal */.Js.RequestClickContinueInModal,
                payload: {
                    contactType: contactType
                }
            });
        }
    });
    (0,react.useEffect)(function() {
        if (!categoryId || !type || !isRequiredDataFetched) {
            return;
        }
        var mapKey = "".concat(categoryId, ":").concat(type);
        var bottomSheetGuideOpenAction = categoryGuideBottomSheetOpenActionMap[mapKey];
        if (bottomSheetGuideOpenAction) {
            bottomSheetGuideOpenAction();
        }
    }, [
        categoryId,
        type,
        isRequiredDataFetched,
        categoryGuideBottomSheetOpenActionMap
    ]);
    (0,react.useEffect)(function() {
        var _obj;
        var stepEventMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis, diagnosis/* EWebTreatmentRequestLog.RequestStepChangeToDiagnosis */.o5.RequestStepChangeToDiagnosis), (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.DoctorFilter */.cR.DoctorFilter, diagnosis/* EWebTreatmentRequestLog.RequestStepChangeToDoctor */.o5.RequestStepChangeToDoctor), (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.Doctor */.cR.Doctor, diagnosis/* EWebTreatmentRequestLog.RequestStepChangeToDoctor */.o5.RequestStepChangeToDoctor), (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.Payment */.cR.Payment, diagnosis/* EWebTreatmentRequestLog.RequestStepChangeToPayment */.o5.RequestStepChangeToPayment), (0,_define_property/* default */.Z)(_obj, models_diagnosis/* EDiagnosisStep.CertificationGuide */.cR.CertificationGuide, diagnosis/* EWebTreatmentRequestLog.RequestStepChangeToCertificationGuide */.o5.RequestStepChangeToCertificationGuide), _obj);
        var _obj1;
        var stepPageMap = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, models_diagnosis/* EDiagnosisStep.Diagnosis */.cR.Diagnosis, "diagnosis"), (0,_define_property/* default */.Z)(_obj1, models_diagnosis/* EDiagnosisStep.DoctorFilter */.cR.DoctorFilter, "doctor_filter"), (0,_define_property/* default */.Z)(_obj1, models_diagnosis/* EDiagnosisStep.Doctor */.cR.Doctor, "doctor"), (0,_define_property/* default */.Z)(_obj1, models_diagnosis/* EDiagnosisStep.Payment */.cR.Payment, "payment"), (0,_define_property/* default */.Z)(_obj1, models_diagnosis/* EDiagnosisStep.CertificationGuide */.cR.CertificationGuide, "certification_guide"), _obj1);
        logger.log({
            eventName: stepEventMap[step],
            payload: {
                step: stepPageMap[step],
                categoryId: categoryId !== null && categoryId !== void 0 ? categoryId : "",
                categoryName: getCategoryName()
            }
        });
    }, [
        step
    ]);
    return {
        accordionRefs: accordionRefs,
        recentlyDetailSymptomsCount: recentlyDetailSymptomsCount,
        isUserPaymentsInfoRefetching: isUserPaymentsInfoRefetching,
        isUserPaymentsInfoFetched: isUserPaymentsInfoFetched,
        ssnInputRef: ssnInputRef,
        detailSymptomInputRef: detailSymptomInputRef,
        reVisitBrandWrapperRef: reVisitBrandWrapperRef,
        cardListWrapperRef: cardListWrapperRef,
        isRequestDiagnosisLoading: isRequestDiagnosisLoading,
        isPreSignedUrlsLoading: isPreSignedUrlsLoading,
        step: step,
        categoryId: categoryId,
        type: type,
        treatmentRequest: treatmentRequest,
        bookingSchedulesInfo: bookingSchedulesInfo,
        selectedTimeSlotTitle: selectedTimeSlotTitle,
        userPaymentsInfo: userPaymentsInfo,
        userProfiles: userProfiles,
        userTargetId: userTargetId,
        point: point,
        cardCompanyButton: cardCompanyButton,
        requestAgreementList: requestAgreementList,
        doctorPublicId: doctorPublicId,
        user: user,
        updatePatientSsn: updatePatientSsn,
        selectedDay: selectedDay,
        selectedDayScheduleLength: selectedDayScheduleLength,
        isChronicDiseaseCategory: isChronicDiseaseCategory,
        chronicDiseaseCategoryWarningMessages: chronicDiseaseCategoryWarningMessages,
        chronicDiseaseCategoryPlaceholder: chronicDiseaseCategoryPlaceholder,
        isCardInstallmentBottomSheetOpen: isCardInstallmentBottomSheetOpen,
        isRadioBottomSheetOpen: isRadioBottomSheetOpen,
        recentlyDetailSymptoms: recentlyDetailSymptoms,
        searchDoctors: searchDoctors,
        isLoadingSearchDoctors: isLoadingSearchDoctors,
        hasNextPageSearchDoctors: hasNextPageSearchDoctors,
        isSearchDoctorSortFilterBottomSheetOpen: isSearchDoctorSortFilterBottomSheetOpen,
        isRequiredDataFetched: isRequiredDataFetched,
        nextStep: nextStep,
        isDoctorStepButtonDisabled: isDoctorStepButtonDisabled,
        isEnabledScheduleAlertOpen: isEnabledScheduleAlertOpen,
        selectedStartDisplayTimeSlot: selectedStartDisplayTimeSlot,
        selectedDoctorDetail: selectedDoctorDetail,
        selectMedicine: handleMedicineSelect,
        updateInstallment: updateInstallment,
        selectCard: selectCard,
        toggleRequestUsePoint: toggleRequestUsePoint,
        updateSymptom: updateSymptom,
        resetPatientSsn: resetPatientSsn,
        selectBookingTargetDate: selectBookingTargetDate,
        selectBookingTimeSlot: selectBookingTimeSlot,
        toggleAsapRequest: toggleAsapRequest,
        selectQuickMode: selectQuickMode,
        selectGeneralMode: selectGeneralMode,
        toggleQuickScheduleMode: toggleQuickScheduleMode,
        selectAddress: selectAddress,
        onHandleChangeSymptomImage: onHandleChangeSymptomImage,
        removeSymptomImage: removeSymptomImage,
        handleDiagnosisStepNext: handleDiagnosisStepNext,
        getDiagnosisStepButtonText: getDiagnosisStepButtonText,
        selectCardCompanyButton: selectCardCompanyButton,
        openCardInstallmentListBottomSheet: openCardInstallmentListBottomSheet,
        toggleTreatmentRequestAgreement: toggleTreatmentRequestAgreement,
        toggleTreatmentRequestAllAgreement: toggleTreatmentRequestAllAgreement,
        moveToAgreementLink: moveToAgreementLink,
        scrollToBottomAndCheckAllAgreement: scrollToBottomAndCheckAllAgreement,
        moveToBack: moveToBack,
        addCreditCard: addCreditCard,
        addKakaopay: addKakaopay,
        openDetailSymptomsLoadBottomSheet: openDetailSymptomsLoadBottomSheet,
        requestCameraPermission: requestCameraPermission,
        scrollToBottom: scrollToBottom,
        getHeaderTitle: getHeaderTitle,
        shouldShowQuickDiagnosisInfoBanner: shouldShowQuickDiagnosisInfoBanner,
        handleCategorySelectDepartment: handleCategorySelectDepartment,
        handleMedicineSelect: handleMedicineSelect,
        closeCardInstallmentBottomSheet: closeCardInstallmentBottomSheet,
        handleInstallmentSelect: handleInstallmentSelect,
        hasDetailMedicine: hasDetailMedicine,
        closeRadioBottomSheet: closeRadioBottomSheet,
        handleSymptomSelect: handleSymptomSelect,
        getCategoryName: getCategoryName,
        fetchNextPageSearchDoctors: fetchNextPageSearchDoctors,
        openSearchDoctorSortFilterBottomSheet: openSearchDoctorSortFilterBottomSheet,
        closeSearchDoctorSortFilterBottomSheet: closeSearchDoctorSortFilterBottomSheet,
        handleSearchDoctorSortFilterSelect: handleSearchDoctorSortFilterSelect,
        handleSearchDoctorSpecialistOnlySelect: handleSearchDoctorSpecialistOnlySelect,
        getUserProfile: getUserProfile,
        onOpenDoctorDetailBottomSheet: onOpenDoctorDetailBottomSheet,
        getDoctorDetailOpenCount: getDoctorDetailOpenCount,
        onCloseDoctorDetailBottomSheet: onCloseDoctorDetailBottomSheet,
        getDoctorIdByQueryString: getDoctorIdByQueryString,
        onOpenRegisterCardBottomSheet: onOpenRegisterCardBottomSheet,
        onCloseRegisterCardBottomSheet: onCloseRegisterCardBottomSheet,
        getIsGeneralCardRegister: getIsGeneralCardRegister,
        onSuccessCardRegister: onSuccessCardRegister,
        onCertificationSuccess: onCertificationSuccess,
        shouldShowDiagnosisFormStep: shouldShowDiagnosisFormStep,
        shouldShowDoctorSelectStep: shouldShowDoctorSelectStep,
        shouldShowPaymentStep: shouldShowPaymentStep,
        shouldShowCertificationGuideStep: shouldShowCertificationGuideStep,
        shouldShowDoctorFilterStep: shouldShowDoctorFilterStep,
        handleSelectDoctor: handleSelectDoctor,
        onCloseIsEnabledScheduleAlert: onCloseIsEnabledScheduleAlert,
        selectedDoctorFilters: selectedFilters,
        handleToggleDoctorFilter: handleToggleFilter,
        handleDoctorFilterSelectionNext: handleFilterSelectionNext,
        onSubmitRequestDiagnosis: onSubmitRequestDiagnosis,
        isMaternityGuideBottomSheetOpen: categoryGuideBottomSheetStates.isMaternityGuideBottomSheetOpen,
        openMaternityGuideBottomSheet: categoryGuideBottomSheetActions.openMaternityGuideBottomSheet,
        closeMaternityGuideBottomSheet: categoryGuideBottomSheetActions.closeMaternityGuideBottomSheet,
        isMaleGuideBottomSheetOpen: categoryGuideBottomSheetStates.isMaleGuideBottomSheetOpen,
        openMaleGuideBottomSheet: categoryGuideBottomSheetActions.openMaleGuideBottomSheet,
        closeMaleGuideBottomSheet: categoryGuideBottomSheetActions.closeMaleGuideBottomSheet,
        isMentalHealthGuideBottomSheetOpen: categoryGuideBottomSheetStates.isMentalHealthGuideBottomSheetOpen,
        openMentalHealthGuideBottomSheet: categoryGuideBottomSheetActions.openMentalHealthGuideBottomSheet,
        closeMentalHealthGuideBottomSheet: categoryGuideBottomSheetActions.closeMentalHealthGuideBottomSheet,
        isDietGuideBottomSheetOpen: categoryGuideBottomSheetStates.isDietGuideBottomSheetOpen,
        openDietGuideBottomSheet: categoryGuideBottomSheetActions.openDietGuideBottomSheet,
        closeDietGuideBottomSheet: categoryGuideBottomSheetActions.closeDietGuideBottomSheet,
        isSleepDisorderGuideBottomSheetOpen: categoryGuideBottomSheetStates.isSleepDisorderGuideBottomSheetOpen,
        openSleepDisorderGuideBottomSheet: categoryGuideBottomSheetActions.openSleepDisorderGuideBottomSheet,
        closeSleepDisorderGuideBottomSheet: categoryGuideBottomSheetActions.closeSleepDisorderGuideBottomSheet
    };
};
/* harmony default export */ var hooks_useTelemedicineRequestViewModel = (useTelemedicineRequestViewModel);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/hooks/index.ts


;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineRequestLoader.tsx




var TelemedicineRequestLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Content */.Z.Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-[100vh] items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                    color: theme/* default.color.gray600 */.Z.color.gray600
                })
            })
        })
    });
};
/* harmony default export */ var ui_TelemedicineRequestLoader = (TelemedicineRequestLoader);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/TelemedicineRequestView.tsx








var TelemedicineRequestView = function(param) {
    var client = param.client;
    var viewModel = hooks_useTelemedicineRequestViewModel(client);
    if (!viewModel.isRequiredDataFetched) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineRequestLoader, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                    params: {
                        eventName: libs/* EWebTreatmentRequestLog.ClickCloseButton */.o5.ClickCloseButton
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                        title: viewModel.getHeaderTitle(),
                        onClickBackButton: viewModel.moveToBack
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    viewModel.shouldShowDiagnosisFormStep() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiagnosisFormStep, {
                        client: client,
                        bookingSchedulesInfo: viewModel.bookingSchedulesInfo,
                        treatmentRequest: viewModel.treatmentRequest,
                        accordionRefs: viewModel.accordionRefs,
                        selectedDayScheduleLength: viewModel.selectedDayScheduleLength,
                        selectedDay: viewModel.selectedDay,
                        ssnInputRef: viewModel.ssnInputRef,
                        categoryName: viewModel.getCategoryName(),
                        isPreSignedUrlsLoading: viewModel.isPreSignedUrlsLoading,
                        detailSymptomInputRef: viewModel.detailSymptomInputRef,
                        recentlyDetailSymptomsCount: viewModel.recentlyDetailSymptomsCount,
                        isChronicDiseaseCategory: viewModel.isChronicDiseaseCategory,
                        chronicDiseaseCategoryWarningMessages: viewModel.chronicDiseaseCategoryWarningMessages,
                        chronicDiseaseCategoryPlaceholder: viewModel.chronicDiseaseCategoryPlaceholder,
                        selectedTimeSlotTitle: viewModel.selectedTimeSlotTitle,
                        isDoctorStepButtonDisabled: viewModel.isDoctorStepButtonDisabled,
                        userProfile: viewModel.userProfiles.getUserProfileByTargetId(viewModel.userTargetId),
                        selectBookingTargetDate: viewModel.selectBookingTargetDate,
                        selectBookingTimeSlot: viewModel.selectBookingTimeSlot,
                        toggleAsapRequest: viewModel.toggleAsapRequest,
                        selectQuickMode: viewModel.selectQuickMode,
                        selectGeneralMode: viewModel.selectGeneralMode,
                        updatePatientSsn: viewModel.updatePatientSsn,
                        resetPatientSsn: viewModel.resetPatientSsn,
                        updateSymptom: viewModel.updateSymptom,
                        onHandleChangeSymptomImage: viewModel.onHandleChangeSymptomImage,
                        removeSymptomImage: viewModel.removeSymptomImage,
                        openDetailSymptomsLoadBottomSheet: viewModel.openDetailSymptomsLoadBottomSheet,
                        requestCameraPermission: viewModel.requestCameraPermission,
                        handleDiagnosisStepNext: viewModel.handleDiagnosisStepNext,
                        diagnosisStepButtonText: viewModel.getDiagnosisStepButtonText(),
                        isSymptomBottomSheetOpen: viewModel.isRadioBottomSheetOpen,
                        recentlyDetailSymptoms: viewModel.recentlyDetailSymptoms,
                        onCloseSymptomBottomSheet: viewModel.closeRadioBottomSheet,
                        onSymptomSelect: viewModel.handleSymptomSelect
                    }),
                    viewModel.shouldShowDoctorFilterStep() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DoctorFilterSelectionStep, {
                        selectedFilters: viewModel.selectedDoctorFilters,
                        onToggleFilter: viewModel.handleToggleDoctorFilter,
                        onNext: viewModel.handleDoctorFilterSelectionNext
                    }),
                    viewModel.shouldShowDoctorSelectStep() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineDoctorSelect, {
                        client: client,
                        searchDoctors: viewModel.searchDoctors,
                        treatmentRequest: viewModel.treatmentRequest,
                        categoryName: viewModel.getCategoryName(),
                        selectedFilters: viewModel.selectedDoctorFilters,
                        isLoadingSearchDoctors: viewModel.isLoadingSearchDoctors,
                        hasNextPageSearchDoctors: viewModel.hasNextPageSearchDoctors,
                        isSearchDoctorSortFilterBottomSheetOpen: viewModel.isSearchDoctorSortFilterBottomSheetOpen,
                        selectedSortKey: viewModel.treatmentRequest.getSortKey(),
                        handleSearchDoctorSpecialistOnlySelect: viewModel.handleSearchDoctorSpecialistOnlySelect,
                        handleSearchDoctorSortFilterSelect: viewModel.handleSearchDoctorSortFilterSelect,
                        fetchNextPageSearchDoctors: viewModel.fetchNextPageSearchDoctors,
                        openSearchDoctorSortFilterBottomSheet: viewModel.openSearchDoctorSortFilterBottomSheet,
                        closeSearchDoctorSortFilterBottomSheet: viewModel.closeSearchDoctorSortFilterBottomSheet,
                        onOpenDoctorDetailBottomSheet: viewModel.onOpenDoctorDetailBottomSheet,
                        getDoctorDetailOpenCount: viewModel.getDoctorDetailOpenCount,
                        isDoctorDetailBottomSheetOpen: !!viewModel.getDoctorIdByQueryString(),
                        onCloseDoctorDetailBottomSheet: viewModel.onCloseDoctorDetailBottomSheet,
                        handleSelectDoctor: viewModel.handleSelectDoctor,
                        isEnabledScheduleAlertOpen: viewModel.isEnabledScheduleAlertOpen,
                        selectedStartDisplayTimeSlot: viewModel.selectedStartDisplayTimeSlot,
                        selectedDoctorDetail: viewModel.selectedDoctorDetail,
                        onCloseIsEnabledScheduleAlert: viewModel.onCloseIsEnabledScheduleAlert
                    }),
                    viewModel.shouldShowPaymentStep() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_PaymentFormStep, {
                        cardListWrapperRef: viewModel.cardListWrapperRef,
                        isUserPaymentsInfoRefetching: viewModel.isUserPaymentsInfoRefetching,
                        isUserPaymentsInfoFetched: viewModel.isUserPaymentsInfoFetched,
                        point: viewModel.point,
                        cardCompanyButton: viewModel.cardCompanyButton,
                        treatmentRequest: viewModel.treatmentRequest,
                        userPaymentsInfo: viewModel.userPaymentsInfo,
                        requestAgreementList: viewModel.requestAgreementList,
                        isRequestDiagnosisLoading: viewModel.isRequestDiagnosisLoading,
                        bookingSchedulesInfo: viewModel.bookingSchedulesInfo,
                        doctorPublicId: viewModel.doctorPublicId,
                        user: viewModel.user,
                        selectCard: viewModel.selectCard,
                        selectCardCompanyButton: viewModel.selectCardCompanyButton,
                        toggleRequestUsePoint: viewModel.toggleRequestUsePoint,
                        openCardInstallmentListBottomSheet: viewModel.openCardInstallmentListBottomSheet,
                        addCreditCard: viewModel.addCreditCard,
                        addKakaopay: viewModel.addKakaopay,
                        toggleTreatmentRequestAgreement: viewModel.toggleTreatmentRequestAgreement,
                        toggleTreatmentRequestAllAgreement: viewModel.toggleTreatmentRequestAllAgreement,
                        moveToAgreementLink: viewModel.moveToAgreementLink,
                        onSubmitRequestDiagnosis: viewModel.onSubmitRequestDiagnosis,
                        scrollToBottomAndCheckAllAgreement: viewModel.scrollToBottomAndCheckAllAgreement,
                        isCardRegisterBottomSheetOpen: viewModel.getIsGeneralCardRegister(),
                        onCloseCardRegisterBottomSheet: viewModel.onCloseRegisterCardBottomSheet,
                        onSuccessCardRegister: viewModel.onSuccessCardRegister,
                        isCardInstallmentBottomSheetOpen: viewModel.isCardInstallmentBottomSheetOpen,
                        cardInstallments: viewModel.userPaymentsInfo.installments,
                        onCardInstallmentSelect: viewModel.handleInstallmentSelect,
                        onCloseCardInstallmentBottomSheet: viewModel.closeCardInstallmentBottomSheet
                    }),
                    viewModel.shouldShowCertificationGuideStep() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_CertificationGuideStep, {
                        onCertificationSuccess: viewModel.onCertificationSuccess
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MaternityGuideBottomSheet, {
                isOpen: viewModel.isMaternityGuideBottomSheetOpen,
                onClose: viewModel.closeMaternityGuideBottomSheet
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MaleGuideBottomSheet, {
                isOpen: viewModel.isMaleGuideBottomSheetOpen,
                onClose: viewModel.closeMaleGuideBottomSheet
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MentalHealthGuideBottomSheet, {
                isOpen: viewModel.isMentalHealthGuideBottomSheetOpen,
                onClose: viewModel.closeMentalHealthGuideBottomSheet
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DietGuideBottomSheet, {
                isOpen: viewModel.isDietGuideBottomSheetOpen,
                onClose: viewModel.closeDietGuideBottomSheet
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SleepDisorderGuideBottomSheet, {
                isOpen: viewModel.isSleepDisorderGuideBottomSheetOpen,
                onClose: viewModel.closeSleepDisorderGuideBottomSheet
            })
        ]
    });
};
/* harmony default export */ var ui_TelemedicineRequestView = (TelemedicineRequestView);

;// CONCATENATED MODULE: ./src/views/telemedicine/request/ui/index.ts

















;// CONCATENATED MODULE: ./src/views/telemedicine/request/index.ts



;// CONCATENATED MODULE: ./src/pages/telemedicine/request/index.tsx
// PageDescription: 비대면진료 웹 진료 신청 페이지





var TelemedicineRequestPage = function(param) {
    var client = param.client;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isAuthenticated = ref[0], setIsAuthenticated = ref[1];
    var ref1 = (0,react.useState)(true), isChecking = ref1[0], setIsChecking = ref1[1];
    var token = (0,useAuth/* default */.Z)().token;
    (0,react.useEffect)(function() {
        if (!token) {
            router.push("/");
        } else {
            setIsAuthenticated(true);
        }
        setIsChecking(false);
    }, [
        router,
        token
    ]);
    if (isChecking) {
        return null;
    }
    if (!isAuthenticated) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TelemedicineRequestView, {
        client: client
    });
};
/* harmony default export */ var request = (TelemedicineRequestPage);


/***/ }),

/***/ 3818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KL": function() { return /* binding */ userState; }
/* harmony export */ });
/* unused harmony exports getUserState, setUserState */
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6983);



var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_2__/* .recoilPersist */ .J)().persistAtom;
var userState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "userState",
    default: {},
    effects_UNSTABLE: [
        persistAtom
    ]
});
var getUserState = function() {
    return getRecoil(userState);
};
var setUserState = function(userData) {
    setRecoil(userState, userData);
};


/***/ }),

/***/ 33310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W8": function() { return /* binding */ EDeprecatedCategoryType; },
/* harmony export */   "ZP": function() { return /* binding */ DiagnosisCategoryService; },
/* harmony export */   "qm": function() { return /* binding */ ECategoryType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);

var ENonBenefitSymptomId;
(function(ENonBenefitSymptomId) {
    ENonBenefitSymptomId["Hairloss"] = "9";
    ENonBenefitSymptomId["Contraceptive"] = "10";
    ENonBenefitSymptomId["Acne"] = "11";
    ENonBenefitSymptomId["Diet"] = "12";
    ENonBenefitSymptomId["GongJinDan"] = "109";
    ENonBenefitSymptomId["OrientalBeauty"] = "605";
    ENonBenefitSymptomId["OtherOrientalTreatments"] = "610";
    ENonBenefitSymptomId["Rosacea"] = "625";
})(ENonBenefitSymptomId || (ENonBenefitSymptomId = {}));
var SymptomId;
(function(SymptomId) {
    SymptomId["PanicAnxiety"] = "8";
    SymptomId["Depression"] = "588";
    SymptomId["OtherMentalDisorders"] = "589";
})(SymptomId || (SymptomId = {}));
var EDeprecatedCategoryType;
(function(EDeprecatedCategoryType) {
    EDeprecatedCategoryType["Symptom"] = "symptom";
    EDeprecatedCategoryType["Subject"] = "subject";
    EDeprecatedCategoryType["Vaccination"] = "vaccination";
})(EDeprecatedCategoryType || (EDeprecatedCategoryType = {}));
var ECategoryType;
(function(ECategoryType) {
    ECategoryType["Treatment"] = "treatment";
    ECategoryType["Department"] = "department";
    ECategoryType["Vaccination"] = "vaccination";
})(ECategoryType || (ECategoryType = {}));
var EDepartmentId;
(function(EDepartmentId) {
    EDepartmentId["Psychiatry"] = "7";
    EDepartmentId["Dermatology"] = "6";
    EDepartmentId["PlasticSurgery"] = "12";
    EDepartmentId["OrientalMedicine"] = "19";
})(EDepartmentId || (EDepartmentId = {}));
var DiagnosisCategoryService = /*#__PURE__*/ function() {
    "use strict";
    function DiagnosisCategoryService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, DiagnosisCategoryService);
    }
    DiagnosisCategoryService.shouldShowPriceCategory = function shouldShowPriceCategory(type, categoryId) {
        if (!type || !categoryId) {
            return false;
        }
        switch(type){
            case ECategoryType.Treatment:
                switch(categoryId){
                    case SymptomId.PanicAnxiety:
                    case SymptomId.Depression:
                    case SymptomId.OtherMentalDisorders:
                    case ENonBenefitSymptomId.OrientalBeauty:
                    case ENonBenefitSymptomId.GongJinDan:
                    case ENonBenefitSymptomId.OtherOrientalTreatments:
                        return false;
                    default:
                        return true;
                }
            case ECategoryType.Department:
                switch(categoryId){
                    case EDepartmentId.Dermatology:
                    case EDepartmentId.Psychiatry:
                    case EDepartmentId.PlasticSurgery:
                    case EDepartmentId.OrientalMedicine:
                        return false;
                    default:
                        return true;
                }
            default:
                return true;
        }
    };
    DiagnosisCategoryService.isNonBenefitCategory = function isNonBenefitCategory(type, categoryId) {
        if (!type || !categoryId) {
            return false;
        }
        switch(type){
            case ECategoryType.Treatment:
                {
                    switch(categoryId){
                        case ENonBenefitSymptomId.Hairloss:
                        case ENonBenefitSymptomId.Acne:
                        case ENonBenefitSymptomId.Contraceptive:
                        case ENonBenefitSymptomId.Diet:
                        case ENonBenefitSymptomId.GongJinDan:
                        case ENonBenefitSymptomId.OrientalBeauty:
                        case ENonBenefitSymptomId.OtherOrientalTreatments:
                        case ENonBenefitSymptomId.Rosacea:
                            return true;
                        default:
                            return false;
                    }
                }
            case ECategoryType.Department:
                {
                    return false;
                }
            case ECategoryType.Vaccination:
                {
                    return false;
                }
        }
    };
    DiagnosisCategoryService.isDietCategory = function isDietCategory(categoryId) {
        if (!categoryId) {
            return false;
        }
        return categoryId === ENonBenefitSymptomId.Diet;
    };
    return DiagnosisCategoryService;
}();
DiagnosisCategoryService.getDiagnosisCategoryType = function(deprecatedType) {
    switch(deprecatedType){
        case EDeprecatedCategoryType.Subject:
            return ECategoryType.Department;
        case EDeprecatedCategoryType.Symptom:
            return ECategoryType.Treatment;
        case EDeprecatedCategoryType.Vaccination:
            return ECategoryType.Vaccination;
    }
};
DiagnosisCategoryService.getDeprecatedCategoryType = function(categoryType) {
    switch(categoryType){
        case ECategoryType.Department:
            return EDeprecatedCategoryType.Subject;
        case ECategoryType.Treatment:
            return EDeprecatedCategoryType.Symptom;
        case ECategoryType.Vaccination:
            return EDeprecatedCategoryType.Vaccination;
    }
};



/***/ }),

/***/ 61607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CERTIFICATION_CHANNEL_NAME; },
/* harmony export */   "i": function() { return /* binding */ CERTIFICATION_MESSAGE_TYPE; }
/* harmony export */ });
var CERTIFICATION_CHANNEL_NAME = "doctornow-certification";
var CERTIFICATION_MESSAGE_TYPE = {
    SUCCESS: "CERTIFICATION_SUCCESS",
    FAIL: "CERTIFICATION_FAIL"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,7506,3969,2564,2707,9653,7292,5679,5179,9922,7417,6409,7966,9939,6874,6758,5434,8798,9774,2888,179], function() { return __webpack_exec__(65450); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);